import { SUPER_ADMIN } from '../components/roles/roles';
import { emptorGradients } from '../utils/DataConstants';

const faker = require('faker');

/**
 * mocks needed:
 * [X] contact
 * [X] sourcing_event
 * [X] statement_of_work
 * [ ] pricing_schedule
 * [X] event_supplier_team
 * [X] event_buyer_team
 * [ ] score_card
 * [X] sourcing_event_supplier_assoc
 * [X] questionnaire
 * [X] uom
 * [X] currency
 * [ ] contact
 * [X] pricing schedule
 * [X] line_item
 * [ ] line_item_price
 * [ ] task
 * [ ] resource
 * [ ] rate_card
 * [ ] rate
 * [ ] milestone
 * [ ] milestone_payment
 */

export const demoLoginCredentials = {
	username: 'staff+demo@emptor.ai',
	password: 'staff1demo',
};

export const siteSurvey = {
	id: 1,
	title: 'My awesome survey',
	tasks: [
		{
			title: 'My awesome task list item',
			questionType: 'taskItem',
			allowFileAttachments: false,
		},
	],
	locationId: 1,
	location: { name: 'Foster City' },
};
export const siteSurveys = [siteSurvey];

export const walkthrough = {
	id: 1,
	title: 'My awesome walkthrough',
	description: '',
	locationId: 1,
	location: {},
	siteSurveyId: 1,
	siteSurvey: {},
	taskAnswers: [],
	notes: [],
	fileAttachments: [],
};

export const walkthroughs = [walkthrough];

export const vendors = [
	{
		id: 1,
		name: 'Lowes',
		primaryAddress: {
			streetAddress1: '111 Monterey Boulevard',
			city: 'San Francisco',
			postcode: '94131',
			region: 'California',
			country: 'United States',
		},
		primaryContactEmail: 'sales@lowes.com',
		website: 'lowes.com',
		primaryContact: {
			id: 0,
			email: 'sales@lowes.com',
			phone_work: '(476) 456-2257',
			phone_mobile: '1-981-002-7337 x693',
			jobTitle: 'National Division Engineer',
			companyId: 1,
			fax: '1-741-940-0589',
			nameSuffix: '',
			nameGiven: 'Austen',
			nameFamily: 'Lind',
			nameAdditional: '',
			photoLink: 'BLL6VMVgXrzSzc5NAYveYiWqIu1V9ZY9w07VBzTXi4x9pkRPxk/joemurphy.png',
			notes: '',
			createdAt: '2017-06-02T04:45:36.376Z',
			updatedAt: '2017-12-04T05:32:53.021Z',
			key: 0,
			name: 'Lind Austen',
		},
	},
	{
		id: 2,
		name: 'Supply House',
		primaryAddress: {
			streetAddress1: '111 Monterey Boulevard',
			city: 'San Francisco',
			postcode: '94131',
			region: 'California',
			country: 'United States',
		},
		primaryContactEmail: 'sales@lowes.com',
		website: 'lowes.com',
		primaryContact: {
			id: 0,
			email: 'sales@lowes.com',
			phone_work: '(476) 456-2257',
			phone_mobile: '1-981-002-7337 x693',
			jobTitle: 'National Division Engineer',
			companyId: 1,
			fax: '1-741-940-0589',
			nameSuffix: '',
			nameGiven: 'Austen',
			nameFamily: 'Lind',
			nameAdditional: '',
			photoLink: 'BLL6VMVgXrzSzc5NAYveYiWqIu1V9ZY9w07VBzTXi4x9pkRPxk/joemurphy.png',
			notes: '',
			createdAt: '2017-06-02T04:45:36.376Z',
			updatedAt: '2017-12-04T05:32:53.021Z',
			key: 0,
			name: 'Lind Austen',
		},
	},
	{
		id: 3,
		name: 'Ferguson',
		primaryAddress: {
			streetAddress1: '111 Monterey Boulevard',
			city: 'San Francisco',
			postcode: '94131',
			region: 'California',
			country: 'United States',
		},
		primaryContactEmail: 'sales@lowes.com',
		website: 'lowes.com',
		primaryContact: {
			id: 0,
			email: 'sales@lowes.com',
			phone_work: '(476) 456-2257',
			phone_mobile: '1-981-002-7337 x693',
			jobTitle: 'National Division Engineer',
			companyId: 1,
			fax: '1-741-940-0589',
			nameSuffix: '',
			nameGiven: 'Austen',
			nameFamily: 'Lind',
			nameAdditional: '',
			photoLink: 'BLL6VMVgXrzSzc5NAYveYiWqIu1V9ZY9w07VBzTXi4x9pkRPxk/joemurphy.png',
			notes: '',
			createdAt: '2017-06-02T04:45:36.376Z',
			updatedAt: '2017-12-04T05:32:53.021Z',
			key: 0,
			name: 'Lind Austen',
		},
	},
	{
		id: 4,
		name: 'Rigid',
		primaryAddress: {
			streetAddress1: '111 Monterey Boulevard',
			city: 'San Francisco',
			postcode: '94131',
			region: 'California',
			country: 'United States',
		},
		primaryContactEmail: 'sales@lowes.com',
		website: 'lowes.com',
		primaryContact: {
			id: 0,
			email: 'sales@lowes.com',
			phone_work: '(476) 456-2257',
			phone_mobile: '1-981-002-7337 x693',
			jobTitle: 'National Division Engineer',
			companyId: 1,
			fax: '1-741-940-0589',
			nameSuffix: '',
			nameGiven: 'Austen',
			nameFamily: 'Lind',
			nameAdditional: '',
			photoLink: 'BLL6VMVgXrzSzc5NAYveYiWqIu1V9ZY9w07VBzTXi4x9pkRPxk/joemurphy.png',
			notes: '',
			createdAt: '2017-06-02T04:45:36.376Z',
			updatedAt: '2017-12-04T05:32:53.021Z',
			key: 0,
			name: 'Lind Austen',
		},
	},
	{
		id: 5,
		name: 'American Jetter',
		primaryAddress: {
			streetAddress1: '111 Monterey Boulevard',
			city: 'San Francisco',
			postcode: '94131',
			region: 'California',
			country: 'United States',
		},
		primaryContactEmail: 'sales@lowes.com',
		website: 'lowes.com',
		primaryContact: {
			id: 0,
			email: 'sales@lowes.com',
			phone_work: '(476) 456-2257',
			phone_mobile: '1-981-002-7337 x693',
			jobTitle: 'National Division Engineer',
			companyId: 1,
			fax: '1-741-940-0589',
			nameSuffix: '',
			nameGiven: 'Austen',
			nameFamily: 'Lind',
			nameAdditional: '',
			photoLink: 'BLL6VMVgXrzSzc5NAYveYiWqIu1V9ZY9w07VBzTXi4x9pkRPxk/joemurphy.png',
			notes: '',
			createdAt: '2017-06-02T04:45:36.376Z',
			updatedAt: '2017-12-04T05:32:53.021Z',
			key: 0,
			name: 'Lind Austen',
		},
	},
];

export const purchaseRequests = [
	{
		id: 1,
		name: 'Parts for Work Order #1526',
		description: 'Parts for Plumbing job for Walmart',
		status: 'requested',
		createdAt: '2019-10-14T18:03:37.439Z',
		requestedBy: {
			userName: 'demo+sm@useopenwrench.com',
			userType: 'supplier',
			email: 'demo+sm@useopenwrench.com',
			phoneWork: '9795713661',
			phoneMobile: '9795713661',
			nameGiven: 'Joe',
			nameFamily: 'Murphy',
			photoLink: 'BLL6VMVgXrzSzc5NAYveYiWqIu1V9ZY9w07VBzTXi4x9pkRPxk/joemurphy.png',
			title: 'Technician',
			department: 'R&M',
		},
		equipmentsWithQuantity: [
			{
				equipmentId: 5,
				equipment: {
					id: 5,
					equipmentUUID: '001434da-3179-496d-b395-6a2fca5ebb5d',
					manufacturerId: 'AJ51T3040H600',
					manufacturerName: 'American Jetter',
					vendorId: 5,
					vendor: { id: 5, name: 'American Jetter' },
					serialNumber: '',
					name: 'Trailer Water Jetter',
					images: [
						'V5NP9iIH3Psd6HEO8tvFGWjCS8CtNe6yrgyc2MpsmezkgSNImE/American_Jetter_51_Series_Hot_Jetter_2040_RS_2017_E__41195.1543615451.jpg',
						'2DXACH5zcKSuChEKSrD3OpQw7jdyG12betoZVLGiGYFukM6nN4/american-jetter-51-series-hot-jetter-2040-ls-2017-e560__50298.1543615451.jpg',
						'WOCrTk3baearqSMbXkphDN03N0sITT5s6xQKmCQrI7k4hXwPSt/dual-portable-jetting-reels-on-trailer-tongue-2018-560__31985.1543615451.jpg',
					],
					description:
						'51T Series Trailer Jetter 3040 Hot Jetter Dual Reel 111 HP, 30 GPM, 4000 PSI, 600 Gallon',
					cost: 62,
					stockLocationId: 1,
					stockLocation: {
						id: 1,
						name: 'FT1',
						images: [
							'oZYGOZjWOAnIDgoLnELbNqRnpyzttkEqLWRlEhvWejcjdl3A8I/mercer-service-tech-truck-thumbnail.jpg',
						],
						description: 'Truck 1 serves Northeast including New York, New Jersey and Connecticut.',
						isMobile: true,
						supplierFacilityId: 137579,
						supplierFacility: {
							id: 137579,
							name: 'OpenWrench',
							displayName: 'OpenWrench',
							status: 'active',
							isClaimed: true,
							about: 'sdflkjasdflkj',
							isNationalSupplier: false,
							operatingHours: {},
							verifications: [],
							licenses: [],
							certifications: [],
							insurances: [
								{
									companyName: 'foo',
									companyContact: {
										name: 'sdfkljsdflkj',
										address: {
											streetAddress1: '1245 3rd Street',
											city: 'San Francisco',
											postcode: '94158',
											region: 'California',
											country: 'United States',
										},
										phone: '415-850-1772',
									},
									policyDocs: [
										{
											policyName: 'sdfsfd',
											amount: 123,
											expiration: '2019-10-14T18:03:37.439Z',
										},
									],
									isVerified: false,
								},
							],
							faqs: [],
							isWomenOwned: false,
							isMinorityOwned: false,
							isVeteranOwned: false,
							isDisabledOwned: false,
							isLgbtOwned: false,
							isSmallBusinessEnterprise: false,
							categoryIds: [9, 314, 5, 258, 6],
							categoryNames:
								'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
							logoURL:
								'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
							poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
							primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
							primaryAddress: {
								streetAddress1: '111 Monterey Boulevard',
								city: 'San Francisco',
								postcode: '94131',
								region: 'California',
								country: 'United States',
							},
							remitToAddress: {
								streetAddress1: '111 Monterey Boulevard',
								city: 'San Francisco',
								postcode: '94131',
								region: 'California',
								country: 'United States',
							},
							latitude: 37.73141098022461,
							longitude: -122.43785095214844,
							socialMedia: {},
							serviceAreaSelfPerforming: [],
							serviceAreaSelfPerformingParsedAddress: [],
							serviceAreaSelfPerformingCountries: [],
							serviceAreaSelfPerformingPostalCodes: [],
							serviceAreaNotSelfPerforming: [],
							serviceAreaNotSelfPerformingParsedAddress: [],
							serviceAreaNotSelfPerformingCountries: [],
							serviceAreaNotSelfPerformingPostalCodes: [],
							additionalDetails: {},
							supplierCompanyId: 276125,
						},
						supplierCompanyId: 276125,
						supplierCompany: {
							id: 276125,
							name: 'OpenWrench',
							displayName: 'OpenWrench',
							status: 'active',
							isClaimed: true,
							about: 'sdflkjasdflkj',
							operatingHours: {},
							verifications: [],
							licenses: [],
							certifications: [],
							insurances: [],
							faqs: [],
							isWomenOwned: false,
							isMinorityOwned: false,
							isVeteranOwned: false,
							isDisabledOwned: false,
							isLgbtOwned: false,
							isSmallBusinessEnterprise: false,
							categoryIds: [9, 314, 5, 258, 6],
							categoryNames:
								'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
							logoURL:
								'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
							poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
							primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
							primaryAddress: {
								streetAddress1: '111 Monterey Boulevard',
								city: 'San Francisco',
								postcode: '94131',
								region: 'California',
								country: 'United States',
							},
							remitToAddress: {
								streetAddress1: '111 Monterey Boulevard',
								city: 'San Francisco',
								postcode: '94131',
								region: 'California',
								country: 'United States',
							},
							latitude: 37.73141098022461,
							longitude: -122.43785095214844,
							socialMedia: {},
							serviceAreaSelfPerforming: [],
							serviceAreaSelfPerformingParsedAddress: [],
							serviceAreaSelfPerformingCountries: [],
							serviceAreaSelfPerformingPostalCodes: [],
							serviceAreaNotSelfPerforming: [],
							serviceAreaNotSelfPerformingParsedAddress: [],
							serviceAreaNotSelfPerformingCountries: [],
							serviceAreaNotSelfPerformingPostalCodes: [],
							additionalDetails: {},
						},
						createdAt: '2019-07-15T18:55:35.000Z',
						updatedAt: '2019-09-05T16:52:10.000Z',
						isDeleted: false,
					},
					isRental: false,
					supplierFacilityId: 137579,
					supplierCompanyId: 276125,
					createdAt: '2019-08-05T22:06:03.000Z',
					updatedAt: '2019-09-05T16:50:11.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				equipmentId: 6,
				equipment: {
					id: 6,
					equipmentUUID: 'b14c0176-1b6d-4b51-b7a1-9bd4ad07f307',
					manufacturerId: '13988',
					manufacturerName: 'Rigid',
					vendorId: 4,
					vendor: { id: 4, name: 'Rigid' },
					serialNumber: '',
					name: 'Pipe Inspection Camera Reel',
					images: ['A1Y3GzRBw9HYNyE6XZAtkvjhNtz2hnkNKGzNgF1FFOKIVvNUfv/1VUT5_AS01.jpeg'],
					description: 'Pipe Inspection Camera Reel, Color, 200 ft',
					cost: 8,
					stockLocationId: 1,
					stockLocation: {
						id: 1,
						name: 'FT1',
						images: [
							'oZYGOZjWOAnIDgoLnELbNqRnpyzttkEqLWRlEhvWejcjdl3A8I/mercer-service-tech-truck-thumbnail.jpg',
						],
						description: 'Truck 1 serves Northeast including New York, New Jersey and Connecticut.',
						isMobile: true,
						supplierFacilityId: 137579,
						supplierFacility: {
							id: 137579,
							name: 'OpenWrench',
							displayName: 'OpenWrench',
							status: 'active',
							isClaimed: true,
							about: 'sdflkjasdflkj',
							isNationalSupplier: false,
							operatingHours: {},
							verifications: [],
							licenses: [],
							certifications: [],
							insurances: [
								{
									companyName: 'foo',
									companyContact: {
										name: 'sdfkljsdflkj',
										address: {
											streetAddress1: '1245 3rd Street',
											city: 'San Francisco',
											postcode: '94158',
											region: 'California',
											country: 'United States',
										},
										phone: '415-850-1772',
									},
									policyDocs: [
										{
											policyName: 'sdfsfd',
											amount: 123,
											expiration: '2019-10-14T18:03:37.439Z',
										},
									],
									isVerified: false,
								},
							],
							faqs: [],
							isWomenOwned: false,
							isMinorityOwned: false,
							isVeteranOwned: false,
							isDisabledOwned: false,
							isLgbtOwned: false,
							isSmallBusinessEnterprise: false,
							categoryIds: [9, 314, 5, 258, 6],
							categoryNames:
								'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
							logoURL:
								'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
							poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
							primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
							primaryAddress: {
								streetAddress1: '111 Monterey Boulevard',
								city: 'San Francisco',
								postcode: '94131',
								region: 'California',
								country: 'United States',
							},
							remitToAddress: {
								streetAddress1: '111 Monterey Boulevard',
								city: 'San Francisco',
								postcode: '94131',
								region: 'California',
								country: 'United States',
							},
							latitude: 37.73141098022461,
							longitude: -122.43785095214844,
							socialMedia: {},
							serviceAreaSelfPerforming: [],
							serviceAreaSelfPerformingParsedAddress: [],
							serviceAreaSelfPerformingCountries: [],
							serviceAreaSelfPerformingPostalCodes: [],
							serviceAreaNotSelfPerforming: [],
							serviceAreaNotSelfPerformingParsedAddress: [],
							serviceAreaNotSelfPerformingCountries: [],
							serviceAreaNotSelfPerformingPostalCodes: [],
							additionalDetails: {},
							supplierCompanyId: 276125,
						},
						supplierCompanyId: 276125,
						supplierCompany: {
							id: 276125,
							name: 'OpenWrench',
							displayName: 'OpenWrench',
							status: 'active',
							isClaimed: true,
							about: 'sdflkjasdflkj',
							operatingHours: {},
							verifications: [],
							licenses: [],
							certifications: [],
							insurances: [],
							faqs: [],
							isWomenOwned: false,
							isMinorityOwned: false,
							isVeteranOwned: false,
							isDisabledOwned: false,
							isLgbtOwned: false,
							isSmallBusinessEnterprise: false,
							categoryIds: [9, 314, 5, 258, 6],
							categoryNames:
								'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
							logoURL:
								'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
							poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
							primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
							primaryAddress: {
								streetAddress1: '111 Monterey Boulevard',
								city: 'San Francisco',
								postcode: '94131',
								region: 'California',
								country: 'United States',
							},
							remitToAddress: {
								streetAddress1: '111 Monterey Boulevard',
								city: 'San Francisco',
								postcode: '94131',
								region: 'California',
								country: 'United States',
							},
							latitude: 37.73141098022461,
							longitude: -122.43785095214844,
							socialMedia: {},
							serviceAreaSelfPerforming: [],
							serviceAreaSelfPerformingParsedAddress: [],
							serviceAreaSelfPerformingCountries: [],
							serviceAreaSelfPerformingPostalCodes: [],
							serviceAreaNotSelfPerforming: [],
							serviceAreaNotSelfPerformingParsedAddress: [],
							serviceAreaNotSelfPerformingCountries: [],
							serviceAreaNotSelfPerformingPostalCodes: [],
							additionalDetails: {},
						},
						createdAt: '2019-07-15T18:55:35.000Z',
						updatedAt: '2019-09-05T16:52:10.000Z',
						isDeleted: false,
					},
					isRental: false,
					supplierFacilityId: 137579,
					supplierCompanyId: 276125,
					createdAt: '2019-08-05T22:06:10.000Z',
					updatedAt: '2019-09-05T16:50:11.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
		],
		partsWithQuantity: [
			{
				id: 1,
				partId: 37,
				part: {
					id: 37,
					partUUID: 'b137ca82-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Lowes',
					vendorId: 1,
					vendor: { id: 1, name: 'Lowes' },
					serialNumber: 'V77712',
					name: 'ProPress® 1/2 in. Press Cap',
					images: [
						'rKqFU3o2c4fHNm8UmFUakOb27iFjoHpqQsZdOnea1mlVwVGmdy/copper-fittings-cpc617-64_1000.jpg',
					],
					description:
						'ProPress® 1/2 in. Press Cap. https://www.homedepot.com/p/1-2-in-Copper-Press-Pressure-Tube-Cap-CPC617/203460444',
					cost: 3.39,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-08-05T21:13:55.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				id: 2,
				partId: 38,
				part: {
					id: 38,
					partUUID: 'b137cbf7-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Lowes',
					vendorId: 1,
					vendor: { id: 1, name: 'Lowes' },
					serialNumber: 'V77717',
					name: 'ProPress® 3/4 in. Press Cap',
					images: [
						'nxmrpVUlxfWh38K7gJuNgX3JDOQ5xdUDBb9rsnuNTAiJy16GFb/nibco-presssystem-copper-fittings-cpc600dshd34-64_1000.jpg',
					],
					description:
						'ProPress® 3/4 in. Press Cap. https://www.homedepot.com/p/NIBCO-PressSystem-3-4-in-Copper-Press-x-Press-Pressure-Coupling-with-Dimple-Stop-CPC600DSHD34/203460405',
					cost: 2.34,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:42:01.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				id: 3,
				partId: 39,
				part: {
					id: 39,
					partUUID: 'b137cd79-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Ferguson',
					vendorId: 3,
					vendor: { id: 3, name: 'Ferguson' },
					serialNumber: 'V77722',
					name: 'ProPress® 1 in. Press Cap',
					images: [
						'ccwgzNesdHFxSCHQ2JpFMc2tkFOh2uX7oHfaMoi2zQ8Mk7PELy/Screen Shot 2019-06-12 at 9.43.10 AM.png',
					],
					description:
						'ProPress® 1 in. Press Cap. https://www.ferguson.com/product/propress-1-in-press-cap-v77722/_/R-1349177',
					cost: 9.2,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:43:27.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				id: 4,
				partId: 40,
				part: {
					id: 40,
					partUUID: 'b137ceea-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Supply House',
					vendorId: 2,
					vendor: { id: 2, name: 'Supply House' },
					serialNumber: 'V77727',
					name: 'ProPress® 1-1/4 in. Press Cap',
					images: ['zne8eiGR28v6F9KKQM9w1iU5T4r5tQWvj7DXNj24OAVOrij2Hf/50052-3.jpg'],
					description:
						'ProPress® 1-1/4 in. Press Cap. https://www.supplyhouse.com/JW-50052-1-1-4-Press-Copper-Cap',
					cost: 9.95,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:44:04.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				id: 5,
				partId: 41,
				part: {
					id: 41,
					partUUID: 'b137d2ba-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Lowes',
					vendorId: 1,
					vendor: { id: 1, name: 'Lowes' },
					serialNumber: '',
					name: 'Cop 90 1/2"',
					images: [
						'hPDKsjVVZ24GdbcnIdtmWIyRHUb9Cu5BvXzb4OMNXSD23pUci1/nibco-copper-fittings-cpc607hd12-64_1000.jpg',
					],
					description:
						'Cop 90 1/2". https://www.homedepot.com/p/NIBCO-1-2-in-Copper-90-Degree-Press-x-Press-Pressure-Elbow-CPC607HD12/204583145',
					cost: 1.69,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:44:32.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				id: 6,
				partId: 42,
				part: {
					id: 42,
					partUUID: 'b137d435-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Lowes',
					vendorId: 1,
					vendor: { id: 1, name: 'Lowes' },
					serialNumber: '',
					name: 'Cop 90 3/4"',
					images: [
						'Vvenwl8m1AB5h2jpOj13b2BbstIf79eZYvD5DcLMmNTUJ7dr8S/nibco-copper-fittings-cpc607hd34-64_1000.jpg',
					],
					description:
						'Cop 90 3/4". https://www.homedepot.com/p/NIBCO-3-4-in-Copper-90-Degree-Press-x-Press-Pressure-Elbow-CPC607HD34/203460430',
					cost: 2.99,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:45:00.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				id: 7,
				partId: 43,
				part: {
					id: 43,
					partUUID: 'b137d59d-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Lowes',
					vendorId: 1,
					vendor: { id: 1, name: 'Lowes' },
					serialNumber: '',
					name: 'cop 90 1"',
					images: [
						'bM6UuvBfMmH9T9yXrnisJ8BWAzn7ahtSpT7lROowM1d6SPEZZD/copper-fittings-cpc607-64_1000.jpg',
					],
					description:
						'cop 90 1". https://www.homedepot.com/p/1-in-Copper-90-Degree-Press-x-Press-Pressure-Elbow-CPC607/203460431',
					cost: 5.98,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:45:29.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				id: 8,
				partId: 44,
				part: {
					id: 44,
					partUUID: 'b137d6fa-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Ferguson',
					vendorId: 3,
					vendor: { id: 3, name: 'Ferguson' },
					serialNumber: 'V77332',
					name: 'cop 90 1.25"',
					images: [
						'efdMsvs3wTsWsoOKKehuSpiVPrKjwJNCKdyBNq1k3GMhPSMR7F/Screen Shot 2019-06-12 at 9.45.54 AM.png',
					],
					description:
						'cop 90 1.25". https://www.ferguson.com/product/propress-1-14-in-press-90-degree-elbow-v77332/_/R-1349303',
					cost: 11.93,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:46:11.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				id: 9,
				partId: 45,
				part: {
					id: 45,
					partUUID: 'b137d860-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Lowes',
					vendorId: 1,
					vendor: { id: 1, name: 'Lowes' },
					serialNumber: '',
					name: 'Pipe 2-in x 2-in dia 90-Degree PVC Schedule 40 Hub Elbow Long Sweep Fitting',
					images: ['2SaGRZwX2EO71XGCLXfyRSEax2gAEp6QRkAL5Zr7zyZdknx17I/611942033782.jpg'],
					description:
						'Pipe 2-in x 2-in dia 90-Degree PVC Schedule 40 Hub Elbow Long Sweep Fitting. https://www.lowes.com/search?searchTerm=90-degree+pvc+schedule+40+hub+elbow+long+sweep+fitting',
					cost: 3.08,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:46:48.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				id: 10,
				partId: 46,
				part: {
					id: 46,
					partUUID: 'b137d9c2-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Supply House',
					vendorId: 2,
					vendor: { id: 2, name: 'Supply House' },
					serialNumber: 'MPF10145',
					name: '1/2 in. Press Copper Coupling',
					images: ['miZJ29voUD22pGT8lNsYGbw3hKiTfzHiAohdiOxd4Z2XIUFHzW/nibco-4801112.jpg'],
					description:
						'1/2 in. Press Copper Coupling. https://www.supply.com/1-1-2-in-h-x-h-pvc-dwv-coupling-4801-domestic/p487392',
					cost: 0.41,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:47:21.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
		],
		stockLocationId: 11,
		stockLocation: {
			id: 11,
			name: 'My warehouse',
			images: [],
			address: {
				streetAddress1: '111 Monterey Boulevard',
				city: 'San Francisco',
				postcode: '94131',
			},
			createdAt: '2019-10-17T20:41:31.000Z',
			description: 'An awesome warehouse where cool things happen',
			isDeleted: false,
			isMobile: false,
			supplierCompany: {
				id: 276125,
				name: 'OpenWrench',
				displayName: 'OpenWrench',
				status: 'active',
				isClaimed: true,
			},
			supplierCompanyId: 276125,
			supplierFacility: {
				id: 137579,
				name: 'OpenWrench',
				displayName: 'OpenWrench',
				status: 'active',
				isClaimed: true,
			},
			supplierFacilityId: 137579,
			updatedAt: '2019-10-17T20:41:31.000Z',
		},
		totalCost: 100,
	},
	{
		id: 2,
		name: 'Parts for Work Order #1526',
		description: 'Parts for Plumbing job for Walmart',
		status: 'approved',
		createdAt: '2019-10-14T18:03:37.439Z',
		requestedBy: {
			userName: 'demo+sm@useopenwrench.com',
			userType: 'supplier',
			email: 'demo+sm@useopenwrench.com',
			phoneWork: '9795713661',
			phoneMobile: '9795713661',
			nameGiven: 'Joe',
			nameFamily: 'Murphy',
			photoLink: 'BLL6VMVgXrzSzc5NAYveYiWqIu1V9ZY9w07VBzTXi4x9pkRPxk/joemurphy.png',
			title: 'Technician',
			department: 'R&M',
		},
		equipmentsWithQuantity: [
			{
				equipmentId: 5,
				equipment: {
					id: 5,
					equipmentUUID: '001434da-3179-496d-b395-6a2fca5ebb5d',
					manufacturerId: 'AJ51T3040H600',
					manufacturerName: 'American Jetter',
					vendorId: 5,
					vendor: { id: 5, name: 'American Jetter' },
					serialNumber: '',
					name: 'Trailer Water Jetter',
					images: [
						'V5NP9iIH3Psd6HEO8tvFGWjCS8CtNe6yrgyc2MpsmezkgSNImE/American_Jetter_51_Series_Hot_Jetter_2040_RS_2017_E__41195.1543615451.jpg',
						'2DXACH5zcKSuChEKSrD3OpQw7jdyG12betoZVLGiGYFukM6nN4/american-jetter-51-series-hot-jetter-2040-ls-2017-e560__50298.1543615451.jpg',
						'WOCrTk3baearqSMbXkphDN03N0sITT5s6xQKmCQrI7k4hXwPSt/dual-portable-jetting-reels-on-trailer-tongue-2018-560__31985.1543615451.jpg',
					],
					description:
						'51T Series Trailer Jetter 3040 Hot Jetter Dual Reel 111 HP, 30 GPM, 4000 PSI, 600 Gallon',
					cost: 62,
					stockLocationId: 1,
					stockLocation: {
						id: 1,
						name: 'FT1',
						images: [
							'oZYGOZjWOAnIDgoLnELbNqRnpyzttkEqLWRlEhvWejcjdl3A8I/mercer-service-tech-truck-thumbnail.jpg',
						],
						description: 'Truck 1 serves Northeast including New York, New Jersey and Connecticut.',
						isMobile: true,
						supplierFacilityId: 137579,
						supplierFacility: {
							id: 137579,
							name: 'OpenWrench',
							displayName: 'OpenWrench',
							status: 'active',
							isClaimed: true,
							about: 'sdflkjasdflkj',
							isNationalSupplier: false,
							operatingHours: {},
							verifications: [],
							licenses: [],
							certifications: [],
							insurances: [
								{
									companyName: 'foo',
									companyContact: {
										name: 'sdfkljsdflkj',
										address: {
											streetAddress1: '1245 3rd Street',
											city: 'San Francisco',
											postcode: '94158',
											region: 'California',
											country: 'United States',
										},
										phone: '415-850-1772',
									},
									policyDocs: [
										{
											policyName: 'sdfsfd',
											amount: 123,
											expiration: '2019-10-14T18:03:37.439Z',
										},
									],
									isVerified: false,
								},
							],
							faqs: [],
							isWomenOwned: false,
							isMinorityOwned: false,
							isVeteranOwned: false,
							isDisabledOwned: false,
							isLgbtOwned: false,
							isSmallBusinessEnterprise: false,
							categoryIds: [9, 314, 5, 258, 6],
							categoryNames:
								'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
							logoURL:
								'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
							poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
							primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
							primaryAddress: {
								streetAddress1: '111 Monterey Boulevard',
								city: 'San Francisco',
								postcode: '94131',
								region: 'California',
								country: 'United States',
							},
							remitToAddress: {
								streetAddress1: '111 Monterey Boulevard',
								city: 'San Francisco',
								postcode: '94131',
								region: 'California',
								country: 'United States',
							},
							latitude: 37.73141098022461,
							longitude: -122.43785095214844,
							socialMedia: {},
							serviceAreaSelfPerforming: [],
							serviceAreaSelfPerformingParsedAddress: [],
							serviceAreaSelfPerformingCountries: [],
							serviceAreaSelfPerformingPostalCodes: [],
							serviceAreaNotSelfPerforming: [],
							serviceAreaNotSelfPerformingParsedAddress: [],
							serviceAreaNotSelfPerformingCountries: [],
							serviceAreaNotSelfPerformingPostalCodes: [],
							additionalDetails: {},
							supplierCompanyId: 276125,
						},
						supplierCompanyId: 276125,
						supplierCompany: {
							id: 276125,
							name: 'OpenWrench',
							displayName: 'OpenWrench',
							status: 'active',
							isClaimed: true,
							about: 'sdflkjasdflkj',
							operatingHours: {},
							verifications: [],
							licenses: [],
							certifications: [],
							insurances: [],
							faqs: [],
							isWomenOwned: false,
							isMinorityOwned: false,
							isVeteranOwned: false,
							isDisabledOwned: false,
							isLgbtOwned: false,
							isSmallBusinessEnterprise: false,
							categoryIds: [9, 314, 5, 258, 6],
							categoryNames:
								'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
							logoURL:
								'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
							poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
							primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
							primaryAddress: {
								streetAddress1: '111 Monterey Boulevard',
								city: 'San Francisco',
								postcode: '94131',
								region: 'California',
								country: 'United States',
							},
							remitToAddress: {
								streetAddress1: '111 Monterey Boulevard',
								city: 'San Francisco',
								postcode: '94131',
								region: 'California',
								country: 'United States',
							},
							latitude: 37.73141098022461,
							longitude: -122.43785095214844,
							socialMedia: {},
							serviceAreaSelfPerforming: [],
							serviceAreaSelfPerformingParsedAddress: [],
							serviceAreaSelfPerformingCountries: [],
							serviceAreaSelfPerformingPostalCodes: [],
							serviceAreaNotSelfPerforming: [],
							serviceAreaNotSelfPerformingParsedAddress: [],
							serviceAreaNotSelfPerformingCountries: [],
							serviceAreaNotSelfPerformingPostalCodes: [],
							additionalDetails: {},
						},
						createdAt: '2019-07-15T18:55:35.000Z',
						updatedAt: '2019-09-05T16:52:10.000Z',
						isDeleted: false,
					},
					isRental: false,
					supplierFacilityId: 137579,
					supplierCompanyId: 276125,
					createdAt: '2019-08-05T22:06:03.000Z',
					updatedAt: '2019-09-05T16:50:11.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				equipmentId: 6,
				equipment: {
					id: 6,
					equipmentUUID: 'b14c0176-1b6d-4b51-b7a1-9bd4ad07f307',
					manufacturerId: '13988',
					manufacturerName: 'Rigid',
					vendorId: 4,
					vendor: { id: 4, name: 'Rigid' },
					serialNumber: '',
					name: 'Pipe Inspection Camera Reel',
					images: ['A1Y3GzRBw9HYNyE6XZAtkvjhNtz2hnkNKGzNgF1FFOKIVvNUfv/1VUT5_AS01.jpeg'],
					description: 'Pipe Inspection Camera Reel, Color, 200 ft',
					cost: 8,
					stockLocationId: 1,
					stockLocation: {
						id: 1,
						name: 'FT1',
						images: [
							'oZYGOZjWOAnIDgoLnELbNqRnpyzttkEqLWRlEhvWejcjdl3A8I/mercer-service-tech-truck-thumbnail.jpg',
						],
						description: 'Truck 1 serves Northeast including New York, New Jersey and Connecticut.',
						isMobile: true,
						supplierFacilityId: 137579,
						supplierFacility: {
							id: 137579,
							name: 'OpenWrench',
							displayName: 'OpenWrench',
							status: 'active',
							isClaimed: true,
							about: 'sdflkjasdflkj',
							isNationalSupplier: false,
							operatingHours: {},
							verifications: [],
							licenses: [],
							certifications: [],
							insurances: [
								{
									companyName: 'foo',
									companyContact: {
										name: 'sdfkljsdflkj',
										address: {
											streetAddress1: '1245 3rd Street',
											city: 'San Francisco',
											postcode: '94158',
											region: 'California',
											country: 'United States',
										},
										phone: '415-850-1772',
									},
									policyDocs: [
										{
											policyName: 'sdfsfd',
											amount: 123,
											expiration: '2019-10-14T18:03:37.439Z',
										},
									],
									isVerified: false,
								},
							],
							faqs: [],
							isWomenOwned: false,
							isMinorityOwned: false,
							isVeteranOwned: false,
							isDisabledOwned: false,
							isLgbtOwned: false,
							isSmallBusinessEnterprise: false,
							categoryIds: [9, 314, 5, 258, 6],
							categoryNames:
								'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
							logoURL:
								'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
							poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
							primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
							primaryAddress: {
								streetAddress1: '111 Monterey Boulevard',
								city: 'San Francisco',
								postcode: '94131',
								region: 'California',
								country: 'United States',
							},
							remitToAddress: {
								streetAddress1: '111 Monterey Boulevard',
								city: 'San Francisco',
								postcode: '94131',
								region: 'California',
								country: 'United States',
							},
							latitude: 37.73141098022461,
							longitude: -122.43785095214844,
							socialMedia: {},
							serviceAreaSelfPerforming: [],
							serviceAreaSelfPerformingParsedAddress: [],
							serviceAreaSelfPerformingCountries: [],
							serviceAreaSelfPerformingPostalCodes: [],
							serviceAreaNotSelfPerforming: [],
							serviceAreaNotSelfPerformingParsedAddress: [],
							serviceAreaNotSelfPerformingCountries: [],
							serviceAreaNotSelfPerformingPostalCodes: [],
							additionalDetails: {},
							supplierCompanyId: 276125,
						},
						supplierCompanyId: 276125,
						supplierCompany: {
							id: 276125,
							name: 'OpenWrench',
							displayName: 'OpenWrench',
							status: 'active',
							isClaimed: true,
							about: 'sdflkjasdflkj',
							operatingHours: {},
							verifications: [],
							licenses: [],
							certifications: [],
							insurances: [],
							faqs: [],
							isWomenOwned: false,
							isMinorityOwned: false,
							isVeteranOwned: false,
							isDisabledOwned: false,
							isLgbtOwned: false,
							isSmallBusinessEnterprise: false,
							categoryIds: [9, 314, 5, 258, 6],
							categoryNames:
								'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
							logoURL:
								'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
							poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
							primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
							primaryAddress: {
								streetAddress1: '111 Monterey Boulevard',
								city: 'San Francisco',
								postcode: '94131',
								region: 'California',
								country: 'United States',
							},
							remitToAddress: {
								streetAddress1: '111 Monterey Boulevard',
								city: 'San Francisco',
								postcode: '94131',
								region: 'California',
								country: 'United States',
							},
							latitude: 37.73141098022461,
							longitude: -122.43785095214844,
							socialMedia: {},
							serviceAreaSelfPerforming: [],
							serviceAreaSelfPerformingParsedAddress: [],
							serviceAreaSelfPerformingCountries: [],
							serviceAreaSelfPerformingPostalCodes: [],
							serviceAreaNotSelfPerforming: [],
							serviceAreaNotSelfPerformingParsedAddress: [],
							serviceAreaNotSelfPerformingCountries: [],
							serviceAreaNotSelfPerformingPostalCodes: [],
							additionalDetails: {},
						},
						createdAt: '2019-07-15T18:55:35.000Z',
						updatedAt: '2019-09-05T16:52:10.000Z',
						isDeleted: false,
					},
					isRental: false,
					supplierFacilityId: 137579,
					supplierCompanyId: 276125,
					createdAt: '2019-08-05T22:06:10.000Z',
					updatedAt: '2019-09-05T16:50:11.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
		],
		partsWithQuantity: [
			{
				id: 12,
				partId: 37,
				part: {
					id: 37,
					partUUID: 'b137ca82-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Lowes',
					vendorId: 1,
					vendor: { id: 1, name: 'Lowes' },
					serialNumber: 'V77712',
					name: 'ProPress® 1/2 in. Press Cap',
					images: [
						'rKqFU3o2c4fHNm8UmFUakOb27iFjoHpqQsZdOnea1mlVwVGmdy/copper-fittings-cpc617-64_1000.jpg',
					],
					description:
						'ProPress® 1/2 in. Press Cap. https://www.homedepot.com/p/1-2-in-Copper-Press-Pressure-Tube-Cap-CPC617/203460444',
					cost: 3.39,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-08-05T21:13:55.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				id: 13,
				partId: 38,
				part: {
					id: 38,
					partUUID: 'b137cbf7-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Lowes',
					vendorId: 1,
					vendor: { id: 1, name: 'Lowes' },
					serialNumber: 'V77717',
					name: 'ProPress® 3/4 in. Press Cap',
					images: [
						'nxmrpVUlxfWh38K7gJuNgX3JDOQ5xdUDBb9rsnuNTAiJy16GFb/nibco-presssystem-copper-fittings-cpc600dshd34-64_1000.jpg',
					],
					description:
						'ProPress® 3/4 in. Press Cap. https://www.homedepot.com/p/NIBCO-PressSystem-3-4-in-Copper-Press-x-Press-Pressure-Coupling-with-Dimple-Stop-CPC600DSHD34/203460405',
					cost: 2.34,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:42:01.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				id: 14,
				partId: 39,
				part: {
					id: 39,
					partUUID: 'b137cd79-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Ferguson',
					vendorId: 3,
					vendor: { id: 3, name: 'Ferguson' },
					serialNumber: 'V77722',
					name: 'ProPress® 1 in. Press Cap',
					images: [
						'ccwgzNesdHFxSCHQ2JpFMc2tkFOh2uX7oHfaMoi2zQ8Mk7PELy/Screen Shot 2019-06-12 at 9.43.10 AM.png',
					],
					description:
						'ProPress® 1 in. Press Cap. https://www.ferguson.com/product/propress-1-in-press-cap-v77722/_/R-1349177',
					cost: 9.2,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:43:27.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				id: 15,
				partId: 40,
				part: {
					id: 40,
					partUUID: 'b137ceea-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Supply House',
					vendorId: 2,
					vendor: { id: 2, name: 'Supply House' },
					serialNumber: 'V77727',
					name: 'ProPress® 1-1/4 in. Press Cap',
					images: ['zne8eiGR28v6F9KKQM9w1iU5T4r5tQWvj7DXNj24OAVOrij2Hf/50052-3.jpg'],
					description:
						'ProPress® 1-1/4 in. Press Cap. https://www.supplyhouse.com/JW-50052-1-1-4-Press-Copper-Cap',
					cost: 9.95,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:44:04.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				id: 16,
				partId: 41,
				part: {
					id: 41,
					partUUID: 'b137d2ba-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Lowes',
					vendorId: 1,
					vendor: { id: 1, name: 'Lowes' },
					serialNumber: '',
					name: 'Cop 90 1/2"',
					images: [
						'hPDKsjVVZ24GdbcnIdtmWIyRHUb9Cu5BvXzb4OMNXSD23pUci1/nibco-copper-fittings-cpc607hd12-64_1000.jpg',
					],
					description:
						'Cop 90 1/2". https://www.homedepot.com/p/NIBCO-1-2-in-Copper-90-Degree-Press-x-Press-Pressure-Elbow-CPC607HD12/204583145',
					cost: 1.69,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:44:32.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				id: 17,
				partId: 42,
				part: {
					id: 42,
					partUUID: 'b137d435-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Lowes',
					vendorId: 1,
					vendor: { id: 1, name: 'Lowes' },
					serialNumber: '',
					name: 'Cop 90 3/4"',
					images: [
						'Vvenwl8m1AB5h2jpOj13b2BbstIf79eZYvD5DcLMmNTUJ7dr8S/nibco-copper-fittings-cpc607hd34-64_1000.jpg',
					],
					description:
						'Cop 90 3/4". https://www.homedepot.com/p/NIBCO-3-4-in-Copper-90-Degree-Press-x-Press-Pressure-Elbow-CPC607HD34/203460430',
					cost: 2.99,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:45:00.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				id: 18,
				partId: 43,
				part: {
					id: 43,
					partUUID: 'b137d59d-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Lowes',
					vendorId: 1,
					vendor: { id: 1, name: 'Lowes' },
					serialNumber: '',
					name: 'cop 90 1"',
					images: [
						'bM6UuvBfMmH9T9yXrnisJ8BWAzn7ahtSpT7lROowM1d6SPEZZD/copper-fittings-cpc607-64_1000.jpg',
					],
					description:
						'cop 90 1". https://www.homedepot.com/p/1-in-Copper-90-Degree-Press-x-Press-Pressure-Elbow-CPC607/203460431',
					cost: 5.98,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:45:29.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				id: 19,
				partId: 44,
				part: {
					id: 44,
					partUUID: 'b137d6fa-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Ferguson',
					vendorId: 3,
					vendor: { id: 3, name: 'Ferguson' },
					serialNumber: 'V77332',
					name: 'cop 90 1.25"',
					images: [
						'efdMsvs3wTsWsoOKKehuSpiVPrKjwJNCKdyBNq1k3GMhPSMR7F/Screen Shot 2019-06-12 at 9.45.54 AM.png',
					],
					description:
						'cop 90 1.25". https://www.ferguson.com/product/propress-1-14-in-press-90-degree-elbow-v77332/_/R-1349303',
					cost: 11.93,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:46:11.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				id: 20,
				partId: 45,
				part: {
					id: 45,
					partUUID: 'b137d860-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Lowes',
					vendorId: 1,
					vendor: { id: 1, name: 'Lowes' },
					serialNumber: '',
					name: 'Pipe 2-in x 2-in dia 90-Degree PVC Schedule 40 Hub Elbow Long Sweep Fitting',
					images: ['2SaGRZwX2EO71XGCLXfyRSEax2gAEp6QRkAL5Zr7zyZdknx17I/611942033782.jpg'],
					description:
						'Pipe 2-in x 2-in dia 90-Degree PVC Schedule 40 Hub Elbow Long Sweep Fitting. https://www.lowes.com/search?searchTerm=90-degree+pvc+schedule+40+hub+elbow+long+sweep+fitting',
					cost: 3.08,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:46:48.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				id: 21,
				partId: 46,
				part: {
					id: 46,
					partUUID: 'b137d9c2-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Supply House',
					vendorId: 2,
					vendor: { id: 2, name: 'Supply House' },
					serialNumber: 'MPF10145',
					name: '1/2 in. Press Copper Coupling',
					images: ['miZJ29voUD22pGT8lNsYGbw3hKiTfzHiAohdiOxd4Z2XIUFHzW/nibco-4801112.jpg'],
					description:
						'1/2 in. Press Copper Coupling. https://www.supply.com/1-1-2-in-h-x-h-pvc-dwv-coupling-4801-domestic/p487392',
					cost: 0.41,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:47:21.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
		],
		stockLocationId: 11,
		stockLocation: {
			id: 11,
			name: 'My warehouse',
			images: [],
			address: {
				streetAddress1: '111 Monterey Boulevard',
				city: 'San Francisco',
				postcode: '94131',
			},
			createdAt: '2019-10-17T20:41:31.000Z',
			description: 'An awesome warehouse where cool things happen',
			isDeleted: false,
			isMobile: false,
			supplierCompany: {
				id: 276125,
				name: 'OpenWrench',
				displayName: 'OpenWrench',
				status: 'active',
				isClaimed: true,
			},
			supplierCompanyId: 276125,
			supplierFacility: {
				id: 137579,
				name: 'OpenWrench',
				displayName: 'OpenWrench',
				status: 'active',
				isClaimed: true,
			},
			supplierFacilityId: 137579,
			updatedAt: '2019-10-17T20:41:31.000Z',
		},
		totalCost: 100,
	},
];

export const categoriesAnalyticsData = [
	{ category: 'Instrument Sharpening', spend: 7.0, percentageOfTotal: 0.22 },
	{ category: 'Transcription', spend: 6.9, percentageOfTotal: 0.22 },
	{ category: 'Medical Gas', spend: 9.5, percentageOfTotal: 0.22 },
	{ category: 'Linens', spend: 14.5, percentageOfTotal: 0.22 },
	{ category: 'Dialysis Services', spend: 18.2, percentageOfTotal: 0.22 },
	{ category: 'Locum Tenens', spend: 26.3, percentageOfTotal: 0.22 },
	{ category: 'IT Security', spend: 18.3, percentageOfTotal: 0.22 },
	{ category: 'Elevator Maintenance', spend: 13.9, percentageOfTotal: 0.22 },
];

export const vendorsAnalyticsData = [
	{ vendor: 'Cintas', spend: 7.0, percentageOfTotal: 0.22 },
	{ vendor: 'Airgas', spend: 6.9, percentageOfTotal: 0.22 },
	{ vendor: 'Aramark', spend: 9.5, percentageOfTotal: 0.22 },
	{ vendor: 'Davita', spend: 14.5, percentageOfTotal: 0.22 },
	{ vendor: 'Weatherby Healthcare', spend: 18.2, percentageOfTotal: 0.22 },
	{ vendor: 'Mobile Instrument', spend: 26.3, percentageOfTotal: 0.22 },
	{ vendor: 'Synoptek', spend: 18.3, percentageOfTotal: 0.22 },
	{ vendor: 'KONE', spend: 13.9, percentageOfTotal: 0.22 },
];

export const facilitiesAnalyticsData = [
	{ facility: 'Hospital 1', spend: 7.0, percentageOfTotal: 0.22 },
	{ facility: 'Hospital 2', spend: 6.9, percentageOfTotal: 0.22 },
	{ facility: 'Hospital 3', spend: 9.5, percentageOfTotal: 0.22 },
	{ facility: 'Hospital 4', spend: 14.5, percentageOfTotal: 0.22 },
];

export const opportunityChartData = {
	1: [
		{ month: 'Jan', rate: 123 },
		{ month: 'Feb', rate: 125 },
		{ month: 'Mar', rate: 127 },
		{ month: 'Apr', rate: 124 },
		{ month: 'May', rate: 130 },
		{ month: 'Jun', rate: 132 },
		{ month: 'Jul', rate: 133 },
		{ month: 'Aug', rate: 128 },
		{ month: 'Sep', rate: 134 },
		{ month: 'Oct', rate: 150 },
		{ month: 'Nov', rate: 145 },
		{ month: 'Dec', rate: 148 },
	],
	2: [
		{ month: 'Jan', offContractSpend: 23, onContractSpend: 125 },
		{ month: 'Feb', offContractSpend: 30, onContractSpend: 120 },
		{ month: 'Mar', offContractSpend: 44, onContractSpend: 120 },
		{ month: 'Apr', offContractSpend: 55, onContractSpend: 120 },
		{ month: 'May', offContractSpend: 29, onContractSpend: 120 },
		{ month: 'Jun', offContractSpend: 50, onContractSpend: 120 },
		{ month: 'Jul', offContractSpend: 55, onContractSpend: 120 },
		{ month: 'Aug', offContractSpend: 50, onContractSpend: 120 },
		{ month: 'Sep', offContractSpend: 64, onContractSpend: 120 },
		{ month: 'Oct', offContractSpend: 135, onContractSpend: 120 },
		{ month: 'Nov', offContractSpend: 105, onContractSpend: 120 },
		{ month: 'Dec', offContractSpend: 134, onContractSpend: 120 },
	],
	3: [
		{ week: 'Jan 1', spend: 1023 },
		{ week: 'Jan 8', spend: 1125 },
		{ week: 'Jan 15', spend: 1227 },
		{ week: 'Jan 22', spend: 1024 },
		{ week: 'Jan 29', spend: 1130 },
		{ week: 'Feb 5', spend: 1332 },
		{ week: 'Feb 12', spend: 1233 },
		{ week: 'Feb 19', spend: 1128 },
		{ week: 'Feb 26', spend: 1304 },
		{ week: 'Mar 5', spend: 1050 },
		{ week: 'Mar 12', spend: 1045 },
		{ week: 'Mar 19', spend: 1248 },
	],
	4: [
		{ month: 'Jan', rate: 123 },
		{ month: 'Feb', rate: 125 },
		{ month: 'Mar', rate: 127 },
		{ month: 'Apr', rate: 124 },
		{ month: 'May', rate: 130 },
		{ month: 'Jun', rate: 132 },
		{ month: 'Jul', rate: 133 },
		{ month: 'Aug', rate: 128 },
		{ month: 'Sep', rate: 134 },
		{ month: 'Oct', rate: 150 },
		{ month: 'Nov', rate: 145 },
		{ month: 'Dec', rate: 148 },
	],
};

export const purchaseOrders = [
	{
		id: 1,
		name: 'Plumbing parts',
		status: 'new',
		createdAt: '2019-10-14T18:03:37.439Z',
		paymentTerms: 'Net 30',
		shippingTerms: 'FOB',
		vendor: { name: 'Ferguson Plumbing' },
		orderedBy: {
			userName: 'demo+sm@useopenwrench.com',
			userType: 'supplier',
			email: 'demo+sm@useopenwrench.com',
			phoneWork: '9795713661',
			phoneMobile: '9795713661',
			nameGiven: 'Joe',
			nameFamily: 'Murphy',
			photoLink: 'BLL6VMVgXrzSzc5NAYveYiWqIu1V9ZY9w07VBzTXi4x9pkRPxk/joemurphy.png',
			title: 'Technician',
			department: 'R&M',
		},
		partsWithQuantity: [
			{
				part: {
					id: 37,
					partUUID: 'b137ca82-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Lowes',
					vendorId: 1,
					vendor: { id: 1, name: 'Lowes' },
					serialNumber: 'V77712',
					name: 'ProPress® 1/2 in. Press Cap',
					images: [
						'rKqFU3o2c4fHNm8UmFUakOb27iFjoHpqQsZdOnea1mlVwVGmdy/copper-fittings-cpc617-64_1000.jpg',
					],
					description:
						'ProPress® 1/2 in. Press Cap. https://www.homedepot.com/p/1-2-in-Copper-Press-Pressure-Tube-Cap-CPC617/203460444',
					cost: 3.39,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-08-05T21:13:55.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				part: {
					id: 38,
					partUUID: 'b137cbf7-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Lowes',
					vendorId: 1,
					vendor: { id: 1, name: 'Lowes' },
					serialNumber: 'V77717',
					name: 'ProPress® 3/4 in. Press Cap',
					images: [
						'nxmrpVUlxfWh38K7gJuNgX3JDOQ5xdUDBb9rsnuNTAiJy16GFb/nibco-presssystem-copper-fittings-cpc600dshd34-64_1000.jpg',
					],
					description:
						'ProPress® 3/4 in. Press Cap. https://www.homedepot.com/p/NIBCO-PressSystem-3-4-in-Copper-Press-x-Press-Pressure-Coupling-with-Dimple-Stop-CPC600DSHD34/203460405',
					cost: 2.34,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:42:01.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				part: {
					id: 39,
					partUUID: 'b137cd79-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Ferguson',
					vendorId: 3,
					vendor: { id: 3, name: 'Ferguson' },
					serialNumber: 'V77722',
					name: 'ProPress® 1 in. Press Cap',
					images: [
						'ccwgzNesdHFxSCHQ2JpFMc2tkFOh2uX7oHfaMoi2zQ8Mk7PELy/Screen Shot 2019-06-12 at 9.43.10 AM.png',
					],
					description:
						'ProPress® 1 in. Press Cap. https://www.ferguson.com/product/propress-1-in-press-cap-v77722/_/R-1349177',
					cost: 9.2,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:43:27.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				part: {
					id: 40,
					partUUID: 'b137ceea-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Supply House',
					vendorId: 2,
					vendor: { id: 2, name: 'Supply House' },
					serialNumber: 'V77727',
					name: 'ProPress® 1-1/4 in. Press Cap',
					images: ['zne8eiGR28v6F9KKQM9w1iU5T4r5tQWvj7DXNj24OAVOrij2Hf/50052-3.jpg'],
					description:
						'ProPress® 1-1/4 in. Press Cap. https://www.supplyhouse.com/JW-50052-1-1-4-Press-Copper-Cap',
					cost: 9.95,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:44:04.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				part: {
					id: 41,
					partUUID: 'b137d2ba-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Lowes',
					vendorId: 1,
					vendor: { id: 1, name: 'Lowes' },
					serialNumber: '',
					name: 'Cop 90 1/2"',
					images: [
						'hPDKsjVVZ24GdbcnIdtmWIyRHUb9Cu5BvXzb4OMNXSD23pUci1/nibco-copper-fittings-cpc607hd12-64_1000.jpg',
					],
					description:
						'Cop 90 1/2". https://www.homedepot.com/p/NIBCO-1-2-in-Copper-90-Degree-Press-x-Press-Pressure-Elbow-CPC607HD12/204583145',
					cost: 1.69,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:44:32.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				part: {
					id: 42,
					partUUID: 'b137d435-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Lowes',
					vendorId: 1,
					vendor: { id: 1, name: 'Lowes' },
					serialNumber: '',
					name: 'Cop 90 3/4"',
					images: [
						'Vvenwl8m1AB5h2jpOj13b2BbstIf79eZYvD5DcLMmNTUJ7dr8S/nibco-copper-fittings-cpc607hd34-64_1000.jpg',
					],
					description:
						'Cop 90 3/4". https://www.homedepot.com/p/NIBCO-3-4-in-Copper-90-Degree-Press-x-Press-Pressure-Elbow-CPC607HD34/203460430',
					cost: 2.99,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:45:00.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				part: {
					id: 43,
					partUUID: 'b137d59d-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Lowes',
					vendorId: 1,
					vendor: { id: 1, name: 'Lowes' },
					serialNumber: '',
					name: 'cop 90 1"',
					images: [
						'bM6UuvBfMmH9T9yXrnisJ8BWAzn7ahtSpT7lROowM1d6SPEZZD/copper-fittings-cpc607-64_1000.jpg',
					],
					description:
						'cop 90 1". https://www.homedepot.com/p/1-in-Copper-90-Degree-Press-x-Press-Pressure-Elbow-CPC607/203460431',
					cost: 5.98,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:45:29.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				part: {
					id: 44,
					partUUID: 'b137d6fa-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Ferguson',
					vendorId: 3,
					vendor: { id: 3, name: 'Ferguson' },
					serialNumber: 'V77332',
					name: 'cop 90 1.25"',
					images: [
						'efdMsvs3wTsWsoOKKehuSpiVPrKjwJNCKdyBNq1k3GMhPSMR7F/Screen Shot 2019-06-12 at 9.45.54 AM.png',
					],
					description:
						'cop 90 1.25". https://www.ferguson.com/product/propress-1-14-in-press-90-degree-elbow-v77332/_/R-1349303',
					cost: 11.93,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:46:11.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				part: {
					id: 45,
					partUUID: 'b137d860-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Lowes',
					vendorId: 1,
					vendor: { id: 1, name: 'Lowes' },
					serialNumber: '',
					name: 'Pipe 2-in x 2-in dia 90-Degree PVC Schedule 40 Hub Elbow Long Sweep Fitting',
					images: ['2SaGRZwX2EO71XGCLXfyRSEax2gAEp6QRkAL5Zr7zyZdknx17I/611942033782.jpg'],
					description:
						'Pipe 2-in x 2-in dia 90-Degree PVC Schedule 40 Hub Elbow Long Sweep Fitting. https://www.lowes.com/search?searchTerm=90-degree+pvc+schedule+40+hub+elbow+long+sweep+fitting',
					cost: 3.08,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:46:48.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
			{
				part: {
					id: 46,
					partUUID: 'b137d9c2-b7dd-11e9-8876-0add6c8ff44e',
					manufacturerName: 'Supply House',
					vendorId: 2,
					vendor: { id: 2, name: 'Supply House' },
					serialNumber: 'MPF10145',
					name: '1/2 in. Press Copper Coupling',
					images: ['miZJ29voUD22pGT8lNsYGbw3hKiTfzHiAohdiOxd4Z2XIUFHzW/nibco-4801112.jpg'],
					description:
						'1/2 in. Press Copper Coupling. https://www.supply.com/1-1-2-in-h-x-h-pvc-dwv-coupling-4801-domestic/p487392',
					cost: 0.41,
					quantity: 0,
					uomId: 1,
					unitOfMeasure: {
						id: 1,
						name: 'each',
						displayNameSingular: 'each',
						displayNamePlural: 'eaches',
						uomConversionFactor: [],
						description: 'the smallest unit by which something is consumed',
					},
					supplierCompanyId: 276125,
					supplierCompany: {
						id: 276125,
						name: 'OpenWrench',
						displayName: 'OpenWrench',
						status: 'active',
						isClaimed: true,
						about: 'sdflkjasdflkj',
						operatingHours: {},
						verifications: [],
						licenses: [],
						certifications: [],
						insurances: [],
						faqs: [],
						isWomenOwned: false,
						isMinorityOwned: false,
						isVeteranOwned: false,
						isDisabledOwned: false,
						isLgbtOwned: false,
						isSmallBusinessEnterprise: false,
						categoryIds: [9, 314, 5, 258, 6],
						categoryNames:
							'Concierge, Food Service Equipment, Building Evaluations, HVAC, Catering',
						logoURL:
							'https://images.emptor.ai/fit-in/300x300/images/company-logos/openwrenchlogo.png',
						poEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryContactEmail: 'vignesh+mixpanelclaim1@useopenwrench.com',
						primaryAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						remitToAddress: {
							streetAddress1: '111 Monterey Boulevard',
							city: 'San Francisco',
							postcode: '94131',
							region: 'California',
							country: 'United States',
						},
						latitude: 37.73141098022461,
						longitude: -122.43785095214844,
						socialMedia: {},
						serviceAreaSelfPerforming: [],
						serviceAreaSelfPerformingParsedAddress: [],
						serviceAreaSelfPerformingCountries: [],
						serviceAreaSelfPerformingPostalCodes: [],
						serviceAreaNotSelfPerforming: [],
						serviceAreaNotSelfPerformingParsedAddress: [],
						serviceAreaNotSelfPerformingCountries: [],
						serviceAreaNotSelfPerformingPostalCodes: [],
						additionalDetails: {},
					},
					createdAt: '2019-06-12T16:47:21.000Z',
					updatedAt: '2019-09-05T16:47:39.000Z',
					isDeleted: false,
				},
				quantity: 1,
			},
		],
		stockLocationId: 11,
		stockLocation: {
			id: 11,
			name: 'My warehouse',
			images: [],
			address: {
				streetAddress1: '111 Monterey Boulevard',
				city: 'San Francisco',
				postcode: '94131',
			},
			createdAt: '2019-10-17T20:41:31.000Z',
			description: 'An awesome warehouse where cool things happen',
			isDeleted: false,
			isMobile: false,
			supplierCompany: {
				id: 276125,
				name: 'OpenWrench',
				displayName: 'OpenWrench',
				status: 'active',
				isClaimed: true,
			},
			supplierCompanyId: 276125,
			supplierFacility: {
				id: 137579,
				name: 'OpenWrench',
				displayName: 'OpenWrench',
				status: 'active',
				isClaimed: true,
			},
			supplierFacilityId: 137579,
			updatedAt: '2019-10-17T20:41:31.000Z',
		},
		totalCost: 100,
	},
];

export const highLevelCategories = {
	facilities: {
		id: 1,
		name: 'Facilities',
		icon: 'machinery',
		imageUrl: 'images/categories/hvacMaintenance.jpg',
	},
	consulting: {
		id: 2,
		name: 'Consulting',
		icon: 'bussinessman',
		imageUrl: 'images/categories/consulting.jpg',
	},
	technology: {
		id: 3,
		name: 'Technology',
		icon: 'electronics',
		imageUrl: 'images/categories/technology.jpg',
	},
	creative: {
		id: 4,
		name: 'Creative',
		icon: 'color',
		imageUrl: 'images/categories/uxDesign.jpg',
	},
	transportation: {
		id: 5,
		name: 'Transportation',
		icon: 'auto',
		imageUrl: 'images/categories/transportAndShuttleServices.jpg',
	},
	logistics: {
		id: 6,
		name: 'Logistics',
		icon: 'logistic',
		imageUrl: 'images/categories/webDesign.jpg',
	},
	finance: {
		name: 'Finance',
		icon: 'calculator',
		imageUrl: 'images/categories/webDesign.jpg',
	},
	marketing: {
		name: 'Marketing',
		icon: 'signboard',
		imageUrl: 'images/categories/videography.jpg',
	},
	telecommunications: {
		name: 'Telecommunications',
		icon: 'phone',
		imageUrl: 'images/categories/telecom.jpg',
	},
	foodAndBeverage: {
		name: 'Food and Beverage',
		icon: 'whatever',
		imageUrl: 'images/categories/cateringAndFoodServices.jpg',
	},
	legal: {
		name: 'Legal',
		icon: 'libra',
		imageUrl: 'images/categories/webDesign.jpg',
	},
	travelAndEntertainment: {
		name: 'Travel and Entertainment',
		icon: 'earth',
		imageUrl: 'images/categories/webDesign.jpg',
	},
	clinical: {
		name: 'Clinical',
		icon: 'phone',
		imageUrl: 'images/categories/clinical.jpg',
	},
	hr: {
		name: 'HR',
		icon: 'phone',
		imageUrl: 'images/categories/branding.jpg',
	},
	administrativeServices: {
		name: 'Administrative',
		icon: 'phone',
		imageUrl: 'images/categories/administrative.jpg',
	},
};

export const services = {
	freightManagement: {
		highLevelCategoryId: 6,
		name: 'Freight',
		imageUrl: 'images/categories/administrative.jpg',
	},
	courierServices: {
		highLevelCategoryId: 6,
		name: 'Couriers',
		imageUrl: 'images/categories/courierServices.jpg',
	},
	laundry: {
		highLevelCategoryId: 1,
		name: 'Laundry & linens',
		imageUrl: 'images/categories/laundryLinenServices.jpg',
	},
	formsManagement: {
		highLevelCategoryId: 15,
		name: 'Forms management',
		imageUrl: 'images/categories/formsManagement.jpg',
	},
	translation: {
		highLevelCategoryId: 4,
		name: 'Translation',
		imageUrl: 'images/categories/translation.jpg',
	},
	alarmSystems: {
		highLevelCategoryId: 1,
		name: 'Alarm Systems',
		imageUrl: 'images/categories/alarm.jpg',
	},
	generatorServices: {
		highLevelCategoryId: 1,
		name: 'Generators',
		imageUrl: 'images/categories/generators.jpeg',
	},
	catering: {
		highLevelCategoryId: 10,
		name: 'Catering',
		imageUrl: 'images/categories/cateringAndFoodServices.jpg',
	},
	breakroomVendingServices: {
		highLevelCategoryId: 10,
		name: 'Breakroom Vending',
		imageUrl: 'images/categories/breakroomVending.jpg',
	},
	hvacMaintenance: {
		highLevelCategoryId: 10,
		name: 'HVAC Maintenance',
		imageUrl: 'images/categories/hvacMaintenance.jpg',
	},
	instrumentRepairAndScopeSharpening: {
		highLevelCategoryId: 13,
		name: 'Instrument Sharpening and Scope Repair',
		imageUrl: 'images/categories/instrumentRepairAndScopeSharpening.jpg',
	},
	accountsPayableAudit: {
		highLevelCategoryId: 7,
		name: 'Recovery Audit',
		imageUrl: 'images/categories/accountsPayableAudit.jpg',
	},
	collectionAgencyServices: {
		highLevelCategoryId: 7,
		name: 'Debt collection',
		imageUrl: 'images/categories/debtCollection.jpg',
	},
	valetAndParkingServices: {
		highLevelCategoryId: 1,
		name: 'Valet and parking',
		imageUrl: 'images/categories/valetAndParking.jpeg',
	},
	printAndCopyServices: {
		highLevelCategoryId: 1,
		name: 'Print and copy services',
		imageUrl: 'images/categories/printAndCopy.jpeg',
	},
	janitorialServices: {
		highLevelCategoryId: 1,
		name: 'Janitorial services',
		imageUrl: 'images/categories/janitorialServices.jpg',
	},
	transcriptionServices: {
		highLevelCategoryId: 15,
		name: 'transcriptionServices',
		imageUrl: 'images/categories/transcription.jpg',
	},
	guardsAndSecurityServices: {
		highLevelCategoryId: 1,
		name: 'Guard and security services',
		imageUrl: 'images/categories/guardsAndSecurity.jpg',
	},
	itServices: {
		highLevelCategoryId: 3,
		name: 'IT services',
		imageUrl: 'images/categories/ITServices.jpeg',
	},
	landscapingAndLawnCare: {
		highLevelCategoryId: 1,
		name: 'Landscaping and lawn care',
		imageUrl: 'images/categories/webDesign.jpg',
	},
	digitalMarketing: {
		highLevelCategoryId: 8,
		name: 'Digital marketing',
		imageUrl: 'images/categories/digitalMarketing.jpg',
	},
	contentCreation: {
		highLevelCategoryId: 4,
		name: 'Content creation',
		imageUrl: 'images/categories/contentCreation.jpg',
	},
	graphicDesign: {
		highLevelCategoryId: 4,
		name: 'Graphic design',
		imageUrl: 'images/categories/graphicDesign.jpg',
	},
	webDesign: {
		highLevelCategoryId: 4,
		name: 'Web design',
		imageUrl: 'images/categories/webDesign.jpg',
	},
	bloodBank: {
		highLevelCategoryId: 13,
		name: 'Blood bank',
		imageUrl: 'images/categories/bloodBank.jpg',
	},
	shuttleServices: {
		highLevelCategoryId: 5,
		name: 'Shuttle services',
		imageUrl: 'images/categories/shuttle.jpeg',
	},
	vendingMachines: {
		highLevelCategoryId: 10,
		name: 'Vending machines',
		imageUrl: 'images/categories/transporation.jpg',
	},
	ambulanceServices: {
		highLevelCategoryId: 5,
		name: 'Shuttle services',
		imageUrl: 'images/categories/ambulance.jpg',
	},
	ePayables: {
		highLevelCategoryId: 7,
		name: 'ePayables',
		imageUrl: 'images/categories/ePayables.jpg',
	},
	interiorLandscaping: {
		highLevelCategoryId: 1,
		name: 'Interior landscaping',
		imageUrl: 'images/categories/interiorLandScaping.jpeg',
	},
	voiceAndData: {
		highLevelCategoryId: 9,
		name: 'Voice and data',
		imageUrl: 'images/categories/voiceAndData.jpeg',
	},
	cellPhonesAndService: {
		highLevelCategoryId: 9,
		name: 'Cell phones and service',
		imageUrl: 'images/categories/cellPhone.jpeg',
	},
	officeSupplies: {
		highLevelCategoryId: 15,
		name: 'Shuttle services',
		imageUrl: 'images/categories/officeSupplies.jpeg',
	},
	fleetManagement: {
		highLevelCategoryId: 5,
		name: 'Fleet management',
		imageUrl: 'images/categories/fleet.jpeg',
	},
	fitnessServices: {
		highLevelCategoryId: 14,
		name: 'Fitness services',
		imageUrl: 'images/categories/fitness.jpeg',
	},
	fleetLeaseOfVehicles: {
		highLevelCategoryId: 5,
		name: 'Fleet leasing',
		imageUrl: 'images/categories/fleet.jpeg',
	},
	employeeAssistanceProgram: {
		highLevelCategoryId: 14,
		name: 'Employee assistance program',
		imageUrl: 'images/categories/employeeAssistance.jpeg',
	},
	inventoryServices: {
		highLevelCategoryId: 6,
		name: 'Inventory services',
		imageUrl: 'images/categories/inventory.jpeg',
	},
	mobileDiagnostics: {
		highLevelCategoryId: 13,
		name: 'Mobile diagnostics',
		imageUrl: 'images/categories/mobileDiagnostics.jpeg',
	},
	roofingServices: {
		highLevelCategoryId: 1,
		name: 'Roofing services',
		imageUrl: 'images/categories/roofing.jpeg',
	},
	instrumentAndEquipmentTracking: {
		highLevelCategoryId: 6,
		name: 'Instrument and equipment tracking',
		imageUrl: 'images/categories/transporation.jpg',
	},
	buildingLifeSafetySystems: {
		highLevelCategoryId: 1,
		name: 'Building life safety systems',
		imageUrl: 'images/categories/buildingLifeSafetySystems.jpeg',
	},
	ehsAndFirstAidServices: {
		highLevelCategoryId: 1,
		name: 'EHS and First Aid',
		imageUrl: 'images/categories/ehsAndFirstAid.jpg',
	},
	onsiteHealthClinic: {
		highLevelCategoryId: 14,
		name: 'Onsite health clinic',
		imageUrl: 'images/categories/onsiteHealthClinic.jpeg',
	},
	flooringAndMats: {
		highLevelCategoryId: 1,
		name: 'Flooring and mats',
		imageUrl: 'images/categories/flooringAndMat.jpeg',
	},
	waterTreatmentProductsAndServices: {
		highLevelCategoryId: 1,
		name: 'Water treatment and conditioning',
		imageUrl: 'images/categories/transporation.jpg',
	},
	perfusionServices: {
		highLevelCategoryId: 13,
		name: 'Perfusion services',
		imageUrl: 'images/categories/transporation.jpg',
	},
	wasteServices: {
		highLevelCategoryId: 1,
		name: 'Waste services',
		imageUrl: 'images/categories/transporation.jpg',
	},
	apparelServices: {
		highLevelCategoryId: 1,
		name: 'Apparel services',
		imageUrl: 'images/categories/transporation.jpg',
	},
	cobraAdministration: {
		highLevelCategoryId: 14,
		name: 'Cobra administration',
		imageUrl: 'images/categories/transporation.jpg',
	},
	pharmacyBenefitsManagement: {
		highLevelCategoryId: 14,
		name: 'Pharmacy benefits administration',
		imageUrl: 'images/categories/transporation.jpg',
	},
	infectionControl: {
		highLevelCategoryId: 13,
		name: 'Infection control',
		imageUrl: 'images/categories/transporation.jpg',
	},
	recordsAndMediaStorage: {
		highLevelCategoryId: 6,
		name: 'Records and media storage',
		imageUrl: 'images/categories/documentStorage.jpg',
	},
	dialysisServices: {
		highLevelCategoryId: 13,
		name: 'Dialysis services',
		imageUrl: 'images/categories/transporation.jpg',
	},
	cleanroomServices: {
		highLevelCategoryId: 13,
		name: 'Cleanroom services',
		imageUrl: 'images/categories/transporation.jpg',
	},
	videoProduction: {
		highLevelCategoryId: 8,
		name: 'Video production',
		imageUrl: 'images/categories/transporation.jpg',
	},
	refrigeration: {
		highLevelCategoryId: 1,
		name: 'Refrigeration',
		imageUrl: 'images/categories/refrigeration.jpeg',
	},
	disasterRecovery: {
		highLevelCategoryId: 3,
		name: 'Disaster recovery',
		imageUrl: 'images/categories/ITServices.jpeg',
	},
	backgroundAndDrugScreening: {
		highLevelCategoryId: 14,
		name: 'Background and drug screening',
		imageUrl: 'images/categories/backgroundAndDrugScreening.jpeg',
	},
	answeringServicesAndCallCenterServices: {
		highLevelCategoryId: 9,
		name: 'Answering and call center services',
		imageUrl: 'images/categories/answerAndCallCenter.jpg',
	},
	rideshare: {
		highLevelCategoryId: 5,
		name: 'Rideshare',
		imageUrl: 'images/categories/rideShare.jpeg',
	},
	paperShredding: {
		highLevelCategoryId: 1,
		name: 'Paper shredding',
		imageUrl: 'images/categories/shredding.jpg',
	},
	staffing: {
		highLevelCategoryId: 14,
		name: 'Staffing',
		imageUrl: 'images/categories/staffing.jpeg',
	},
	eventManagemenmt: {
		highLevelCategoryId: 8,
		name: 'Event management',
		imageUrl: 'images/categories/eventManagement.jpeg',
	},
	signage: {
		highLevelCategoryId: 1,
		name: 'Signage',
		imageUrl: 'images/categories/signage.jpeg',
	},
	recallAlertServices: {
		highLevelCategoryId: 6,
		name: 'Recall alert services',
		imageUrl: 'images/categories/transporation.jpg',
	},
	surveyingAndQuestionnaires: {
		highLevelCategoryId: 8,
		name: 'Surveying and questionnaires',
		imageUrl: 'images/categories/surveyingAndQuestionnaires.jpg',
	},
	pestPrevention: {
		highLevelCategoryId: 1,
		name: 'Pest prevention',
		imageUrl: 'images/categories/pestPrevention.jpeg',
	},
	flexSpendingAccounts: {
		highLevelCategoryId: 14,
		name: 'Flex spending accounts',
		imageUrl: 'images/categories/flexSpendingAccounts.jpeg',
	},
	lifeAndDisabilitiyInsurance: {
		highLevelCategoryId: 14,
		name: 'Life and disability insurance',
		imageUrl: 'images/categories/lifeAndDisabilityInsurance.jpeg',
	},
	healthInsurance: {
		highLevelCategoryId: 14,
		name: 'Health insurance',
		imageUrl: 'images/categories/healthInsurance.jpeg',
	},
	dentalInsurance: {
		highLevelCategoryId: 14,
		name: 'Dental insurance',
		imageUrl: 'images/categories/dentalInsurance.jpeg',
	},
	teleconferencing: {
		highLevelCategoryId: 9,
		name: 'Teleconferencing',
		imageUrl: 'images/categories/teleConference.jpeg',
	},
	relocation: {
		highLevelCategoryId: 6,
		name: 'Relocation',
		imageUrl: 'images/categories/relocation.jpeg',
	},
	advertising: {
		highLevelCategoryId: 8,
		name: 'Advertising',
		imageUrl: 'images/categories/advertising.jpg',
	},
	complianceServices: {
		highLevelCategoryId: 5,
		name: 'Compliance services',
		imageUrl: 'images/categories/compliance.jpeg',
	},
	elevatorMaintenance: {
		highLevelCategoryId: 1,
		name: 'Elevator maintenance',
		imageUrl: 'images/categories/elevatorMaintenance.jpg',
	},
};

export const opportunityIndicatorStyles = {
	rateIncrease: {
		icon: 'tag',
		colors: emptorGradients.purple,
	},
	offContractSpend: {
		icon: 'file-unknown',
		colors: emptorGradients.yellow,
	},
	projectOverrun: {
		icon: 'schedule',
		colors: emptorGradients.red,
	},
	newProjectRequest: {
		icon: 'file-add',
		colors: emptorGradients.blue,
	},
};

export const mockBuyerContacts = [
	{
		email: 'alice.lam@example.com',
		phoneWork: '671-163-4550',
		phoneMobile: '293-555-4924',
		nameGiven: 'alice',
		nameFamily: 'lam',
		photoLink: 'https://randomuser.me/api/portraits/med/women/72.jpg',
		title: 'manager',
		department: 'Marketing',
		facilityId: 1,
	},
	{
		email: 'amanda.marshall@example.com',
		phoneWork: '(940)-617-4265',
		phoneMobile: '(650)-509-7145',
		nameGiven: 'amanda',
		nameFamily: 'marshall',
		photoLink: 'https://randomuser.me/api/portraits/med/women/30.jpg',
		title: 'director',
		department: 'Legal',
		facilityId: 1,
	},
	{
		email: 'avery.mitchell@example.com',
		phoneWork: '206-742-5283',
		phoneMobile: '253-930-6879',
		nameGiven: 'avery',
		nameFamily: 'mitchell',
		photoLink: 'https://randomuser.me/api/portraits/med/women/37.jpg',
		title: 'lead',
		department: 'Supply Chain',
		facilityId: 1,
	},
	{
		email: 'connor.ferguson@example.com',
		phoneWork: '(370)-471-2029',
		phoneMobile: '(915)-916-7056',
		nameGiven: 'connor',
		nameFamily: 'ferguson',
		photoLink: 'https://randomuser.me/api/portraits/med/men/78.jpg',
		title: 'senior analyst',
		department: 'Human Resources',
		facilityId: 1,
	},
	{
		email: 'courtney.lawson@example.com',
		phoneWork: '(804)-420-0846',
		phoneMobile: '(759)-161-5164',
		nameGiven: 'courtney',
		nameFamily: 'lawson',
		photoLink: 'https://randomuser.me/api/portraits/med/women/27.jpg',
		title: 'manager',
		department: 'Sales',
		facilityId: 1,
	},
	{
		email: 'curtis.black@example.com',
		phoneWork: '(505)-084-1576',
		phoneMobile: '(775)-090-4837',
		nameGiven: 'curtis',
		nameFamily: 'black',
		photoLink: 'https://randomuser.me/api/portraits/med/men/54.jpg',
		title: 'analyst',
		department: 'Accounting',
		facilityId: 1,
	},
	{
		email: 'david.marshall@example.com',
		phoneWork: '(306)-056-5090',
		phoneMobile: '(136)-532-8162',
		nameGiven: 'david',
		nameFamily: 'marshall',
		photoLink: 'https://randomuser.me/api/portraits/med/men/21.jpg',
		title: 'manager',
		department: 'Legal',
		facilityId: 1,
	},
	{
		email: 'deann.hunter@example.com',
		phoneWork: '(976)-656-6182',
		phoneMobile: '(798)-314-1831',
		nameGiven: 'deann',
		nameFamily: 'hunter',
		photoLink: 'https://randomuser.me/api/portraits/med/women/3.jpg',
		title: 'manager',
		department: 'IT',
		facilityId: 1,
	},
	{
		email: 'harper.brar@example.com',
		phoneWork: '879-873-0963',
		phoneMobile: '596-194-9726',
		nameGiven: 'harper',
		nameFamily: 'brar',
		photoLink: 'https://randomuser.me/api/portraits/med/women/3.jpg',
		title: 'lead',
		department: 'Sales',
		facilityId: 1,
	},
	{
		email: 'jackie.campbell@example.com',
		phoneWork: '(026)-999-0174',
		phoneMobile: '(088)-795-5168',
		nameGiven: 'jackie',
		nameFamily: 'campbell',
		photoLink: 'https://randomuser.me/api/portraits/med/women/17.jpg',
		title: 'analyst',
		department: 'Marketing',
		facilityId: 1,
	},
	{
		email: 'jorge.cruz@example.com',
		phoneWork: '(484)-518-1459',
		phoneMobile: '(223)-632-3660',
		nameGiven: 'jorge',
		nameFamily: 'cruz',
		photoLink: 'https://randomuser.me/api/portraits/med/men/97.jpg',
		title: 'supervisor',
		department: 'Accounting',
		facilityId: 1,
	},
	{
		email: 'krin.rice@example.com',
		phoneWork: '(230)-454-4213',
		phoneMobile: '(311)-345-9280',
		nameGiven: 'krin',
		nameFamily: 'rice',
		photoLink: 'https://randomuser.me/api/portraits/med/women/21.jpg',
		title: 'supervisor',
		department: 'Marketing',
		facilityId: 1,
	},
	{
		email: 'laurie.lam@example.com',
		phoneWork: '815-306-7105',
		phoneMobile: '929-100-4520',
		nameGiven: 'laurie',
		nameFamily: 'lam',
		photoLink: 'https://randomuser.me/api/portraits/med/women/80.jpg',
		title: 'manager',
		department: 'Legal',
		facilityId: 1,
	},
	{
		email: 'logan.côté@example.com',
		phoneWork: '482-495-5942',
		phoneMobile: '059-342-4030',
		nameGiven: 'logan',
		nameFamily: 'côté',
		photoLink: 'https://randomuser.me/api/portraits/med/men/85.jpg',
		title: 'director',
		department: 'Supply Chain',
		facilityId: 1,
	},
	{
		email: 'manuel.grant@example.com',
		phoneWork: '(853)-752-3469',
		phoneMobile: '(077)-045-4101',
		nameGiven: 'manuel',
		nameFamily: 'grant',
		photoLink: 'https://randomuser.me/api/portraits/med/men/47.jpg',
		title: 'associate manager',
		department: 'Human Resources',
		facilityId: 1,
	},
	{
		email: 'marcus.harper@example.com',
		phoneWork: '(836)-762-7984',
		phoneMobile: '(386)-595-6004',
		nameGiven: 'marcus',
		nameFamily: 'harper',
		photoLink: 'https://randomuser.me/api/portraits/med/men/35.jpg',
		title: 'associate manager',
		department: 'Finance',
		facilityId: 1,
	},
	{
		email: 'mason.morin@example.com',
		phoneWork: '362-070-2082',
		phoneMobile: '304-963-1997',
		nameGiven: 'mason',
		nameFamily: 'morin',
		photoLink: 'https://randomuser.me/api/portraits/med/men/68.jpg',
		title: 'analyst',
		department: 'Marketing',
		facilityId: 1,
	},
	{
		email: 'nicholas.jensen@example.com',
		phoneWork: '(441)-879-2673',
		phoneMobile: '(395)-086-8588',
		nameGiven: 'nicholas',
		nameFamily: 'jensen',
		photoLink: 'https://randomuser.me/api/portraits/med/men/78.jpg',
		title: 'analyst',
		department: 'Legal',
		facilityId: 1,
	},
	{
		email: 'owen.wallace@example.com',
		phoneWork: '(980)-666-9908',
		phoneMobile: '(230)-387-7329',
		nameGiven: 'owen',
		nameFamily: 'wallace',
		photoLink: 'https://randomuser.me/api/portraits/med/men/6.jpg',
		title: 'director',
		department: 'Sales',
		facilityId: 1,
	},
	{
		email: 'roger.cole@example.com',
		phoneWork: '(623)-561-2598',
		phoneMobile: '(499)-781-9035',
		nameGiven: 'roger',
		nameFamily: 'cole',
		photoLink: 'https://randomuser.me/api/portraits/med/men/32.jpg',
		title: 'lead',
		department: 'Accounting',
		facilityId: 1,
	},
	{
		email: 'sophia.sirko@example.com',
		phoneWork: '719-367-4226',
		phoneMobile: '579-040-4550',
		nameGiven: 'sophia',
		nameFamily: 'sirko',
		photoLink: 'https://randomuser.me/api/portraits/med/women/86.jpg',
		title: 'coordinator',
		department: 'Purchasing',
		facilityId: 1,
	},
	{
		email: 'sophie.washington@example.com',
		phoneWork: '(479)-792-2354',
		phoneMobile: '(710)-829-8182',
		nameGiven: 'sophie',
		nameFamily: 'washington',
		photoLink: 'https://randomuser.me/api/portraits/med/women/34.jpg',
		title: 'coordinator',
		department: 'IT',
		facilityId: 1,
	},
	{
		email: 'theo.miller@example.com',
		phoneWork: '040-865-1740',
		phoneMobile: '876-109-0611',
		nameGiven: 'theo',
		nameFamily: 'miller',
		photoLink: 'https://randomuser.me/api/portraits/med/men/97.jpg',
		title: 'senior analyst',
		department: 'Purchasing',
		facilityId: 1,
	},
	{
		email: 'tristan.knight@example.com',
		phoneWork: '748-558-0225',
		phoneMobile: '522-296-3663',
		nameGiven: 'tristan',
		nameFamily: 'knight',
		photoLink: 'https://randomuser.me/api/portraits/med/men/82.jpg',
		title: 'senior manager',
		department: 'Legal',
		facilityId: 1,
	},
	{
		email: 'victoria.bergeron@example.com',
		phoneWork: '550-188-0768',
		phoneMobile: '645-120-5666',
		nameGiven: 'victoria',
		nameFamily: 'bergeron',
		photoLink: 'https://randomuser.me/api/portraits/med/women/43.jpg',
		title: 'director',
		department: 'Supply Chain',
		facilityId: 1,
	},
];

export const opportunityDetailData = {
	1: {
		title: 'Price increase on revenue cycle management consulting services',
		subtitle:
			'Your payables data indicates a 20% increase in hourly rates for revenue cycle management consulting services',
		type: 'rateIncrease',
		spendCategory: 'Revenue Cycle Management',
		createdAt: 'Jan 1, 2018',
	},
	2: {
		title: 'Off-Contract Spend',
		subtitle: '50% of locem tenens spend is not under an active agreement',
		type: 'offContractSpend',
		spendCategory: 'Locum Tenens',
		createdAt: 'Jan 1, 2018',
	},
	3: {
		title: 'Project Overrun',
		subtitle: 'ICD-10 training project at Sutter Solano Medical Center is 10% overbudget',
		type: 'projectOverrun',
		spendCategory: 'Revenue Cycle Management',
		createdAt: 'Jan 1, 2018',
	},
	4: {
		title: 'New Project Request',
		subtitle: 'Shiv Tamaranjan requested $210,000 for HIPAA data security compliance',
		type: 'newProjectRequest',
		spendCategory: 'Revenue Cycle Management',
		createdAt: 'Jan 1, 2018',
	},
};

export const dummyFormData = {
	id: 27,
	biddingStatus: 'draft',
	attachments: [],
	title: 'sdfjsdfjlk',
	description: 'asdlfkjasdlkfjasdlkfj',
	eventType: 'rfp',
	currencyId: 'USD',
	spendCategoryId: 1,
	biddingDates: ['2018-02-21T16:34:50.237Z', '2018-02-28T16:34:50.237Z'],
	isBidSealed: false,
	targetAwardDate: '2018-02-28T16:35:16.335Z',
	isNdaRequired: false,
	biddingType: 'rfp',
	biddingOpensAt: '2018-02-21T16:34:50.237Z',
	biddingClosesAt: '2018-02-28T16:34:50.237Z',
	scoringMatrix: [
		{
			criteria: 'sadfsadfasdf',
			description: 'asdfasdfasdfasdf',
			weight: 0.12,
		},
	],
	questions: [
		{
			title: 'asdfasdf',
			description: 'asdfasdfasdf',
			questionType: 'yesNo',
			multipleChoices: [],
		},
	],
	buyerFacilityId: 1,
	ownerEmail: 'staff+demo@emptor.ai',
};

export const opportunityPayablesData = {
	1: [
		{
			key: '1',
			id: 2509,
			spendCategory: 'Revenue Cycle Management',
			spend: 12000,
			supplier: 'Deloitte',
			createdAt: 'Jan 1, 2018',
		},
		{
			key: '2',
			id: 2510,
			spendCategory: 'Revenue Cycle Management',
			spend: 13500,
			supplier: 'Deloitte',
			createdAt: 'Jan 14, 2018',
		},
		{
			key: '3',
			id: 2509,
			spendCategory: 'Revenue Cycle Management',
			spend: 16000,
			supplier: 'PriceWaterhouseCoopers',
			createdAt: 'Feb 3, 2018',
		},
		{
			key: '4',
			id: 2509,
			spendCategory: 'Revenue Cycle Management',
			spend: 11500,
			supplier: 'Deloitte',
			createdAt: 'Feb 10, 2018',
		},
	],
	2: [
		{
			key: '1',
			id: 2509,
			spendCategory: 'Revenue Cycle Management',
			spend: 12000,
			supplier: 'Deloitte',
			createdAt: 'Jan 1, 2018',
		},
		{
			key: '2',
			id: 2510,
			spendCategory: 'Revenue Cycle Management',
			spend: 13500,
			supplier: 'Deloitte',
			createdAt: 'Jan 14, 2018',
		},
		{
			key: '3',
			id: 2509,
			spendCategory: 'Revenue Cycle Management',
			spend: 16000,
			supplier: 'PriceWaterhouseCoopers',
			createdAt: 'Feb 3, 2018',
		},
		{
			key: '4',
			id: 2509,
			spendCategory: 'Revenue Cycle Management',
			spend: 11500,
			supplier: 'Deloitte',
			createdAt: 'Feb 10, 2018',
		},
	],
	3: [
		{
			key: '1',
			id: 2509,
			spendCategory: 'Revenue Cycle Management',
			spend: 12000,
			supplier: 'Deloitte',
			createdAt: 'Jan 1, 2018',
		},
		{
			key: '2',
			id: 2510,
			spendCategory: 'Revenue Cycle Management',
			spend: 13500,
			supplier: 'Deloitte',
			createdAt: 'Jan 14, 2018',
		},
		{
			key: '3',
			id: 2509,
			spendCategory: 'Revenue Cycle Management',
			spend: 16000,
			supplier: 'PriceWaterhouseCoopers',
			createdAt: 'Feb 3, 2018',
		},
		{
			key: '4',
			id: 2509,
			spendCategory: 'Revenue Cycle Management',
			spend: 11500,
			supplier: 'Deloitte',
			createdAt: 'Feb 10, 2018',
		},
	],
	4: [
		{
			key: '1',
			id: 2509,
			spendCategory: 'Revenue Cycle Management',
			spend: 12000,
			supplier: 'Deloitte',
			createdAt: 'Jan 1, 2018',
		},
		{
			key: '2',
			id: 2510,
			spendCategory: 'Revenue Cycle Management',
			spend: 13500,
			supplier: 'Deloitte',
			createdAt: 'Jan 14, 2018',
		},
		{
			key: '3',
			id: 2509,
			spendCategory: 'Revenue Cycle Management',
			spend: 16000,
			supplier: 'PriceWaterhouseCoopers',
			createdAt: 'Feb 3, 2018',
		},
		{
			key: '4',
			id: 2509,
			spendCategory: 'Revenue Cycle Management',
			spend: 11500,
			supplier: 'Deloitte',
			createdAt: 'Feb 10, 2018',
		},
	],
};

export const numberOfLocalProfessionals = {
	20: 75,
	17: 53,
	157: 43,
	159: 31,
	29: 29,
};

export const sourcingEvent = {
	id: 2,
	title: 'Hematopathology Lab Services',
	description: 'Blood diagnostic testing for consolidated services center',
	eventType: 'RFP',
	isBidSealed: false,
	ownerEmail: 'matt@emptor.ai',
	biddingOpensAt: '2017-12-01T21:00:19.785Z',
	biddingClosesAt: '2017-12-11T21:00:19.785Z',
	biddingType: 'traditional',
	biddingStatus: 'draft',
	attachments: [],
	currencyId: 'USD',
	scoringMatrix: [
		{
			criteria: 'pricing',
			description: 'Pricing',
			weight: 0.3,
		},
		{
			criteria: 'compliance',
			description: 'Risk Management and Compliance',
			weight: 0.2,
		},
		{
			criteria: 'completeness',
			description: 'Completeness of Solution',
			weight: 0.2,
		},
		{
			criteria: 'references',
			description: 'Customer References',
			weight: 0.1,
		},
		{
			criteria: 'serviceCommitment',
			description: 'Service Level Guarantees',
			weight: 0.2,
		},
	],
	questions: [
		{
			id: 1,
			title: 'Response Time',
			description:
				'Ability to support clinical diagnostics for full territory with maximum 48 hour turnaround on routine tests?',
			type: 'multipleChoice',
			choices: ['Yes', 'No'],
		},
		{
			id: 2,
			title: 'Quality Control',
			description:
				'Availability of test kit controls, such as internal test device controls and test kit controls for QC?',
			type: 'multipleChoice',
			choices: ['Yes', 'No'],
		},
		{
			id: 3,
			title: 'Compatibility',
			description: 'Compatibility with EQAS/proficiency testing programmes?',
			type: 'multipleChoice',
			choices: ['Yes', 'No'],
		},
		{
			id: 4,
			title: 'Customer Support',
			description: 'Dedicated customer service and account representative?',
			type: 'multipleChoice',
			choices: ['Yes', 'No'],
		},
		{
			id: 5,
			title: 'Solution Completeness',
			description: 'Coagulation and urinalysis testing?',
			type: 'multipleChoice',
			choices: ['Yes', 'No'],
		},
	],
};

export const mockSuppliers = [
	{
		id: 653,
		name: 'Arca Design Group',
		displayName: 'Arca Design Group',
		status: 'active',
		about:
			'We provide consultations ongoing maintenance services and complete design-build landscape remodels for gardens of all sizes: residential--houses estates live-work and apartment complexes and commercial--municipal and industrial buildings and restaurants. In every job we undertake we emphasize repurposing and recycling as part of our overall commitment to green and sustainable practices. Established in 1980. Suzanne Arca Design has received numerous prestigious industry awards including the Association of Professional Landscape Designers (APLD) 2011 International Landscape Designer of the Year as well as APLD--Gold Medal Residential APLD--Best in Show ASLA--Merit Award and CLCA--Judges Award.Our team is made up of experts with diverse backgrounds in landscape architecture horticulture and construction. Each of us shares the same vision--to create transformational spaces our clients will love. Suzanne Arca ASLA ALPD CLCAA creative team leader with a detail-driven focus34 years of expertise in designing building and maintaining landscapes and providing vision to residential and commercial property ownersDegree in Landscape Architecture University of California at BerkeleyLicensed Design and Build Landscape Contractor C-27 #734757Green Business CertifiedCertified Horticulturalist and Bay Friendly Qualified Landscape ProfessionalInstructor for the Department of Landscape Architecture University of California Extension and the Landscape Horticulture Department Merritt CollegeGuest Lecturer for garden clubs nurseries and horticultural events',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '4:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '4:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '4:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '4:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '4:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [29],
		categoryNames: 'Landscaping and lawn care',
		corporateURL: 'http://www.arcadesigngroup.com',
		storefrontURL: 'http://www.arcadesigngroup.com',
		logoURL: 'https://arcadesigngroup.com/wp-content/uploads/2017/07/logo-2017-315.png',
		poEmail: 'info@arcadesigngroup.com',
		website: 'arcadesigngroup.com',
		primaryContactEmail: 'info@arcadesigngroup.com',
		primaryPhone: '(510) 558-0636',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.886871337890625,
		longitude: -122.2977523803711,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4.5',
			yelpNumReviews: '10',
			hasCommercialText: true,
		},
		supplierCompanyId: 653,
	},
	{
		id: 686,
		name: 'CastleLite Block',
		displayName: 'CastleLite Block',
		status: 'active',
		about:
			'For over 65 years our Diamond Certified business has proudly served the Bay Area. We are the leading manufacturing and installation source of Concrete Pavers Retaining Wall Systems and Retaining Wall Systems for residential and commercial clients in Northern California.We are the only manufacturer that sells directly to its clients and that makes a big difference in terms of the price quality and appearance of our installations. In addition to our onsite installation capabilities we also maintain two factory showrooms in Alamo and Los Altos so customers can see firsthand applications of the products.Stop by our show rooms or let us to come to you so you can experience the CastleLite difference. Visit our website for a full list of services then request information online or call us today for a free estimate and design customized to your specifics. We look forward to providing you with unparalleled value from CastleLitle Block LLC! Established in 1947. With nearly 70 years of experience CastleLite Block LLC has the experience and knowledge necessary to get the job done right. Established in 1947 our business has a strong history of helping residents and businesses across Northern California. At CastleLite it is our mission to work side-by-side with you throughout the entire process to ensure that you are comfortable and all of your questions are answered. Additionally our team of professional factory installers has undergone extensive training and are always available to assist you. We are proud to have been a part of many Northern California communities for so long. We want to thank our loyal customers who have supported our business and we look forward to many years of continued success. As the Operations Manager of CastleLite Block LLC Jay loves working intimately with customers to help them customize a design that they will love. Not only does Jay strive to provide great products and efficient installations for all but he also encourages all of his staff to offer only the best in customer service. If you ever have any questions comments or even a little praise for a job well done- just let Jay know! We value feedback and cant wait to hear from you soon.',
		operatingHours: {
			Tuesday: {
				from: '10:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '10:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '10:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '10:00 am',
				to: '5:00 pm',
			},
			Saturday: {
				from: '10:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [29],
		categoryNames: 'Landscaping and lawn care',
		corporateURL: 'http://castleliteblock.com/',
		storefrontURL: 'http://castleliteblock.com/',
		logoURL: 'http://castleliteblock.com/wp-content/themes/castleliteblock/images/logo.png',
		poEmail: 'info@castleliteblock.com',
		website: 'castleliteblock.com',
		primaryContactEmail: 'info@castleliteblock.com',
		primaryPhone: '(925) 329-3055',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.821048736572266,
		longitude: -121.9986572265625,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4.5',
			yelpNumReviews: '42',
			hasCommercialText: true,
		},
		supplierCompanyId: 686,
	},
	{
		id: 703,
		name: 'CR Paving and Landscaping',
		displayName: 'CR Paving and Landscaping',
		status: 'active',
		about:
			'CR Paving and Landscaping will help you identify the best native or hybrid plants perennials or annuals depending on your taste and vision. Through our association with reputable growers CR Paving and Landscaping will select only the healthiest hardiest specimens for your lawn or garden. Established in 2002. Our company has over 15 years of experience in the industry serving Santa Clara County and the surrounding areas. Owner C Ramirez started in the landscaping industry in the 2000 He maintained a yard maintenance service company for 15 years and the last 12 years he has specialized in backyard retreats and hardscapes. We never fail to meet the very demands and expectations that are set by our clients and through our services we achieve the vision that the residential or commercial client had for their property.When it comes to pavers we also offer a wide array of colors sizes and shapes for you to choose from. We make sure every area of your landscape is beautiful and your patio is no exception. Work hand in hand with the professionals at CR Paving and Landscaping for first class paving and landscaping in Sunnyvale CA.We specialize in both paving and landscaping in Sunnyvale CA. No landscaping or paving job is too big or too small for the landscape professionals at CR Paving and Landscaping. We have the experience and knowledge to help you plan and implement a landscape and paving design that suits your taste and lifestyle. Whether your landscape is a blank canvas or a work in progress we can help make your dreams a reality by helping identify the right vegetation for your propertys terrain',
		operatingHours: {
			Monday: {
				from: '7:00 am',
				to: '7:00 pm',
			},
			Tuesday: {
				from: '7:00 am',
				to: '7:00 pm',
			},
			Wednesday: {
				from: '7:00 am',
				to: '7:00 pm',
			},
			Thursday: {
				from: '7:00 am',
				to: '7:00 pm',
			},
			Friday: {
				from: '7:00 am',
				to: '7:00 pm',
			},
			Saturday: {
				from: '7:00 am',
				to: '7:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [29],
		categoryNames: 'Landscaping and lawn care',
		corporateURL: 'http://www.crpavingandlandscaping.com',
		storefrontURL: 'http://www.crpavingandlandscaping.com',
		logoURL: 'http://www.crpavingandlandscaping.com/images/logo.png',
		poEmail: 'carlosramirez1249@gmail.com',
		website: 'crpavingandlandscaping.com',
		primaryContactEmail: 'carlosramirez1249@gmail.com',
		primaryPhone: '(650) 248-1249',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.37186050415039,
		longitude: -122.02123260498047,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4.5',
			yelpNumReviews: '8',
			hasCommercialText: true,
		},
		supplierCompanyId: 703,
	},
	{
		id: 706,
		name: 'Crown Landscape Contractors',
		displayName: 'Crown Landscape Contractors',
		status: 'active',
		about:
			'Crown Landscape Contractors is a landscape company thats here for all your landscape needs.We do Complete Commercial / Residential Landscape Construction and Landscape Maintenance. We are Licensed C-27 Landscape Contractor. Specializing in: Landscape Installation Landscape Maintenance Yard Service Mowing Edging Manual / Chemical Weeding Pruning & Tree Service Yard Clean-up & Hauling Irrigation / Drainage Repair & Installation Landscape Lighting Fertilization and Aeration. Concrete / Masonry Landscaping. Established in 2004. LandscapeConstruction / Maintenance  * Weekly / Bi-Weekly  * Landscape Design  * Pruning / Tree Service  * Concrete / MasonryColor & StampedKeystone / Pavestone Driveway & Workway & Patio  * Landscape Lighting  * Clean-Up & Hauling  * Aeration & Fertilization  * Pressure Washing  * Water Management  * Landscape Fire Protection  * Retaining WallBlock / Wood / Stone  * Fencing If youre looking for high quality and personal service At Crown Landscape Contractors well give you the attention and personal service youll come to expect and enjoy. Crown Landscape Contractors is a landscape company thats here for all your landscape needs.We do Complete Commercial / Residential Landscape Construction and Landscape Maintenance. We are Licensed C-27 Landscape Contractor. Specializing in: Landscape Installation Landscape Maintenance Yard Service Mowing Edging Manual / Chemical Weeding Pruning & Tree Service Yard Clean-up & Hauling Irrigation / Drainage Repair & Installation Landscape Lighting Fertilization and Aeration. Concrete / Masonry Landscaping And now providing Pressure washing service for your home and business.',
		operatingHours: {
			Monday: {
				from: '7:00 am',
				to: '6:00 pm',
			},
			Tuesday: {
				from: '7:00 am',
				to: '6:00 pm',
			},
			Wednesday: {
				from: '7:00 am',
				to: '6:00 pm',
			},
			Thursday: {
				from: '7:00 am',
				to: '6:00 pm',
			},
			Friday: {
				from: '7:00 am',
				to: '6:00 pm',
			},
			Saturday: {
				from: '7:00 am',
				to: '6:00 pm',
			},
			Sunday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [29],
		categoryNames: 'Landscaping and lawn care',
		corporateURL: 'http://www.crownlandscapecontractors.com',
		storefrontURL: 'http://www.crownlandscapecontractors.com',
		logoURL: '',
		poEmail: 'aman@crownlandscapecontractors.com',
		website: 'crownlandscapecontractors.com',
		primaryContactEmail: 'aman@crownlandscapecontractors.com',
		primaryPhone: '(707) 704-6273',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 38.17491912841797,
		longitude: -122.26080322265625,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4.5',
			yelpNumReviews: '7',
			hasCommercialText: true,
		},
		supplierCompanyId: 706,
	},
	{
		id: 788,
		name: 'Liaison Landscapes',
		displayName: 'Liaison Landscapes',
		status: 'active',
		about:
			'C-27 & C-29 Licensed/Bonded/Insured. Liaison Landscapes was founded to provide greater customer service higher craftsmanship and exceptional project management in the world of landscape construction. Communication is king especially when running any landscape development project private or commercial. Liaisons value is measured in our ability to create unparalleled working relationships providing customers project transparency & contractor accountability from start to finish. A driven ethic to create build & maintain our projects is what forms the foundation of corps values that trademark our skillets. Established in 2015. Liaison Landscapes wants to be the best at what we do. We want to provide an absolute top tier outdoor living development experience from start to finish. What makes us different from others in our field? We care. We care about your property as if it was our own and we take the quality of our work personally and it shows in the final product. Give us a call & find out! Hi! My name is Markus Paul Don Czirban I am the active owner of Liaison Landscapes. The business of construction has been a part of my family for several generations. The satisfaction that comes day in & day out while helping people achieve goals of increasing property value & aesthetic appeal to land development projects is one that runs deep with me. As a Sergeant in the U.S. Marines I was trained to approach task analysis in layers always looking at the present with the future in mind. Fortunately that mentality has translated well as those are some of the cornerstone principals in conducting safe & effective landscape development projects. My team is a dedicated group and I am honored to work along side them as we conduct our projects with superior attention to detail. There are many options in the landscape world our goal is simply to the the best there is. On behalf of the Liaison Landscapes team we look forward to working with you too.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '7:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '7:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '7:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '7:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '7:00 pm',
			},
			Saturday: {
				from: '10:00 am',
				to: '6:00 pm',
			},
			Sunday: {
				from: '10:00 am',
				to: '6:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [29],
		categoryNames: 'Landscaping and lawn care',
		corporateURL: 'http://www.liaisonlandscapes.com/',
		storefrontURL: 'http://www.liaisonlandscapes.com/',
		logoURL: 'http://www.liaisonlandscapes.com/wp-content/uploads/2018/01/logo-4.png',
		poEmail: 'ops@liaisonlandscapes.com',
		website: 'liaisonlandscapes.com',
		primaryContactEmail: 'ops@liaisonlandscapes.com',
		primaryPhone: '(415) 805-3404',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.79283142089844,
		longitude: -122.39788055419922,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '55',
			hasCommercialText: true,
		},
		supplierCompanyId: 788,
	},
	{
		id: 819,
		name: 'Pacific Landscape Design',
		displayName: 'Pacific Landscape Design',
		status: 'active',
		about:
			'Residential Landscape Design & Consultation  -   I provide conceptual landscape designs for homeowners who wish to perform the work themselves or will hire labor to do the work. Complete plans for all aspects of the renovation and installation process using 3D CAD and Photo Design software. I work directly with you and/or your crew to help supervise the project. I also offer hourly consultations to help solve landscape problems with sketches if needed. I have been a landscape contractor for over 30 years designing and installing custom residential landscapes. I am a Bay Area native and know the climate soils and plants that thrive in our microclimates. Calif. Landscape Contractors License # 407526. Member - Association of Professional Landscape Designers and California Landscape Contractors Association. Established in 1981. Pacific Landscape Design opened in 1981 as a commercial and residential design/build firm serving clients throughout Northern California.In 1988 we established our office and yard in Marin County California. The company concentrated on residential landscaping offering design installation and maintenance services. In 2012 the company became a residential landscape design and consultation firm. We welcome all clients from large to small jobs serving all of Northern California. Hi Im Steve the owner of Pacific Landscape Design. I began my career in the landscape and gardening profession here in the Bay Area. I studied horticulture in college at night and worked as a gardener during the day. I worked for a landscape contractor as a foreman and then went on to becoming a licensed California State landscape Contractor in 1981. I established my business here in Marin County in 1988 and built a great reputation by giving my customers their moneys worth and always being available after a job for support. Honesty and Professionalism brought me a lot of word of mouth advertising in the landscape construction business and I intend to continue that philosophy at Pacific Landscape Design. Please Contact Me For A Free Estimate - Weekend Appts. Available.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
			Saturday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
			Sunday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [29],
		categoryNames: 'Landscaping and lawn care',
		corporateURL: 'http://www.pacificlandscapedesign.com',
		storefrontURL: 'http://www.pacificlandscapedesign.com',
		logoURL: 'http://www.pacificlandscapedesign.com/wp-content/uploads/2013/03/logorev2.png',
		poEmail: 'greenland13@icloud.com',
		website: 'pacificlandscapedesign.com',
		primaryContactEmail: 'greenland13@icloud.com',
		primaryPhone: '(916) 740-9299',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.95000076293945,
		longitude: -122.55999755859375,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '1',
			hasCommercialText: true,
		},
		supplierCompanyId: 819,
	},
	{
		id: 830,
		name: 'Rainbow Landscape',
		displayName: 'Rainbow Landscape',
		status: 'active',
		about:
			'Artificial Grass BBQ Islands Decks Drainage systems Drip systems Fences Fireplaces firepits Garden Lighting Garden Maintenance Gazebos Hardscaping Landing steps Landscape Contractor Masonry Mulching Outdoors Home Staging Paths Patios Pergolas Planting Retaining Walls Sod Stairs Stepstones Trellises Walkways Water Features. Established in 2007. Rainbow Landscape Irrigation & Maintenance is a well established and recognized business registered with the Contractors License Board of California under the landscape contractor license # 897534. As a business we have been operating mainly in the North Bay Area. Our main office located in San Rafael Marin County California. Our landscaping business is fully bonded and insured as required by law.We have been providing landscaping services for commercial and residential properties all over Marin County and major cities like Berkeley San Francisco San Jose Oakland Petaluma and more. Our wide array of landscape services includes garden maintenance artificial grass installations irrigation systems patios retaining walls water features and more.We can work with professionals such as Landscape Designers & Architects (with blueprint designs) or directly with the clients just let us know your landscaping ideas and we can put them together in an estimate at no charge. Jorge Jimenez the owner of Rainbow Landscape Irrigation & Maintenance has been in the landscaping business as a professional landscape contractor for over 20 years. He personally gets involved in all the landscaping projects from the beginning to the end. From the moment we set up a jobsite visit Jorge visits all the potential clients at their houses to answer all the questions related to the landscape project. Jorge talks and listens to them to put the desired estimate together to meet the clients expectations. Once an estimate is approved Jorge arrives with our own experienced crew to get the job started. Jorge leads and supervises all the projects. At the end of the job he walks through the installation area with the clients to show them the final work.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '4:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '4:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '4:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '4:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '4:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [29],
		categoryNames: 'Landscaping and lawn care',
		corporateURL: 'http://www.RainbowLandSR.com',
		storefrontURL: 'http://www.RainbowLandSR.com',
		logoURL: '',
		poEmail: 'webmaster@zews.co.cr',
		website: 'RainbowLandSR.com',
		primaryContactEmail: 'webmaster@zews.co.cr',
		primaryPhone: '(415) 485-9231',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.96025848388672,
		longitude: -122.51042175292969,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '2',
			hasCommercialText: true,
		},
		supplierCompanyId: 830,
	},
	{
		id: 857,
		name: 'Simmonds & Associates',
		displayName: 'Simmonds & Associates',
		status: 'active',
		about:
			'Simmonds & Associates Inc. is a leading Bay-Area based landscape architecture and urban design firm specializing in residential commercial and equestrian facilities design. The firm is founded on over twenty five years of practice on three continents bringing a vast and varied experience to our projects.We work with our clients to create outdoor environments rooted in nature. We believe that each unique place is a sanctuary from the stresses of life and an environment that nourishes the spirit. We design outdoor environments that inspire those who enjoy them. We diligently listen to our clients to ensure that we are creating their dreams not ours - making every project unique and exciting. Established in 1994. The company is founded on a wealth of experience working on a broad range of projects from residences to tropical resorts to ski resort villages hospital campuses hotelsand urban streetscapes. We bring a great deal of creativity to any size project and are currently focussed primarily on fine residential commercial and equestrian properties and also in assisting with the rehabilitation of larger landscapes to achieve sustainability. Part master of all elements water part sculptor of nature Warrens approach to Landscape Architecture is rooted in nature. The firm focuses on the idea of sanctuary creating outdoor places that provide a respite from the stresses of life and nourish the spirit.Prior to founding Simmonds & Associates Inc. in 1994 he tenured as Project Manager and Landscape Architect for Eldon Beck Associates (San Rafael CA) and Leffingwell Associates (Sausalito CA) Landscape Architect for Land Design International (Burleigh Heads Australia) and as Landscape Architect for Al-Zoen Sekki Landscape Co. (Tokyo Japan.) Warrens 25 plus years of experience is built on a unique project spectrum spread over three continents; commercial hospital and school campus design tropical and mountain resort projects and residential estates.Warren received his degree in Landscape Architecture from The University of New South Wales Sydney Australia and is currently licensed in the state of California.',
		operatingHours: {
			Monday: {
				from: '8:30 am',
				to: '6:00 pm',
			},
			Tuesday: {
				from: '8:30 am',
				to: '6:00 pm',
			},
			Wednesday: {
				from: '8:30 am',
				to: '6:00 pm',
			},
			Thursday: {
				from: '8:30 am',
				to: '6:00 pm',
			},
			Friday: {
				from: '8:30 am',
				to: '6:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [29],
		categoryNames: 'Landscaping and lawn care',
		corporateURL: 'http://www.simmonds-associates.com',
		storefrontURL: 'http://www.simmonds-associates.com',
		logoURL:
			'https://simmonds-associates.com/wp-content/uploads/2016/12/logo-1_transp.png srcset=https://simmonds-associates.com/wp-content/uploads/2016/12/logo-1_transp.png',
		poEmail: 'info@simmonds-associates.com',
		website: 'simmonds-associates.com',
		primaryContactEmail: 'info@simmonds-associates.com',
		primaryPhone: '(415) 460-0460',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.97597122192383,
		longitude: -122.56146240234375,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '3',
			hasCommercialText: true,
		},
		supplierCompanyId: 857,
	},
	{
		id: 859,
		name: 'Sizemore Services',
		displayName: 'Sizemore Services',
		status: 'active',
		about:
			'Here at Sizemore Services we take pride in providing the best services and satisfying our customers needs. We offer a wide array of outdoor home services ranging from landscaping fences gates sod or mulch installation hauling and junk removal. Specializing in drought tolerant sustainable landscaping to help with conserving water and energy. Hardscape installation of pavers crushed granite rocks permeable paving flagstone and decompose walkways.Tree care trimming pruning or removal of stumps weed abatement blackberry and ivy removal clearing hillsides or vacant lots yearly for Oakland hills fire inspection. Sizemore Services can also be your fence contractor offering new fence and gate installation or repair. Hauling year round or when youre ready for spring cleaning to rid yourself of those unwanted items that have been sitting around to long. As well as property clean ups green waste hauling clearing out gutters blowing parking lots. If you need any of these services in the Oakland CA area call Sizemore Services today. Established in 2004. I started working part time labor work for a property management co. After the company I worked for went under I started doing this full time. I have successfully completed jobs for as large as commercial property maintenance to residential property. Experience in electrical plumbing roofing & construction. Im secure & bondable with an understanding on how to take care of a home. I pride myself on being friendly with a reliable service at a competitive price. At first most dont know what to think about me those who dont judge only find comfort.With labor as an asset its difficult to give estimates most would say Im under bidding myself although the quality of work is worth much more. Ive been found to be caring for your property as if it were my own or being placed in home & gardens magazine trying to find zin. Never taking on anything that I dont know how to do or have never done if I say that I can thats why Im saying that because I can. I feel your yard should be enjoyable with comfort I take pride in my work paying attention to detail & the reputation my work leaves.Not afraid of hard work having high expectations for myself & the same for others with a humorous outlook on life itself.Willing to work anything out so wed both leave happy. Making the right rate for the job vs the amount of work = happy worker equaling a delightful customer!#theunderestimator',
		operatingHours: {
			Monday: {
				from: '7:00 am',
				to: '4:00 pm',
			},
			Tuesday: {
				from: '7:00 am',
				to: '4:00 pm',
			},
			Wednesday: {
				from: '7:00 am',
				to: '4:00 pm',
			},
			Thursday: {
				from: '7:00 am',
				to: '4:00 pm',
			},
			Friday: {
				from: '7:00 am',
				to: '4:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [29],
		categoryNames: 'Landscaping and lawn care',
		corporateURL: 'http://sizemoreservices.com',
		storefrontURL: 'http://sizemoreservices.com',
		logoURL: 'http://sizemoreservices.com/images/logo.png',
		poEmail: 'sizemoreservicesoakland@gmail.com',
		website: 'sizemoreservices.com',
		primaryContactEmail: 'sizemoreservicesoakland@gmail.com',
		primaryPhone: '(510) 277-5703',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.7347412109375,
		longitude: -122.2143325805664,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4',
			yelpNumReviews: '17',
			hasCommercialText: true,
		},
		supplierCompanyId: 859,
	},
	{
		id: 862,
		name: 'Smartscaping',
		displayName: 'Smartscaping',
		status: 'active',
		about:
			'If you are in the market looking for residential or commercial hardscaping products or paving services such as brick pavers interlocking pavers you have come to the right place. No one is more dedicated to installing gorgeous paver driveways in The Bay Area than the landscaping and design team at Smartscaping. Our designers and installers work closely with each client to ensure that their vision is translated into a gorgeous reality. Established in 2016. Founded in 2016 we are family owned and operated and have extensive experience in each phase of construction from the ground up. If you are looking for affordable stone/brick pavers installation Look no further. Please take our advice and get bids for your paving projects. Prices vary a lot. Some companies are simply installers or sales people that sub-contract. We get brick pavers at wholesale price. When you get a bid from us you will verify that the best price the most qualified installers. We offer the best laborers in the business with the best equipment and we work within your budget! We are family owned and operated and have extensive experience in each phase of construction from the ground up. If you are looking for affordable stone/brick pavers installation Look no further. Call our office NOW and we will give you a FREE design & estimate on your Paver Stone project. Please take our advice and get bids for your paving projects. Prices vary a lot. Some companies are simply installers or sales people that sub-contract. We get brick pavers at wholesale price. When you get a bid from us you will verify that the best price the most qualified installers. We offer the best laborers in the business with the best equipment and we work within your budget!',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [29],
		categoryNames: 'Landscaping and lawn care',
		corporateURL: 'http://www.mysmartscaping.com',
		storefrontURL: 'http://www.mysmartscaping.com',
		logoURL:
			'http://www.mysmartscaping.com/wp-content/uploads/2017/04/Smart-Scaping-Hardscaping.png',
		poEmail: 'johnny@mysmartscaping.com',
		website: 'mysmartscaping.com',
		primaryContactEmail: 'johnny@mysmartscaping.com',
		primaryPhone: '(510) 647-8630',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.862300872802734,
		longitude: -122.28247833251953,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '29',
			hasCommercialText: true,
		},
		supplierCompanyId: 862,
	},
	{
		id: 873,
		name: 'Sustainable Landscape And Gardening',
		displayName: 'Sustainable Landscape And Gardening',
		status: 'active',
		about:
			'Sustainable Landscape & Gardening is proudly serving San Francisco Bay Area. Located In San Mateo County we are owner operated and provide on-site supervision to ensure that every detail satisfies your desired specifications. Specialize In: Commercial & Residential Landscaping California Native Garden Drought-Resistant Succulents and Plants Sod or Seed Lawns Gardening Irrigation Irrigation Repair Sprinkler & Drip Systems French Drains Installation Gutter Cleaning & Gutter Guard Installation Retaining Walls Tree Trimming & Removal Hauling & Clean-ups Walkways & Patios Fountain Pick Up & Setup Plant & Tree Installation Christmas Light & Outdoor Decor Installation Decks & Restoration Real Estate Clear-outs Established in 2012. Established in 2012 - Chen Wang - UC Irvine GraduateCriminology B.A.Film B.A.- Logan Campbell -Over 10 years of experiences in Landscaping and Agriculture',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Saturday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Sunday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [29],
		categoryNames: 'Landscaping and lawn care',
		corporateURL: 'http://www.sustainablelg.com',
		storefrontURL: 'http://www.sustainablelg.com',
		logoURL: 'https://sustainablelg.com/wp-content/uploads/2017/05/logo-bruh.jpg',
		poEmail: 'service@sustainablelg.com',
		website: 'sustainablelg.com',
		primaryContactEmail: 'service@sustainablelg.com',
		primaryPhone: '(650) 274-9302',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.54553985595703,
		longitude: -122.29136657714844,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4',
			yelpNumReviews: '75',
			hasCommercialText: true,
		},
		supplierCompanyId: 873,
	},
	{
		id: 888,
		name: 'Torres Landscaping',
		displayName: 'Torres Landscaping',
		status: 'active',
		about:
			'We offer Competitive Rates and Quality Work that you can see.If youre looking for not only a Good Gardener but Great Experience Give us a Try and you will be Completely Satisfied with the Service and Competitive Rates.We Specialize in the following areas        Residential/Commercial Landscape Service-Lawn Mowing -Trimming-Pruning -Leaf Blowing-Sprinkler System Maintenance_____________________________________________________________Landscape Construction-New Lawns Seed or Sod-Sprinkler Systems -Manual or Automatic-Drip Systems -Soaker Systems-Walk Ways -Flower Beds -Lighting______________________________________________________________To Compliment your beautiful lawn we also do-New Fences -Repair Old Fences-Water Falls -Tree Planting-New & Innovative Designs-Gutter Cleaning_______________________________________________________________More Landscaping Services-Pressure Wash -Clean Ups-Lawn Aeration -Fertilizer-Demos -Hauling to the dump -Rotor tilig Established in 2006. This business was founded in 2006. The business is located in Redwood City CA 94063. Omar Torres founded Torres Landscaping in 2006.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '4:30 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '4:30 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '4:30 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '4:30 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '4:30 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [29],
		categoryNames: 'Landscaping and lawn care',
		corporateURL: 'http://www.torreslandscapinginc.com',
		storefrontURL: 'http://www.torreslandscapinginc.com',
		logoURL:
			'https://www.torreslandscapinginc.com/wp-content/themes/torreslandscapinginc/images/instagram-logo.png',
		poEmail: 'info@torreslandscapinginc.com',
		website: 'torreslandscapinginc.com',
		primaryContactEmail: 'info@torreslandscapinginc.com',
		primaryPhone: '(650) 673-7100',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.48522186279297,
		longitude: -122.2363510131836,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4',
			yelpNumReviews: '42',
			hasCommercialText: true,
		},
		supplierCompanyId: 888,
	},
	{
		id: 644,
		name: 'Amaral’s Cleaning Services',
		displayName: 'Amaral’s Cleaning Services',
		status: 'active',
		about:
			'We are specialize on treat each of our clients individually and with special care. The products we use meet the requirements of our clients and respect the environment. Also our professionals are highly qualified with excellent references. Established in 2013. Amarals Cleaning Services is a company that acts on the residential and commercial cleaning segment with highly qualified professionals modern equipment and products that guarantee excellent cleaning without harming the environment. We build a strong relationship with our clients basing our business on honesty and integrity to ensure a long and successful partnership.Our MissionProvide quality services with honesty respecting deadlines and providing maximum comfort and tranquility to our clients. Our VisionAchieve levels of excellence that exceed the expectations of those we serve at attractive prices making us reference as a service provider. Im seeking to build a strong relationship with my clients basing my business on honesty and integrity to ensure a long and successful partnership. My goal is exceed expectations and meet the needs of my clients and ensure the highest quality standards in the services provided.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [20],
		categoryNames: 'Janitorial services',
		corporateURL: 'https://amaralscleaningservices.com',
		storefrontURL: 'https://amaralscleaningservices.com',
		logoURL: 'https://amaralscleaningservices.com/wp-content/uploads/2018/03/logo.svg',
		poEmail: 'regina@amaralscleaningservices.com',
		website: 'amaralscleaningservices.com',
		primaryContactEmail: 'regina@amaralscleaningservices.com',
		primaryPhone: '(415) 867-9013',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.65319061279297,
		longitude: -122.41841125488281,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '1',
			hasCommercialText: true,
		},
		supplierCompanyId: 644,
	},
	{
		id: 670,
		name: 'Blue Angels Cleaning Services',
		displayName: 'Blue Angels Cleaning Services',
		status: 'active',
		about:
			'Post-Construction / Renovation:You can count on Blue Angels Maid Services to help make your properties move-in ready with our post construction dirt dust and debris removal. We offer rough final and touch up construction cleaning services to newly built residential homes condominiums and commercial office and retail buildings.Move in/out Cleaning:If you are preparing for a home lease inspection or new tenant occupancy these services are perfect for you.Commercial Cleaning:If you want to take advantage of our highly regarded and reputable office cleaning services contact us todayWindow Cleaning: Contact the professional window cleaners at Blue Angels Cleaning Services for qualified residential window washing that leaves any glass surface spotless and streak-free!Carpet Cleaning:Our cleaning experts can easily remove stains pet dander and deep-down dirt no matter what carpeting material you have in your home. Established in 2011. We are very friendly family cleaning business providing residential and commercial cleaning in the Bay Area.Seven years ago our housecleaning clients liked what we were doing enough to tell their friends and co-workers about us. Because of their trust in us we have grown our small family-owned company to offer more residential and commercial cleaning services and more staff to get the job done. No project is too small or too big and either way you can be sure that you are getting the best cleaning services around. We are very friendly family cleaning business providing residential and commercial cleaning in the Bay Area.Seven years ago our housecleaning clients liked what we were doing enough to tell their friends and co-workers about us. Because of their trust in us we have grown our small family-owned company to offer more residential and commercial cleaning services and more staff to get the job done. No project is too small or too big and either way you can be sure that you are getting the best cleaning services around.',
		operatingHours: {
			Monday: {
				from: '7:00 am',
				to: '7:00 pm',
			},
			Tuesday: {
				from: '7:00 am',
				to: '7:00 pm',
			},
			Wednesday: {
				from: '7:00 am',
				to: '7:00 pm',
			},
			Thursday: {
				from: '7:00 am',
				to: '7:00 pm',
			},
			Friday: {
				from: '7:00 am',
				to: '7:00 pm',
			},
			Saturday: {
				from: '7:00 am',
				to: '7:00 pm',
			},
			Sunday: {
				from: '7:00 am',
				to: '5:30 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [20],
		categoryNames: 'Janitorial services',
		corporateURL: 'http://www.blueangels.cleaning',
		storefrontURL: 'http://www.blueangels.cleaning',
		logoURL: 'https://blueangels.cleaning/wp-content/uploads/sites/522/2018/01/logoweb.jpg',
		poEmail: 'blueangelsmaidservices@gmail.com',
		website: 'blueangels.cleaning',
		primaryContactEmail: 'blueangelsmaidservices@gmail.com',
		primaryPhone: '(415) 577-9956',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.617008209228516,
		longitude: -122.42578125,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4.5',
			yelpNumReviews: '21',
			hasCommercialText: true,
		},
		supplierCompanyId: 670,
	},
	{
		id: 689,
		name: 'Centurion Janitorial Services',
		displayName: 'Centurion Janitorial Services',
		status: 'active',
		about:
			'Carpet Cleaning Carpet and Floor Installation Commercial Cleaning (Offices Schools Churches etc) Floor Maintenance Handyman Services Interior and Exterior Detailing Moving Services Painting Window Cleaning. Established in 2006. Centurion Services was founded in 2006 in San Francisco California. Currently based in the Peninsula Centurion serves a variety of clients throughout the Bay Area. The clients we serve include commercial buildings such as hospitals clinics schools office buildings fitness centers manufacturing facilities among others. Distinguished by a willingness to provide a highly personalized service and basic hard work Centurion provides its clients with individualized and customized services to meet any maintenance janitorial and handyman service. Consistent communication with Centurions clientele ensures that our technicians are always conforming to the clients needs and high standards. - Raul Vinces (Owner/Founder) Raul Vinces Centurions general manager and founder is responsible for the management direction and business strategy for the company. A highly energetic professional Raul is a life-long learner with a reputation for welcoming challenge and overcoming adversity. Additionally Raul served in United States Navy and continues to as a Navy Reservist. This experience has guided Raul in establishing Centurion Services to provide service solutions with a commitment to excellence and a sound business practice. He is a respected affable team leader with a record of inspiring high morale and productivity.',
		operatingHours: {
			Monday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [20],
		categoryNames: 'Janitorial services',
		corporateURL: 'http://www.centurionsvs.com',
		storefrontURL: 'http://www.centurionsvs.com',
		logoURL: 'http://www.centurionsvs.com///cdn.initial-website.com/s/img/1and1/logo.gif',
		poEmail: 'office@centurionsvs.com',
		website: 'centurionsvs.com',
		primaryContactEmail: 'office@centurionsvs.com',
		primaryPhone: '(415) 505-8070',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.68880081176758,
		longitude: -122.46736907958984,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '1',
			hasCommercialText: true,
		},
		supplierCompanyId: 689,
	},
	{
		id: 696,
		name: 'Colindres Cleaning',
		displayName: 'Colindres Cleaning',
		status: 'active',
		about:
			'Our Cleaning Service Specializes In Deep Cleaning & General Cleaning:HousesApartmentsMove ins/outsSchoolsOfficesRestaurantsCarpet CleaningFloor Stripping & WaxingWindow Washing Commercial and Residential Colindres Cleaning has a reliable work team has been training and retaining a quality work force. Great care is taken to keep our employees trained and regularly informed of changes in policies and procedures. All employees are supervised nightly and are provided formal feedback through scheduled performance evaluations. Established in 2008. Colindres Cleaning is a commercial and residential contractor that provides cleaning services in the Bay Area. We have been serving satisfied customers in San Francisco Daly City Milbrae South San Francisco and Oakland since 2008. We have developed a green cleaning janitorial service by following Green Cleaning & Indoor Environmental standards. Our green cleaning programs addresses issues such as; indoor air quality by using environmentally safe cleaning products. By combining state-of-the-art equipment with a customized service plan Colindres Cleaning assists your facility in making important strides towards economically and effectively maintaining an environmentally healthy workplace. I am a very responsible person and a hard worker.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Saturday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [20],
		categoryNames: 'Janitorial services',
		corporateURL: 'http://colindrescleaning.com',
		storefrontURL: 'http://colindrescleaning.com',
		logoURL: 'http://colindrescleaning.com/public/images/common/logo.png',
		poEmail: 'colindrescleaning@gmail.com',
		website: 'colindrescleaning.com',
		primaryContactEmail: 'colindrescleaning@gmail.com',
		primaryPhone: '(415) 583-5205',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.73386001586914,
		longitude: -122.40477752685547,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4.5',
			yelpNumReviews: '29',
			hasCommercialText: true,
		},
		supplierCompanyId: 696,
	},
	{
		id: 702,
		name: 'Courtesy Cleaning Systems',
		displayName: 'Courtesy Cleaning Systems',
		status: 'active',
		about: 'Commercial Cleaning Servicesfor the San Francisco Bay Area',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '10:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '10:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '10:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '10:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '10:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [20],
		categoryNames: 'Janitorial services',
		corporateURL: 'http://www.courtesycleaning.com',
		storefrontURL: 'http://www.courtesycleaning.com',
		logoURL: 'http://courtesycleaning.com/Images/logo_CourtesyCleaningSystems.jpg',
		poEmail: 'info@courtesycleaning.com',
		website: 'courtesycleaning.com',
		primaryContactEmail: 'info@courtesycleaning.com',
		primaryPhone: '(415) 566-6336',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.75975036621094,
		longitude: -122.47502899169922,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '1',
			hasCommercialText: true,
		},
		supplierCompanyId: 702,
	},
	{
		id: 721,
		name: 'Evelyn Janitorial Cleaning Service',
		displayName: 'Evelyn Janitorial Cleaning Service',
		status: 'active',
		about:
			'Residential CleaningCommercial CleaningMoving in/Moving outHome OrganizingPost Construction Cleaning',
		operatingHours: {},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [20],
		categoryNames: 'Janitorial services',
		corporateURL: 'http://www.evelynjanitorialservice.com',
		storefrontURL: 'http://www.evelynjanitorialservice.com',
		logoURL:
			'http://www.evelynjanitorialservice.com//uploads/1/0/4/5/104539821/published/logo-png-evelyn-janitorial-service-04222017.png',
		poEmail: 'evelynjanitorial@gmail.com',
		website: 'evelynjanitorialservice.com',
		primaryContactEmail: 'evelynjanitorial@gmail.com',
		primaryPhone: '(415) 368-2663',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.71123123168945,
		longitude: -122.457763671875,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4.5',
			yelpNumReviews: '3',
			hasCommercialText: true,
		},
		supplierCompanyId: 721,
	},
	{
		id: 724,
		name: 'Extreme Janitorial',
		displayName: 'Extreme Janitorial',
		status: 'active',
		about:
			'We specialize in Professional Commercial Janitorial Services: Commercial Building Cleaning General Office Cleaning Facility Maintenance Post Construction Clean Up Pressure Wash Window Wash Floor Stripping and Waxing Janitorial Event Staffing and Day Porter Established in 2004. Extreme Janitorial was established in 2004 to fill a void of a professional reliable local Janitorial company. Extreme Janitorial was founded in 2004 by Abel Casanga. We are a local family owned business based in Oakland. We clean a large variety of building types in the greater Bay Area. We provide a full range of cleaning and janitorial services in Offices Retail Restaurants Manufacturing and Industrial Facilities Fitness Clubs Veterinary Clinics and Hospitals and others. All our staff are trained professionals and paid well to ensure they take care of your facilities. We pride ourselves on our fast and accurate quotes so contact us for your contract or one time project and we will respond promptly.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [20],
		categoryNames: 'Janitorial services',
		corporateURL: 'http://www.extremejanitors.com',
		storefrontURL: 'http://www.extremejanitors.com',
		logoURL:
			'https://i0.wp.com/www.extremejanitors.com/wp-content/uploads/2018/03/logo-light.png?fit=431%2C170 class=logo-height-constrain width=431 height=170 alt=Extreme Janitorial Logo srcset=https://i0.wp.com/www.extremejanitors.com/wp-content/uploads/2018/03/logo-light.png',
		poEmail: 'admin@extremejanitors.com',
		website: 'extremejanitors.com',
		primaryContactEmail: 'admin@extremejanitors.com',
		primaryPhone: '(510) 842-8949',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.792850494384766,
		longitude: -122.22592163085938,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '25',
			hasCommercialText: true,
		},
		supplierCompanyId: 724,
	},
	{
		id: 736,
		name: 'Good & Clean',
		displayName: 'Good & Clean',
		status: 'active',
		about:
			'Good & Clean Company Inc is your one-stop shop for all your cleaning needs.Good & Clean Company Inc specializes in: Residential CleaningCommercial CleaningJanitorial ServicesCarpet cleaning Window cleaningOffice cleaningQuality cleaning and great customer service are our number one goals! We can custom tailor a schedule that is well suited for your needs. We are here to make sure that you get all the resources that you are looking for. We offer various cleaning schedules from one-time deep cleaning to daily weekly or even monthly cleaning.We take pride in the work that we do so you can rest assured that you will be receiving high quality results.Good & Clean Company Inc has been in business for over 20 years. We put an importance on paying attention to even the smallest of details. Established in 1996. We are a family run cleaning business that has provided residential and commercial cleaning services to the entire Bay Area for the last 20 years.As of May 29 2014 Good & Clean Co has earned and maintained the prestigious Diamond Certified® award. The Diamond Certified award is presented only to cleaning companies and other local service companies that rate highest in quality in a detailed customer satisfaction study of their customers served during the previous four-year period.Each qualifying business must also pass a license insurance complaint status legal and credit rating (for contractors). To maintain Diamond Certification American Ratings Corporation conducts ongoing customer satisfaction surveys and checks credentials on a regular basis. For over 10 years Jeremy has been running the cleaning company started by his father over 20 years ago. He is dedicated to his staff and clients and works day and night to provide exceptional service.',
		operatingHours: {
			Monday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [20],
		categoryNames: 'Janitorial services',
		corporateURL: 'http://www.goodandcleaninc.com',
		storefrontURL: 'http://www.goodandcleaninc.com',
		logoURL:
			'http://www.goodandcleanco.com/wp-content/uploads/2016/11/logo2-2.png alt=good-clean-co-inc class=img-responsive halfsize ></a><a href=http://www.goodandcleaninc.com style=><img id=logomenureveal http://www.goodandcleanco.com/wp-content/uploads/2016/11/logo2-2.png',
		poEmail: 'info@goodandcleaninc.com',
		website: 'goodandcleaninc.com',
		primaryContactEmail: 'info@goodandcleaninc.com',
		primaryPhone: '(415) 868-9638',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.89802169799805,
		longitude: -122.64031219482422,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4.5',
			yelpNumReviews: '13',
			hasCommercialText: true,
		},
		supplierCompanyId: 736,
	},
	{
		id: 740,
		name: 'Green Living Planet',
		displayName: 'Green Living Planet',
		status: 'active',
		about:
			'Green Living Planet LLC (GLP Janitorial Services) is a leading provider of commercial janitorial services ranging from carpet cleaning to hard floor surface care - all with a green approach.We are consistently improving the quality of our comprehensive cleaning service by incorporating innovative products and technologies into our processes and offering intensive training to our staff. Established in 2011. Green Living Planet LLC is owned by a former Executive at a luxury hotel in San Francisco. As a manager for 12 years at a five star and five diamond hotel we are bringing the high standard of cleaning service customer satisfaction to your commercial property. GLP is here to exceed your cleaning expectations and keep you as a satisfied costumer. We use only the best green commercial products and materials for our customers. As a past Executive at a five star five diamond hotel I am bringing 12 years of experience in cleaning to your commercial properties. I am committed to exceed your cleaning expectations go above and beyond to ensure you are 100% satisfied.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [20],
		categoryNames: 'Janitorial services',
		corporateURL: 'http://www.greenlivingplanet.com',
		storefrontURL: 'http://www.greenlivingplanet.com',
		logoURL: 'http://greenlivingplanet.com/wp-content/uploads/2016/05/logo1.png',
		poEmail: 'info@greenlivingplanet.com',
		website: 'greenlivingplanet.com',
		primaryContactEmail: 'info@greenlivingplanet.com',
		primaryPhone: '(415) 400-5671',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.74568176269531,
		longitude: -122.3877182006836,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '9',
			hasCommercialText: true,
		},
		supplierCompanyId: 740,
	},
	{
		id: 773,
		name: 'JJ & CC Commercial Janitorial',
		displayName: 'JJ & CC Commercial Janitorial',
		status: 'active',
		about:
			'At JJ & CC we are dedicated to getting your commercial property cleaned to your expectations. From offices to schools and from warehouses to industrial plants we are here to provide you with exceptional cleaning and outstanding customer service. Established in 1992. JJ&CC Maintenance Services is family owned and operated. We have performed extensive maintenance work throughout California since 1992. You can count on us to provide you with the best one-stop maintenance services because:* We listen to your individual needs and identify problems* Consistently provide quality service and attention to detail* We have appropriately compensated and motivated staff* We have well organized management and labor* Our personnel are professionally uniformed* We use modern and new equipment* We have trained and supervised personnel Focused on proving great cleaning service and customer service every time.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Saturday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [20],
		categoryNames: 'Janitorial services',
		corporateURL: 'http://jjccservices.com',
		storefrontURL: 'http://jjccservices.com',
		logoURL: 'http://www.jjccservices.com/wp-content/uploads/2017/03/mainwebsitelogo.jpg',
		poEmail: 'info@jjccservices.com',
		website: 'jjccservices.com',
		primaryContactEmail: 'info@jjccservices.com',
		primaryPhone: '(415) 800-2232',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.77827835083008,
		longitude: -122.4243392944336,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '3',
			hasCommercialText: true,
		},
		supplierCompanyId: 773,
	},
	{
		id: 791,
		name: 'Lustran Cleaning Services',
		displayName: 'Lustran Cleaning Services',
		status: 'active',
		about:
			'Our company provides exceptional residential and commercial cleaning services in the Bay Area and we are committed to providing a high level of professionalism and attention to detail. Lustran Cleaning Services offers clients the options of a General Deep or Green Cleaning. Our specialty the Deep Cleaning is considered an extreme makeover where we uncover layers of dirt and grime that have unnoticeably collected for many years (often changing the color and texture of many surfaces in your home). With Lustran Cleaning Services you almost re-discover your home! **PLEASE NOTE: Prior to providing any estimates its important for us to inspect your home or office to fully understand the level of cleaning required as well as the type of materials and finishes in the bathroom kitchen and on the floors. Established in 1995. Lustran Cleaning Services has been providing its many longstanding and dedicated clients in the S.F. Bay Area with exceptional residential & commercial cleaning services for over 17 years. Originally from Brazil Fernando is both hardworking and a perfectionist at heart. He believes in doing the best job possible on each and every house that he and his staff work in and he stands by the results of the companys work.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [20],
		categoryNames: 'Janitorial services',
		corporateURL: 'http://www.lustrancleaning.com',
		storefrontURL: 'http://www.lustrancleaning.com',
		logoURL: 'http://lustrancleaning.com/wp-content/uploads/2017/08/lustrancleaning-logo2.png',
		poEmail: 'info@lustrancleaning.com',
		website: 'lustrancleaning.com',
		primaryContactEmail: 'info@lustrancleaning.com',
		primaryPhone: '(415) 529-1276',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.787750244140625,
		longitude: -122.438232421875,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '67',
			hasCommercialText: true,
		},
		supplierCompanyId: 791,
	},
	{
		id: 809,
		name: 'Natural Maidens',
		displayName: 'Natural Maidens',
		status: 'active',
		about:
			'We are environmentally conscious in regards to cleaning your home or office. We are recognized through the San Francisco Green Business for meeting their stringent environmental standards. Established in 2008. Natural Maidens was founded in early 2008 by Katie E. After struggling herself to find an ideal cleaning service she decided there was a need to fill in the San Francisco area. No more asphyxiating products. No more guessing at what will be included in your cleaning package! Quickly the sprout of an idea came to fruition: she found a few dependable cleaners and her home became a chemistry lab of natural potions and aromatic oils. Starting out with homes of friends and then building professional relationships one at a time Natural Maidens has now expanded to clean more than 600 homes on a regular basis. And were still visiting new homes on a daily.',
		operatingHours: {
			Monday: {
				from: '8:30 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '8:30 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '8:30 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '8:30 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '8:30 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [20],
		categoryNames: 'Janitorial services',
		corporateURL: 'http://www.naturalmaidens.com',
		storefrontURL: 'http://www.naturalmaidens.com',
		logoURL:
			'http://www.naturalmaidens.com/wp-content/uploads/2017/03/naturalMaidensLogo_70h.png data-retina=http://www.naturalmaidens.com/wp-content/uploads/2017/03/naturalMaidensLogo_140h.png',
		poEmail: 'info@naturalmaidens.com',
		website: 'naturalmaidens.com',
		primaryContactEmail: 'info@naturalmaidens.com',
		primaryPhone: '(415) 563-5063',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.77101135253906,
		longitude: -122.4124984741211,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4.5',
			yelpNumReviews: '312',
			hasCommercialText: true,
		},
		supplierCompanyId: 809,
	},
	{
		id: 835,
		name: 'Reyes Cleaning Services',
		displayName: 'Reyes Cleaning Services',
		status: 'active',
		about:
			'Office cleaning post construction cleanupBuilding maintenance handy man business and residential cleaning..move outs move insCarpet cleaning. Pressure washing. Window washing. And more Established in 2006. Cleaning business that specialized in commercial and residential properties and carpet cleaning and installation. Serving all of the San Francisco Bay Area Peninsula North Bay South Bay and East Bay 24/7. janitorial servicesReyes Cleaning servicescan do all the cleaning for you',
		operatingHours: {},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [20],
		categoryNames: 'Janitorial services',
		corporateURL: 'http://www.reyesrcs.com',
		storefrontURL: 'http://www.reyesrcs.com',
		logoURL:
			'http://www.reyesrcs.com/wp-content/uploads/2014/11/reyes-residential-and-comercial-cleaning-services-logo-290.png',
		poEmail: 'reyescleaningservices.rcs@gmail.com',
		website: 'reyesrcs.com',
		primaryContactEmail: 'reyescleaningservices.rcs@gmail.com',
		primaryPhone: '(415) 375-1700',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.76472091674805,
		longitude: -122.43193817138672,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4',
			yelpNumReviews: '15',
			hasCommercialText: true,
		},
		supplierCompanyId: 835,
	},
	{
		id: 844,
		name: 'S & J Cleaning Services',
		displayName: 'S & J Cleaning Services',
		status: 'active',
		about:
			'We specialize in house cleaning services commercial cleaning services window cleaning carpet cleaning and hauling. We work closely to the biggest realty services in the Bay Area providing them with services as Open House Cleaning Support . Established in 1996. Being in this business since 1996 where we started as a house cleaning service and gradually grew into the commercial and real state businesses.',
		operatingHours: {},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [20],
		categoryNames: 'Janitorial services',
		corporateURL: 'http://www.sjcleaningservices.com',
		storefrontURL: 'http://www.sjcleaningservices.com',
		logoURL:
			'http://sjcleaningservices.com/wp-content/plugins/wp-yelp-review-slider/public/partials/imgs/yelp_outline.png alt= class=wpyelp_t1_yelp_logo></a>\t\t\t</div><span class=wpyelp_t1_A_8><img https://s3-media2.fl.yelpcdn.com/assets/srv0/yelp_styleguide/514f6997a318/assets/img/default_avatars/user_60_square.png',
		poEmail: 'contact@sjcleaningservices.com',
		website: 'sjcleaningservices.com',
		primaryContactEmail: 'contact@sjcleaningservices.com',
		primaryPhone: '(415) 860-4882',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 38.027000427246094,
		longitude: -122.54859161376953,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '10',
			hasCommercialText: true,
		},
		supplierCompanyId: 844,
	},
	{
		id: 846,
		name: 'Sba Janitorial Services',
		displayName: 'Sba Janitorial Services',
		status: 'active',
		about:
			'SBA Janitorial Services is a janitorial based company set on providing excellent customer service and piece of mind to our customers. SBA offers a full range of janitorial services for both residential and commercial properties including floors (vacuuming strip & wax etc) window cleaning and even laboratory clean rooms and hazardous materials. Established in 2008. SBA Janitorial Services started in 2008 with the goal of being the Bay Areas premiere service for all of your janitorial services. With a wide range of cleaning services SBA Janitorial Services is your go to service company for all cleaning jobs big or small and for your home business or any where else that could use a good wipe down. Our staff of professionals are polite and friendly. And when you need a special touch for more extreme conditions we have staff who are hazardous waste certified. We at SBA Janitorial Services know what our clients want! Great customer service hard work and a clean place to work/relax. All at an affordable price! We have it all!',
		operatingHours: {},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [20],
		categoryNames: 'Janitorial services',
		corporateURL: 'http://sbajanitorial.com',
		storefrontURL: 'http://sbajanitorial.com',
		logoURL: 'http://linknow.com/linknow_images/linknow-logo-white.png',
		poEmail: 'sbaservicesca@gmail.com',
		website: 'sbajanitorial.com',
		primaryContactEmail: 'sbaservicesca@gmail.com',
		primaryPhone: '(707) 364-5000',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 38.24742126464844,
		longitude: -122.63475036621094,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '3',
			hasCommercialText: true,
		},
		supplierCompanyId: 846,
	},
	{
		id: 851,
		name: 'ServiceMaster Janitorial Services',
		displayName: 'ServiceMaster Janitorial Services',
		status: 'active',
		about:
			'Appointments available for commercial/office cleaning only.Hard surface cleaning.Carpet and upholstery cleaning for businessTile and grout cleaning for business.Post construction cleaningWarehouse cleaning Established in 2010. We started this business more than 3 years ago. It was difficult at first to live upto the ServiceMaster standard but we did it. We rose to the top and made sure our services are unmatched by any other companies out there. I have always been people person. I love seeing the satisfaction that people get after they receive my services. I got into the business world since I was in my high school. After that there was no turning back. I worked my way up and finally established this business which is a leading name in the cleaning industry. I make sure that my services are unmatched. I train my employees personally and also work with them making sure that they know the importance of customer satisfaction. So far we have been able to live up to our expectations. We will make sure that we continue doing better and better.',
		operatingHours: {
			Monday: {
				from: '7:00 am',
				to: '9:00 pm',
			},
			Tuesday: {
				from: '7:00 am',
				to: '9:00 pm',
			},
			Wednesday: {
				from: '7:00 am',
				to: '9:00 pm',
			},
			Thursday: {
				from: '7:00 am',
				to: '9:00 pm',
			},
			Friday: {
				from: '7:00 am',
				to: '9:00 pm',
			},
			Saturday: {
				from: '7:00 am',
				to: '9:00 pm',
			},
			Sunday: {
				from: '7:00 am',
				to: '9:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [20],
		categoryNames: 'Janitorial services',
		corporateURL: 'http://www.smjanitorialservices.com',
		storefrontURL: 'http://www.smjanitorialservices.com',
		logoURL:
			'http://smjanitorialservices.com/wp-content/uploads/2017/04/smjanitorial-services-logo.png',
		poEmail: 'info@smjanitorialservices.com',
		website: 'smjanitorialservices.com',
		primaryContactEmail: 'info@smjanitorialservices.com',
		primaryPhone: '(510) 521-2717',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.761680603027344,
		longitude: -122.25463104248047,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '4',
			hasCommercialText: true,
		},
		supplierCompanyId: 851,
	},
	{
		id: 630,
		name: 'A FEDAIR',
		displayName: 'A FEDAIR',
		status: 'active',
		about:
			'We offer you all the services you need and more. Our trained and skilled technicians are experts in all aspects of HVAC system design installation service and maintenance. We provide reliable repair service and installation of all major home and commercial HVAC systems. Our goal is to provide fast reliable and affordable service. You can always schedule same day appointment at no-additional charge. Always FREE service call with repair or installation. Our HVAC repair service technicians are dependable courteous and always professional.Our Services include:New InstallationsChange outCentral Air Conditioning and HeatingMini Split System (ductless unit)Central HeatersHeat Pump UnitsRepair and Service on all brand A/C and heatingFloor Gravity or Wall Heaters.We do NOT Repair or Install:-Window or Wall Air ConditioningAll repair works come with warranty.10% off labor for the new customers',
		operatingHours: {
			Monday: {
				from: '7:30 am',
				to: '7:00 pm',
			},
			Tuesday: {
				from: '7:30 am',
				to: '7:00 pm',
			},
			Wednesday: {
				from: '7:30 am',
				to: '7:00 pm',
			},
			Thursday: {
				from: '7:30 am',
				to: '7:00 pm',
			},
			Friday: {
				from: '7:30 am',
				to: '7:00 pm',
			},
			Saturday: {
				from: '7:30 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [17],
		categoryNames: 'HVAC maintenance',
		corporateURL: 'http://afedair.com',
		storefrontURL: 'http://afedair.com',
		logoURL: 'http://afedair.com/images/logo.png',
		poEmail: 'afedair@gmail.com',
		website: 'afedair.com',
		primaryContactEmail: 'afedair@gmail.com',
		primaryPhone: '(408) 607-0005',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.13050079345703,
		longitude: -121.65438842773438,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '14',
			hasCommercialText: true,
		},
		supplierCompanyId: 630,
	},
	{
		id: 634,
		name: 'Action Plumbing & Heating Maintenance',
		displayName: 'Action Plumbing & Heating Maintenance',
		status: 'active',
		about:
			'Servicing all your plumbing heating gas water and sewer needs. At Action Plumbing & Heating Maintenance you can count on us for professional advice top quality work and comprehensive service - even after your project is complete. We guarantee the quality of our work 100% and provide a full warranty for every service we offer. Our customers trust is a source of great pride and inspires us to keep improving our business. We use the industrys most current technology and our technicians undergo advanced training. Were prepared to help you with any questions you may have or any situations you may encounter. Were also committed to offering environmentally friendly products and services.For more information or if you need assistance please feel free to give us a call. Our phones are staffed 24 hours a day so you can always talk to a live person even outside of our normal business hours. Were looking forward to working with you! Established in 1972. Were proud to have served Santa Rosa and surrounding areas for over 40 years. Were a locally-owned company and were committed to supporting and helping our local community.',
		operatingHours: {},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [17],
		categoryNames: 'HVAC maintenance',
		corporateURL: 'http://www.actionplumbingandheating.biz',
		storefrontURL: 'http://www.actionplumbingandheating.biz',
		logoURL: 'http://static.sites.yp.com/templates/creator/m_c/c2/c24/8444/assets/logo.jpg',
		poEmail: 'dalecrane@sbcglobal.net',
		website: 'actionplumbingandheating.biz',
		primaryContactEmail: 'dalecrane@sbcglobal.net',
		primaryPhone: '(707) 584-0714',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 38.37997817993164,
		longitude: -122.711669921875,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4.5',
			yelpNumReviews: '70',
			hasCommercialText: true,
		},
		supplierCompanyId: 634,
	},
	{
		id: 637,
		name: 'Air Flow Pros Heating And Air Conditioning',
		displayName: 'Air Flow Pros Heating And Air Conditioning',
		status: 'active',
		about:
			'As a Diamond Certified company Air Flow Pros specializes in proven exceptional customer satisfaction and professionalism. A list of our specialty areas of expertise reviews (verbatim customer responses) video profile and independent rating details are all available on our online Diamond Certified report. We are experienced technicians and installers specializing in heatingA/C and refrigeration. We work on both the commercial and residential side of the industry offering all of our customers the highest quality of service. Established in 2009. As of March 15 2011 and every year since Air Flow Pros has earned and maintained the prestigious Diamond Certified award which is only presented to heating & air conditioning contractors and other local service companies that rate highest in quality in a detailed customer satisfaction study of their customers.Each qualifying business must also pass a license insurance complaint status legal and credit rating (for contractors). To maintain Diamond Certification American Ratings Corporation conducts ongoing customer satisfaction surveys and checks credentials on a regular basis.',
		operatingHours: {},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [17],
		categoryNames: 'HVAC maintenance',
		corporateURL: 'http://www.afpheating.com/',
		storefrontURL: 'http://www.afpheating.com/',
		logoURL: 'http://www.afpheating.com//images/afp-logo.png',
		poEmail: 'service@afpheating.com',
		website: 'afpheating.com',
		primaryContactEmail: 'service@afpheating.com',
		primaryPhone: '(415) 400-5140',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.75590133666992,
		longitude: -122.4294204711914,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '275',
			hasCommercialText: true,
		},
		supplierCompanyId: 637,
	},
	{
		id: 638,
		name: 'AJ Appliance & Refrigeration Repair',
		displayName: 'AJ Appliance & Refrigeration Repair',
		status: 'active',
		about:
			'We are a factory authorized appliance service dealer. We do the repairs for washers dryers wine coolers ice machines refrigerators trash compactors dishwashers cook tops and ovens.AmanaBoschCrosleyGaggenauJenn-AirKenmoreKitchen aidMarvelMaytagRoperSiemensThermadorVikingWhirlpool Established in 1990. Established 27 years ago as a small independently run appliance repair company AJ Appliance has grown into a factory authorized leader in the appliance industry servicing the Bay Area. Our technicians are all EPA certified and have been in the industry for more than 34 years. AJ Appliance prides itself on being a great example of the American Dream with many technicians relocating to the Bay Area for a better life and working their hardest each day to provide the best service for their customers. *English and Spanish Speaking Technicians and Secretaries Jaime the founder of AJ Appliance has worked in the appliance repair industry since he was 18 years old. As a young man from Peru he desired a great life for himself in the United States gratefully working in his chosen field. His dream was realized when he eventually started his own company and employed other skilled appliance repair technicians. Jaime believes in quick qualified and respectful service from all company employees in order for the customer to have the best experience possible.',
		operatingHours: {
			Monday: {
				from: '7:30 am',
				to: '6:00 pm',
			},
			Tuesday: {
				from: '7:30 am',
				to: '6:00 pm',
			},
			Wednesday: {
				from: '7:30 am',
				to: '6:00 pm',
			},
			Thursday: {
				from: '7:30 am',
				to: '6:00 pm',
			},
			Friday: {
				from: '7:30 am',
				to: '6:00 pm',
			},
			Saturday: {
				from: '9:00 am',
				to: '3:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [17],
		categoryNames: 'HVAC maintenance',
		corporateURL: 'http://www.ajapplianceservice.com',
		storefrontURL: 'http://www.ajapplianceservice.com',
		logoURL: 'http://www.ajapplianceservice.com/images/logo.jpg',
		poEmail: 'ajappliance@sbcglobal.net',
		website: 'ajapplianceservice.com',
		primaryContactEmail: 'ajappliance@sbcglobal.net',
		primaryPhone: '(650) 347-0104',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.571529388427734,
		longitude: -122.26107025146484,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4.5',
			yelpNumReviews: '95',
			hasCommercialText: true,
		},
		supplierCompanyId: 638,
	},
	{
		id: 661,
		name: 'Barker Heating & Cooling',
		displayName: 'Barker Heating & Cooling',
		status: 'active',
		about:
			'Need your heater or air conditioner fixed today? We will come out and provide you an upfront price to repair your system and get it operational today by one of our trained experts. We provide the best warranty in the bay area with 10 years equipment and material on new systems and up to 6 years on repairs.We offer free estimates on new heating and air conditioning systems we will also apply our service charge towards any authorized repair if your system is not working and we never do work without your approval.We make sure your home stays clean and safe by sending out background checked experts that wear shoe covers and protect your home during the repair. Established in 1996. Barker Mechanical Services was established in 1996 by Joe Barker. Who has 45 years experience in the Heating and Air Conditioning business. Barker Mechanical was started to provide high quality service and installation services like the larger competitors in the area but mix it with small business focused and personalized service that you can only do with operating a small focus driven team.Barker Mechanical has kept many of the same faces that you would of come across in 96 that you would see still today. This has helped us provide the consistent quality of service that Joe had envisioned back then. A second generation heating & air conditioning contractor. Christopher has been working in the Dublin and surrounding areas since 2000 where he learned the family business from his father working in the bay area since the 1980s. He and his team specialize in advising customers on short term solutions and long term solutions to clients comfort needs showing the benefit of each option short and long term to make sure the client gets the best value for there dollar.When not working youll probably find him at the local Amador Valley dog park in Dublin with his pug Frank and is always happy to give advise and recommendations on home owners comfort issues.',
		operatingHours: {
			Monday: {
				from: '7:00 am',
				to: '7:00 pm',
			},
			Tuesday: {
				from: '7:00 am',
				to: '7:00 pm',
			},
			Wednesday: {
				from: '7:00 am',
				to: '7:00 pm',
			},
			Thursday: {
				from: '7:00 am',
				to: '7:00 pm',
			},
			Friday: {
				from: '7:00 am',
				to: '7:00 pm',
			},
			Saturday: {
				from: '9:00 am',
				to: '1:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [17],
		categoryNames: 'HVAC maintenance',
		corporateURL: 'http://www.callbarker.com',
		storefrontURL: 'http://www.callbarker.com',
		logoURL: 'http://callbarker.com/wp-content/themes/barker/images/main_logo.png',
		poEmail: 'service@barkerms.com',
		website: 'callbarker.com',
		primaryContactEmail: 'service@barkerms.com',
		primaryPhone: '(925) 359-9445',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.71015930175781,
		longitude: -121.9139633178711,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4.5',
			yelpNumReviews: '58',
			hasCommercialText: true,
		},
		supplierCompanyId: 661,
	},
	{
		id: 677,
		name: 'Buffalo’s Mechanical',
		displayName: 'Buffalo’s Mechanical',
		status: 'active',
		about:
			'Buffalos Mechanical Inc. is a Mechanical HVAC Contractor serving Northern/Central California by providing quality construction and service to our clients for over 20 years. We have extensive mall/retail experience and specialize in fast track projects. We are located in Northern California with offices in the Central Valley (Modesto) and the San Francisco Bay Area (Sunnyvale). Our territory starts at Bakersfield and goes through Northern California including the Bay Area Central California Fresno area Santa Rosa area and Sacramento Region.Some of the retail clients that we worked for in 2014-15 include: Aeropostale 5 Guys Burgers Americas Tire Company Apple Autozone Best Buy Big 5 Chase Bank Chevron CVS Pharmacy Dollar General Dollar Tree Footlocker Fresh & Easy Market Gap Inc. Hollister Jamba Juice Juicy Couture Old Navy Office Depot McDonalds NIKE Panera Bread Peets Coffee and Tea Petco Pet Food Express Sprouts Market Starbucks Target Established in 1995. Buffalos Mechanical Inc. is a commercial/industrial Mechanical Contractor serving Northern/Central California by providing quality HVAC construction and service since 1995. Our company philosophy is simple... provide quality work on time at a competitive price.Our offices trucks and team are equipped with the latest technology. We have the latest PCs and Apple Desktops mobile devices cable internet and full color plotters for printing at our facilities. We utilize the latest software and technology handling all facets of our business. Jason Buffalow was raised in the sheet metal /HVAC/refrigeration industry. His grandfather Henry Buffalow started Buffalows in 1948 as a commercial refrigeration company in Mt. View CA. In the late 1960s his father Henry Buffalow Jr. took over the family business and ran it for nearly twenty five years. Jason learned the basics of the HVAC industry and witnessed first hand how to run a successful company. In the mid 1990s Jason began working for a few smaller mechanical contractors before starting Buffalos Mechanical Inc. in 1995.Over the last 18 years this company has experienced controlled growth from 4 residential/light commercial installers to the medium sized commercial shop that it is today. Jason keeps his primary focus on taking good care of his customers employees vendors and making business decisions based on what is right not costs.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [17],
		categoryNames: 'HVAC maintenance',
		corporateURL: 'http://www.buffac.com',
		storefrontURL: 'http://www.buffac.com',
		logoURL: 'http://www.buffac.com/wp-content/uploads/2015/02/Buff_Logo_Top1.png',
		poEmail: 'jb@buffac.com',
		website: 'buffac.com',
		primaryContactEmail: 'jb@buffac.com',
		primaryPhone: '(209) 599-1700',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.735469818115234,
		longitude: -121.124267578125,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '1',
			hasCommercialText: true,
		},
		supplierCompanyId: 677,
	},
	{
		id: 698,
		name: 'Comfort International',
		displayName: 'Comfort International',
		status: 'active',
		about:
			'Comfort International is an energy efficiency organization exclusively focused on achieving peak efficiencies with existing commercial buildings. We identify unique and effective solutions that permanently decrease recurring operational cost directly related to heating ventilation air conditioning and lighting in your workplace environment. We will increase workplace comfort while positively impacting your bottom-line as well as the environment. Employing experienced engineers and highly skilled HVAC technicians we provide turnkey solutions supported by investment grade studies and guaranteed results. We achieve measurable reduction in energy consumption (kWh/therms) typically with a return on investment (ROI) of less than two years. If our targeted ROI is not realized in post implementation utility bills then CI will make up the difference. We also provide HVAC maintenance and service for commercial buildings and achieve LEED & Energy Star Certification services. Established in 2003. Comfort International Inc. was created by Alan Pong whom has been in the HVAC and Energy Management industry since 1989. We bring the experience of professional engineers energy management experts & journeyman HVAC service technicians. Our clients have achieved the lowest metrics in energy consumption in commercial facilities without having to replace expensive systems typically reducing energy consumption 20% to over 50% on existing HVAC systems. Comfort Internationals clients realize a payback in 2 years or less without disrupting operations.Virtually every type of facility can realize cost savings -- We have an extensive experience in energy management and HVAC maintenance range from corporate headquarter /office facilities to highly critical manufacturing / FAB / clean room / data center facilities.We have been awarded numerous PG & E awards for achieving the largest energy savings in commercial buildings. In 2012 we achieved the largest PG & E rebate in Silicon Valley',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [17],
		categoryNames: 'HVAC maintenance',
		corporateURL: 'http://www.comfortintl.com',
		storefrontURL: 'http://www.comfortintl.com',
		logoURL: 'http://www.comfortintl.com///comfortintl.com/wp-content/uploads/2018/02/CII_logo.jpg',
		poEmail: 'sales@comfortintl.com',
		website: 'comfortintl.com',
		primaryContactEmail: 'sales@comfortintl.com',
		primaryPhone: '(888) 518-1118',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.38526153564453,
		longitude: -121.92485046386719,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '1',
			hasCommercialText: true,
		},
		supplierCompanyId: 698,
	},
	{
		id: 708,
		name: 'Cyclone Air Systems',
		displayName: 'Cyclone Air Systems',
		status: 'active',
		about:
			'Cyclone Air Systems Since 1999 Were proud of our company and we enjoy a fine reputation for integrity and performance in the Air Duct Cleaning Carpet Upholstery Cleaning Chimney-Fireplace Sweeping Furnace Heater Air Conditioner Repairs and Maintenance Tune-ups industry with a strong customer base. With more than 14 years in the Air Duct Cleaning  Carpet Cleaning & Upholstery Cleaning We offer a variety of services including tile and grout cleaning presurre washing mold remediation and fire and water damage restoration. In the process we only use environmentally friendly cleaning solutions and state-of-the-art cleaning equipment. All our technician are professionally trained & certified. Cyclone Air Systems Licensed Insured & Member of Better Business Bureau. Established in 1999. We use only environmentally-friendly cleaning solutions andstate-of-the-art cleaning equipment. All of our technicians areprofessionally trained and certified. My father and I started this business together. Previously I was workingat an air duct company and we decided to start our own business with a focuson customer service. We value our good reputation and the relationships webuild with our customers.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '9:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '9:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '9:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '9:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '9:00 pm',
			},
			Saturday: {
				from: '8:00 am',
				to: '9:00 pm',
			},
			Sunday: {
				from: '8:00 am',
				to: '9:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [17],
		categoryNames: 'HVAC maintenance',
		corporateURL: 'http://www.cycloneairsystems.com/',
		storefrontURL: 'http://www.cycloneairsystems.com/',
		logoURL: 'http://www.cycloneairsystems.com//images/logo.gif',
		poEmail: 'info@cycloneairsystems.com',
		website: 'cycloneairsystems.com',
		primaryContactEmail: 'info@cycloneairsystems.com',
		primaryPhone: '(888) 870-1166',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.76182174682617,
		longitude: -122.39859008789062,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '262',
			hasCommercialText: true,
		},
		supplierCompanyId: 708,
	},
	{
		id: 764,
		name: 'Izmirian Roofing & Sheet Metal',
		displayName: 'Izmirian Roofing & Sheet Metal',
		status: 'active',
		about:
			'For 90 years family owned and operated Izmirian has provided quality residential and commercial roofing heating air conditioning and sheet metal work to homeowners and businesses on the San Francisco Peninsula. Established in 1924. A tradition of quality was begun in 1924 when the company was founded by Charles Izmirian. Today his grandsons Luther Jr. and Richard continue the dedication to service instilled in them by their father Luther Izmirian.Generations of Peninsula customers have come to trust izmirian for quality products and service.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [17],
		categoryNames: 'HVAC maintenance',
		corporateURL: 'http://izmirian.com',
		storefrontURL: 'http://izmirian.com',
		logoURL: 'http://izmirian.com/dev/wp-content/uploads/2015/02/izmirian_logo.png',
		poEmail: 'support@izmirian.com',
		website: 'izmirian.com',
		primaryContactEmail: 'support@izmirian.com',
		primaryPhone: '(650) 342-3200',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.56660842895508,
		longitude: -122.32199096679688,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4',
			yelpNumReviews: '25',
			hasCommercialText: true,
		},
		supplierCompanyId: 764,
	},
	{
		id: 776,
		name: 'JW Hanson Heating and Air',
		displayName: 'JW Hanson Heating and Air',
		status: 'active',
		about:
			'We are a family owned HVAC and radiant heating company in Santa Rosa. We specialize in high efficiency equipment zone systems and warm floors. Established in 2005. We are a family owned and operated company out of Santa Rosa. We specialize in all indoor comfort needs whether it is heating air conditioning indoor air quality or radiant heating. We pride ourselves in our honesty knowledge and customer service and will go out of our way to make sure you are completely satisfied. We started our business in 2005 with the ultimate goal of offering the best quality and customer service in the industry. We just celebrated our 13th Anniversary and would like to think that we have not only met but surpassed this goal.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '4:30 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '4:30 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '4:30 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '4:30 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '4:30 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [17],
		categoryNames: 'HVAC maintenance',
		corporateURL: 'http://www.hansonheatingandair.com/',
		storefrontURL: 'http://www.hansonheatingandair.com/',
		logoURL: 'http://hansonheatingandair.com/wp-content/uploads/2016/10/logo.png',
		poEmail: 'kim@hansonheatingandair.com',
		website: 'hansonheatingandair.com',
		primaryContactEmail: 'kim@hansonheatingandair.com',
		primaryPhone: '(707) 538-3329',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 38.39881134033203,
		longitude: -122.7220687866211,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '46',
			hasCommercialText: true,
		},
		supplierCompanyId: 776,
	},
	{
		id: 777,
		name: 'K & R Heating and Air Conditioning Service',
		displayName: 'K & R Heating and Air Conditioning Service',
		status: 'active',
		about:
			'Residential & Commercial Heating/ Air Conditioning/Refrigeration Established in 2014. Our Company has more than 35 years experience in the HVAC-R Industry! BBB Accredited Licensed and Insured100% Satisfaction Guaranteed or Your Money Back!',
		operatingHours: {
			Monday: {
				from: '6:00 am',
				to: '10:00 pm',
			},
			Tuesday: {
				from: '6:00 am',
				to: '10:00 pm',
			},
			Wednesday: {
				from: '6:00 am',
				to: '10:00 pm',
			},
			Thursday: {
				from: '6:00 am',
				to: '10:00 pm',
			},
			Friday: {
				from: '6:00 am',
				to: '10:00 pm',
			},
			Saturday: {
				from: '6:00 am',
				to: '10:00 pm',
			},
			Sunday: {
				from: '6:00 am',
				to: '10:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [17],
		categoryNames: 'HVAC maintenance',
		corporateURL: 'http://krheatingandair.com',
		storefrontURL: 'http://krheatingandair.com',
		logoURL:
			'http://www.krheatingandair.com/wp-content/uploads/2016/05/KR_Logo21.png alt= data-g1-src-desktop=http://www.krheatingandair.com/wp-content/uploads/2016/05/KR_Logo21.png data-g1-src-desktop-hdpi=http://www.krheatingandair.com/wp-content/uploads/2016/05/KR_Logo21.png',
		poEmail: 'info@kandrheatingandair.com',
		website: 'krheatingandair.com',
		primaryContactEmail: 'info@kandrheatingandair.com',
		primaryPhone: '(925) 798-5088',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.93096923828125,
		longitude: -121.97563171386719,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '2',
			hasCommercialText: true,
		},
		supplierCompanyId: 777,
	},
	{
		id: 779,
		name: 'Kit Appliance Repair',
		displayName: 'Kit Appliance Repair',
		status: 'active',
		about:
			'Kit Appliance Repair provides repair service for all major home and commercial appliances as well as HVAC repair and installation. Our repair techs are highly trained and certified professionals who are knowledgeable and experienced in repairing all brands and models of all major appliances and HVAC equipment. With the latest equipment and a highly experienced staff we have the tools to handle any task big or small. Our commitment is to creating long-term relationships with our clients by providing quality without compromise and to that effect we promise to never leave a job that has not been executed to your complete satisfaction.We service and repair throughout San Francisco San Jose Marine County San Mateo County and Santa Clara County.Kit Appliance Repair offers:- Same or next day appointment- 10% off labor for new customers- Unconditional 1-year warranty on parts- Free service calls upon repair- Competitive prices.Our Appliance Services include:- Fridge / Freezer repair- Cooktop / Rangetop repair- Oven / Double oven repair- Stove / Range- Wine cooler repair- Range hood repair- Icemaker repair- Dryer / Washer repair- BBQ / Grill repair- Warming drawerOur HVAC Services include repair and installation of:- Gas Furnace - Heat pump- Central AC- Wall heaterWe do NOT Repair or Install:- Car AC- Window AC- Dishwashers- Microwaves Established in 2007. Kit Appliance Repair started out in 2007 as a small family business. Repairing small appliances at the lowest cost. Slowly we switched over to bigger appliance and HVAC systems repair service. We appreciate your business and care about your satisfaction. Our business was founded upon the belief that customers deserve fast professional and honest service. We know its not easy to go by with a broken appliance or HVAC equipment so we make every effort to provide you with dependable repair service and fair pricing. When you call Kit Appliance Appliance Repair you can rest assured that you will receive a prompt and courteous attention with exceptionally helpful honest and extremely knowledgeable professionals. All of our service technicians are factory trained and highly experienced. Our technicians will work cleanly and respectfully with a focus on customer service. They will patiently explain what they are doing and why.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
			Saturday: {
				from: '8:00 am',
				to: '6:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [17],
		categoryNames: 'HVAC maintenance',
		corporateURL: 'https://www.kitappliancerepair.com',
		storefrontURL: 'https://www.kitappliancerepair.com',
		logoURL: 'https://www.kitappliancerepair.com/wp-content/uploads/2018/02/kit-logo-gray.png',
		poEmail: 'contact@kitappliancerepair.com',
		website: 'kitappliancerepair.com',
		primaryContactEmail: 'contact@kitappliancerepair.com',
		primaryPhone: '(650) 770-9009',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.3785400390625,
		longitude: -122.08657836914062,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '8',
			hasCommercialText: true,
		},
		supplierCompanyId: 779,
	},
	{
		id: 839,
		name: 'Right Now Air & Solar',
		displayName: 'Right Now Air & Solar',
		status: 'active',
		about:
			'Heating Air Conditioning & solar. With nearly 3 decades of experience serving people just like you Right Now Air Inc. can ensure the best solution for your heating and air conditioning needs. We offer service in Solano Contra Costa Sacramento and Napa counties. Our technicians have over 300 hours of training with Trane and PG&E in addition to in house training. Our 100% client satisfaction is achieved from caring and you will feel that from your first call. We offer same day service and we are available 7 days a week. Emergency services available so call us anytime your in need. Established in 2001. President and C.E.O. John Neuman started his heating and air conditioning career after graduating from Utica High School in Michigan. Shortly after graduating he met his wife of 23 years and moved to sunny California. He was hired on with a local Solano based heating and air conditioning company and worked his way up to general manager. After 12 years of dedicated service he found the company unwilling to adapt or change and had lost the values of customer service. At that time John devoted himself to building more than just a heating and air conditioning company. As his personal guarantee John invites you to give him a call at 707-590-0045 for any reason positive or negative as your feedback is always important. President and C.E.O. John Neuman started his heating and air conditioning career after graduating from Utica High School in Michigan. Shortly after graduating he met his wife of 23 years and moved to sunny California. He was hired on with a local Solano based heating and air conditioning company and worked his way up to general manager. After 12 years of dedicated service he found the company unwilling to adapt or change and had lost the values of customer service. At that time John devoted himself to building more than just a heating and air conditioning company. As his personal guarantee John invites you to give him a call at 707-590-0045 for any reason positive or negative as your feedback is always important!',
		operatingHours: {},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [17],
		categoryNames: 'HVAC maintenance',
		corporateURL: 'http://www.rightnowair.net',
		storefrontURL: 'http://www.rightnowair.net',
		logoURL:
			'https://storage.googleapis.com/sos-websvc/uploads/0015212DEA001233/images/rightnow-logo-header.png',
		poEmail: 'wedothat@sbcglobal.net',
		website: 'rightnowair.net',
		primaryContactEmail: 'wedothat@sbcglobal.net',
		primaryPhone: '(707) 317-1588',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 38.39073944091797,
		longitude: -121.9673080444336,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4',
			yelpNumReviews: '64',
			hasCommercialText: true,
		},
		supplierCompanyId: 839,
	},
	{
		id: 858,
		name: 'Simpson Sheet Metal Heating & Air Conditioning',
		displayName: 'Simpson Sheet Metal Heating & Air Conditioning',
		status: 'active',
		about:
			'Simpson Sheet Metal has a full state-of-the-art warehouse on site and our shop guys can bend a piece of metal into any custom shape you desire. Simpson HVAC provides Commercial and Residential installation & repair. You may have seen our signs around town on new commercial buildings that are going up. We can do new construction or retrofit. Many homeowners have been happy with our work and we provide free estimates for a new system. Simpson HVAC also has many qualified service technicians available; which allows us to get to your home or business on the same day over 90% of the time! Established in 1977. Simpson Sheet Metal Heating & Air Conditioning is a family-owned full-service heating & air conditioning company. Simpson has been with the Carrier label for more than 30 years and has been a Factory Authorized Dealer for the past 23 years. We employ some of the BEST people in the HVAC industry with a combined experience of over 100 years. We are a member of Local Sheet Metal Union 104 which means our employees are highly trained educated and well skilled in all makes and models of heating ventilation and air conditioning systems. We provide respectful dependable honest and reliable customer service for any job no matter how large or small and our pricing is competitive and fair with no hidden or surprise costs. Simpson takes the family approach to business by having the estimator conduct all of our free estimates not an aggressive sales person. This provides all of our customers with the confidence that every system is designed and installed properly. Manages the service department and is the main contact for all questions Simpson. You can contact John for all service repair and installation needs. If you need an answer from Simpson HVAC John will point you in the right direction.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Saturday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Sunday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [17],
		categoryNames: 'HVAC maintenance',
		corporateURL: 'http://www.simpsonsheetmetal.com',
		storefrontURL: 'http://www.simpsonsheetmetal.com',
		logoURL: 'http://simpson.voxmagneta.com/wp-content/uploads/2017/07/cropped-s-logo.png',
		poEmail: 'info@ssmhvac.com',
		website: 'simpsonsheetmetal.com',
		primaryContactEmail: 'info@ssmhvac.com',
		primaryPhone: '(707) 576-1500',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 38.408241271972656,
		longitude: -122.72022247314453,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4.5',
			yelpNumReviews: '35',
			hasCommercialText: true,
		},
		supplierCompanyId: 858,
	},
	{
		id: 893,
		name: 'Vigil Mechanical',
		displayName: 'Vigil Mechanical',
		status: 'active',
		about:
			'Commercial and residential heating and air conditioningHVACArchitecural sheet metalDesign/build services.*Financing Available* Established in 2001. Vigil Mechanical Inc. has a full production sheet metal shop and focuses primarily on commercial HVAC installation. Over the years we have built CVS pharmacy Bass Pro Shop San Jose Sprouts Pinole Tropical Smoothie City Sports Club Gyms Seafood City grocery malls Tokyo Tokyo & Chowking restaurants Pacific Commons Fremont and we have completed over thirty Grocery Outlets just to name a few. Our ability to take our commercial skill into your home also makes our company a perfect choice for your residential needs. Cameron started his career in the HVAC industry at the age of 13 working in his fathers shop in Florida. After serving his country during Desert Shield & Desert Storm Cameron was honorable discharged when Mare Islands shipyard closed down. He stayed in the area where he found his true love and continued his fathers trade in the HVAC industry. 13 years ago with the help of his wife and co-owner Dina Vigil they created Vigil Mechanical. Cameron and Dina have worked tirelessly every since to provide great installations on budget and on time all the while providing a family style work environment for their crew.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '4:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '4:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '4:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '4:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '4:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [17],
		categoryNames: 'HVAC maintenance',
		corporateURL: 'http://vigilmechanical.com',
		storefrontURL: 'http://vigilmechanical.com',
		logoURL: 'http://vigilmechanical.com/images/logo_metallic_1.png',
		poEmail: 'info@vigilmechanical.com',
		website: 'vigilmechanical.com',
		primaryContactEmail: 'info@vigilmechanical.com',
		primaryPhone: '(707) 748-1000',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 38.07992935180664,
		longitude: -122.12640380859375,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '4',
			hasCommercialText: true,
		},
		supplierCompanyId: 893,
	},
	{
		id: 1374,
		name: 'A 24 Electric Co',
		displayName: 'A 24 Electric Co',
		status: 'active',
		about:
			'A 24 Electric Company provides a wide range of electrical services for commercial and residential properties. We are fully equipped to take care of all your electrical repairs. From removing violations to rewiring your entire building or home we are prepared to make it right for you. We are here to assist you with any electrical problem and ready for troubleshooting 24/7 including weekends and holidays. Lic#489800 Established in 1985. A 24 Electric Co. is a full service electrical contracting company serving residential and commercial customers in San Francisco and the Bay Area.The company was established on 1985 in San Francisco.License No. 489800. We provide full capability electrical contracting for new construction kitchen and bath renovations main electrical service upgrades underground conversions door bell and intercom repair and installation phone lines smoke detectors exterior and interior lighting code violation repair issue permits and get projects inspected condo conversions retrofits and service modifications and just about anything relating to wiring line and low voltage.',
		operatingHours: {},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [159],
		categoryNames: 'Commercial electricians',
		corporateURL: 'http://www.a24electric.com',
		storefrontURL: 'http://www.a24electric.com',
		logoURL: 'http://a24electric.com/wp-content/uploads/2015/04/Eddie-logo.png',
		poEmail: 'a24electric@gmail.com',
		website: 'a24electric.com',
		primaryContactEmail: 'a24electric@gmail.com',
		primaryPhone: '(415) 664-6611',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.74324035644531,
		longitude: -122.49767303466797,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4.5',
			yelpNumReviews: '24',
			hasCommercialText: true,
		},
		supplierCompanyId: 1374,
	},
	{
		id: 1376,
		name: 'AA Customs',
		displayName: 'AA Customs',
		status: 'active',
		about:
			'At AA Customs we provide a variety of outstanding AV and electrical services. Our technicians will install the latest AV gear and meet any bodies needs challenge us and we will not disappoint. Established in 2005. AA Customs is a full service home audio and video installation and procurement company. It all started with car audio and natural developed in home A/V. AA Customs been providing cutting-edge ideas and solutions for audio/video lighting and security applications throughout the Bay Area for nearly a decade. Clients work hand-in-hand with designers and installers on projects ranging from full-house audio systems home theater and whole-house lighting to state-of-the-art security systems. Building a new home or remodeling your current one? AA Customs can design and pre-wire to accommodate current and future digital needs. Dont let cost concerns deter you - their sales team can help you build a system to fit your budget. . In addition its hassle-free - AA Customs stands behind their products 100% so returning or exchanging products is easy. When it comes to home audio & video installation few companies offer the quality customer services and results that match AA Custom Audio. Whether the job requires installing a flat screen monitor in your kitchen or designing and efficiently building a custom home theatre in your house our trained technicians will work with you to fulfill all of your home audio and video needs. We aim to satisfy all of our customers desires and offer a wide range of custom solutions to help not only produce unique products but also build lasting relationships.',
		operatingHours: {
			Monday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
			Saturday: {
				from: '9:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [159],
		categoryNames: 'Commercial electricians',
		corporateURL: 'http://www.aacustoms.pro',
		storefrontURL: 'http://www.aacustoms.pro',
		logoURL: 'http://www.aacustoms.pro/images/logo.png',
		poEmail: 'sales@aacustomsproav.com',
		website: 'aacustoms.pro',
		primaryContactEmail: 'sales@aacustomsproav.com',
		primaryPhone: '(650) 762-9598',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.59624099731445,
		longitude: -122.36736297607422,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '38',
			hasCommercialText: true,
		},
		supplierCompanyId: 1376,
	},
	{
		id: 1378,
		name: 'Absolute Electric',
		displayName: 'Absolute Electric',
		status: 'active',
		about:
			'We specialize in residential and commercial electrical projects both small and big. Attention to detail wide spread knowledge of the electrical code and tons of experience installing electrical systems is what sets us apart from the competition. Every installation we complete looks like it was done by professionals because we are! We give you honest recommendations that we feel are efficient for your project and our pricing is very competitive. Services include: Arc Fault Circuit Breakers Attic Fans Bathroom Exhaust Fans Ceiling Fans Chandeliers Dedicated Circuits Dimmers Electric Car Chargers Electrical Outlets Flat Screen TV Installations Flourescent Lighting Fuses To Circuit Breakers Generators GFCI Outlets Hot Tubs Insta Hots Kitchen Remodels Landscape Lighting Light Switches Pendant Lights Recessed Lighting Rewires Security Lighting Service Upgrades Sub Panels Trouble Shooting Whole House Fans and much more...',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [159],
		categoryNames: 'Commercial electricians',
		corporateURL: 'http://www.absoluteelectric.net',
		storefrontURL: 'http://www.absoluteelectric.net',
		logoURL:
			'http://www.absoluteelectric.net/wp-content/uploads/2012/10/AE-logo-2-j-peg1-e1351540285162.jpg',
		poEmail: 'dave@absoluteelectric.net',
		website: 'absoluteelectric.net',
		primaryContactEmail: 'dave@absoluteelectric.net',
		primaryPhone: '(209) 305-8866',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.73453140258789,
		longitude: -121.43418884277344,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '32',
			hasCommercialText: true,
		},
		supplierCompanyId: 1378,
	},
	{
		id: 1391,
		name: 'Ample Electric',
		displayName: 'Ample Electric',
		status: 'active',
		about:
			'Being that Ample Electric Inc. is located in the small farming community of Winters we pride ourselves in providing the most up to date electrical services for your agricultural needs. From walnuts to grapes Ample Electric is serving the farming community with the most reliable electrical service possible. We work with motor control high voltage starters relays contacts and farming equipment such as walnut hollers just to name a few. We can service and maintain all your agricultural equipment so that your farming business will always run smoothly and effectively. We also offer the following services:-Same day service calls for residential commercial and industrial troubleshooting and repairs.-Residential Commercial and Industrial new construction installation-Residential Commercial and Industrial remodels-Outdoor and landscape lighting-Pool and spa wiring Established in 2009. Ample Electric Inc was formerly known as Spears Electric Inc and was owned and operated by Kyle Spears. In 2009 Kyle wanted a career change and decided to sell the corporation. With Kyles career change Jose Diaz a close friend and employee of Kyles decided that this would be a great way to own an electrical contracting company with an impeccable reputation. After taking ownership of the corporation Jose felt that with new ownership there should come a new name. With this decision Ample Electric Inc was created and founded. Jose is the owner of Ample Electric Inc. He has worked in the electrical field for 10 years and has owned Ample Electric since 2009.',
		operatingHours: {
			Monday: {
				from: '9:00 am',
				to: '4:00 pm',
			},
			Tuesday: {
				from: '9:00 am',
				to: '4:00 pm',
			},
			Wednesday: {
				from: '9:00 am',
				to: '4:00 pm',
			},
			Thursday: {
				from: '9:00 am',
				to: '4:00 pm',
			},
			Friday: {
				from: '9:00 am',
				to: '4:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [159],
		categoryNames: 'Commercial electricians',
		corporateURL: 'http://www.ampleelectricinc.com',
		storefrontURL: 'http://www.ampleelectricinc.com',
		logoURL: 'http://www.ampleelectricinc.com/images/logo_ae-home.gif',
		poEmail: 'jdiaz@ampleelectricinc.com',
		website: 'ampleelectricinc.com',
		primaryContactEmail: 'jdiaz@ampleelectricinc.com',
		primaryPhone: '(530) 795-9913',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 38.521629333496094,
		longitude: -121.96942901611328,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4.5',
			yelpNumReviews: '3',
			hasCommercialText: true,
		},
		supplierCompanyId: 1391,
	},
	{
		id: 1414,
		name: 'D & S Electric',
		displayName: 'D & S Electric',
		status: 'active',
		about:
			'Commercial & Industrial - Installing new and upgrading existing power distribution systemsProviding electrical distribution for CNC lathe and manual machinesProviding and installing transformers for all voltage needs Lighting: interior and exterior (fluorescent LED and metal halide) building lightingTroubleshooting repairs and preventive maintenance Electrical capacity and demand surveysElectrical layout and design consultationEmergency electrical servicesProject permitting and inspecting.LIC. # C10-499083 Established in 1986. D&S Electric has over 40 years experience in the electrical field we design install upgrade and maintain all electrical systems from machine shops to high-tech industries all through out the Bay area.By providing quality workmanship and competitive pricing we have achieved valuable long-term relationships with clients large and small.',
		operatingHours: {
			Monday: {
				from: '7:00 am',
				to: '4:00 pm',
			},
			Tuesday: {
				from: '7:00 am',
				to: '4:00 pm',
			},
			Wednesday: {
				from: '7:00 am',
				to: '4:00 pm',
			},
			Thursday: {
				from: '7:00 am',
				to: '4:00 pm',
			},
			Friday: {
				from: '7:00 am',
				to: '4:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [159],
		categoryNames: 'Commercial electricians',
		corporateURL: 'http://www.dselectric.us',
		storefrontURL: 'http://www.dselectric.us',
		logoURL: 'http://www.dselectric.us/img/logo.png',
		poEmail: 'office@dselectric.us',
		website: 'dselectric.us',
		primaryContactEmail: 'office@dselectric.us',
		primaryPhone: '(408) 988-8870',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.38072967529297,
		longitude: -121.94367218017578,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '2',
			hasCommercialText: true,
		},
		supplierCompanyId: 1414,
	},
	{
		id: 1464,
		name: 'Magic Sun Electric',
		displayName: 'Magic Sun Electric',
		status: 'active',
		about:
			'Our electrical services include electrical troubleshooting dedicated circuits LED lighting Solar repair (panels/components) Solar panel cleaning LED lighting EV charging stations back-up generators whole house fans and attic exhaust fans. Established in 2015. Magic Sun Electric started up in 2015 with the sister company Magic Sun Solar which has been in business since 2010.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [159],
		categoryNames: 'Commercial electricians',
		corporateURL: 'http://www.magicsunelectric.com',
		storefrontURL: 'http://www.magicsunelectric.com',
		logoURL: 'http://www.magicsunelectric.com/wp-content/uploads/2016/07/logo.png',
		poEmail: 'chad@magicsunelectric.com',
		website: 'magicsunelectric.com',
		primaryContactEmail: 'chad@magicsunelectric.com',
		primaryPhone: '(916) 794-0448',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 38.81924057006836,
		longitude: -121.19584655761719,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4.5',
			yelpNumReviews: '11',
			hasCommercialText: true,
		},
		supplierCompanyId: 1464,
	},
	{
		id: 1495,
		name: 'Reyff Electric',
		displayName: 'Reyff Electric',
		status: 'active',
		about:
			'We are a Diamond Certified electrical company specializing in:Residential Services:-Spa & and hot tub set-ups-Troubleshooting & rewiring-Light fixtures-Heater bath & ceiling fan installation-Panel and breaker upgrades-Repairs & new custom construction-Under cabinet lighting-Cable-DSL networking-Artwork lighting-Attic & exhaust fans-Motion detector & flood lighting-Installation of new or dedicated circuits-Remote & automated lighting-Plasma wall-mounted audio-Ballast & lamp replacement-Repair & installation of smoke detectors-Appliance hook-ups-Home inspections-Repair & installation of receptacles GFIS switches circuit breakers & fuses-Repair/installation of indoor recessed & track lighting & outdoor landscape lightingCommercial Services:-Restaurant specialist-New sonstruction & repairs-Energy management-Panel & breaker upgrades-Cable & data networking-Troubleshooting & rewiring-Maintenance & contracts-Generators-Lighting modifications & upgrades Established in 1980. BBB accredited A+ business since 2008Diamond Certified since 2011 Ray Reyff Jr. is the owner of Reyff Electric Inc. Rohnert Park office. He took over the business from his father Ray Sr. who started the company in 1980 and who now exclusively runs the Fairfield office.. Ray Jr. has expanded his portion of the business to include nearly 50 full time employees and an extensive array of big-name commercial projects all while keeping the homegrown-business ethics alive and well while taking care of his small business and residential customers. Ray and his family reside in Sonoma County and are active members of the community.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [159],
		categoryNames: 'Commercial electricians',
		corporateURL: 'http://reyffelectricsantarosaca.com',
		storefrontURL: 'http://reyffelectricsantarosaca.com',
		logoURL:
			'http://reyffelectricsantarosaca.com//templates/bubbles/templates_cj5753/floating/reyffelectric/Black/en/gfx/footer-logos-no-diamond1.png',
		poEmail: 'rohnertpark@reyffelectric.com',
		website: 'reyffelectricsantarosaca.com',
		primaryContactEmail: 'rohnertpark@reyffelectric.com',
		primaryPhone: '(707) 585-2481',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 38.35438919067383,
		longitude: -122.72377014160156,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4.5',
			yelpNumReviews: '18',
			hasCommercialText: true,
		},
		supplierCompanyId: 1495,
	},
	{
		id: 1522,
		name: 'Tim’s Electric City SF',
		displayName: 'Tim’s Electric City SF',
		status: 'active',
		about:
			'Reliable Responsive Expert Electrical Services in SF Since 1988 Tim can handle ANY electrical repair or remodel!Residential & CommercialElectrical Repairs Remodeling Troubleshooting BIG or Small Jobs OKAfter-Hours Emergencies OKUpdate Old Wiring in Vintage BuildingsSwitches Receptacles & Dedicated Circuits PGE Service & Electrical Code CorrectionsCommercial & Small Enterprise Repairs & InstallationsFiber Optic & Data Comm WiringMotor repairsLED lighting & Lighting Design Parking-lot Lighting Upgrade & InstallationGallery and Commercial Space LightingMuch more...just ask us! Established in 1988. After 29 years in San Francisco weve handled nearly every electrical challenge there is. Our goal is to deliver reliable responsive expert electrical services at a fair price to our valued San Francisco customers.Our expertise lets us quickly identify your needs & help you understand your options.Prioritizing responsive communication & attention to detail we deliver personalized solutions without interrupting your busy life.Give us a call & well show you why weve earned the trust & 5-Star recommendations of so many in the San Francisco community! Im a master electrician-problem-solver with a mission: Success is delivering excellent customer service & quality workmanship in sync with the golden rule. Coming up in the SF Bay Area I learned electrical in the family-biz & by 16 I was a residential service-tech repairing & installing home appliances. Studying at UC (Mathematical Economics & Systems Theory) I worked part-time as an electrician before starting my company Electric City SF in 1988.Ive also learned from diverse cultures & people adventure-traveling off-the-beaten-path in 50+ countries. Like me nearly everyone everywhere values well-being & prosperity for their family their community & their planet. I bring this insight to my work.I enjoy good friends my dog Pumpkin music dancing BurningMan scuba surfing birdwatching Spanish hi-tech toys & solving electrical challenges for customers.Since 1988 Ive served 1000s of valued customers in the SF community & I look forward to helping you too ;-)',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '7:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '7:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '7:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '7:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '7:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [159],
		categoryNames: 'Commercial electricians',
		corporateURL: 'http://www.electriccitysf.com',
		storefrontURL: 'http://www.electriccitysf.com',
		logoURL:
			'https://www.electriccitysf.com/wp-content/uploads/2016/06/electriccity_color_3inch.jpg',
		poEmail: 'info@electriccitysf.com',
		website: 'electriccitysf.com',
		primaryContactEmail: 'info@electriccitysf.com',
		primaryPhone: '(415) 805-8583',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.76483154296875,
		longitude: -122.43203735351562,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4',
			yelpNumReviews: '21',
			hasCommercialText: true,
		},
		supplierCompanyId: 1522,
	},
	{
		id: 1534,
		name: 'Wong Electric',
		displayName: 'Wong Electric',
		status: 'active',
		about:
			'Commercial and Industrial only. NO residential work.- Design Build- New Construction- Tenant Improvements- Electrical Service Work- Underground Electrical- Parking Lot Lighting Maintenance- Monthly Lighting Maintenance- Emergency Service Work 24/7 Established in 1978. In 1978 Steve Wong had recently graduated in Electrical Engineering and at the age of 22 years old he saw a potential in going out on his own to get his contractors license and start his own electrical company. The timing was right says Wong. I had a customer base with my familys friends as they all were expanding their businesses and needed electrical work done just as I had done for my own familys farm. They trusted me because they knew my family and could communicate with me because I spoke Chinese. Following the development booms in Santa Clara Valley in the 1980s Wong moved his office to Palo Alto and today has over 70 employees. Steve Wong however through the years has gained the respect of the total contracting industry in the valley so his client base runs the gamut from Fortune 500 companies to smaller developers .',
		operatingHours: {
			Monday: {
				from: '7:00 am',
				to: '4:00 pm',
			},
			Tuesday: {
				from: '7:00 am',
				to: '4:00 pm',
			},
			Wednesday: {
				from: '7:00 am',
				to: '4:00 pm',
			},
			Thursday: {
				from: '7:00 am',
				to: '4:00 pm',
			},
			Friday: {
				from: '7:00 am',
				to: '4:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [159],
		categoryNames: 'Commercial electricians',
		corporateURL: 'http://www.wongelectric.com/',
		storefrontURL: 'http://www.wongelectric.com/',
		logoURL:
			'http://www.wongelectric.com/wp-content/uploads/2017/08/WONG-Electric-Logo-We-Con-Duit-SidebySide-v2-800px.jpg',
		poEmail: 'swong@wongelectric.com',
		website: 'wongelectric.com',
		primaryContactEmail: 'swong@wongelectric.com',
		primaryPhone: '(650) 813-9999',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.42485809326172,
		longitude: -122.09870147705078,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '2',
			hasCommercialText: true,
		},
		supplierCompanyId: 1534,
	},
	{
		id: 1535,
		name: 'Woodland Electrical Enterprises',
		displayName: 'Woodland Electrical Enterprises',
		status: 'active',
		about:
			'Woodland Electrical Enterprises has been completing electrical work for residential and commercial clients for many years. We complete a wide range of projects from a simple ceiling fan repair to a full electrical install on a custom home.',
		operatingHours: {
			Monday: {
				from: '7:00 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '7:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '7:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '7:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '7:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [159],
		categoryNames: 'Commercial electricians',
		corporateURL: 'http://woodlandelectrical.com',
		storefrontURL: 'http://woodlandelectrical.com',
		logoURL: 'http://woodlandelectrical.com/images/WEE_Final_logo-11.svg',
		poEmail: 'admin@woodlandelectrical.com',
		website: 'woodlandelectrical.com',
		primaryContactEmail: 'admin@woodlandelectrical.com',
		primaryPhone: '(530) 867-3740',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 38.67852020263672,
		longitude: -121.77330017089844,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '9',
			hasCommercialText: true,
		},
		supplierCompanyId: 1535,
	},
	{
		id: 914,
		name: 'ABP All Bay Plumbing',
		displayName: 'ABP All Bay Plumbing',
		status: 'active',
		about:
			'No job is too big or small for us.ABP All Bay Plumbings goal is to provide the highest level of service. We are a full service plumbing company family owned and operated. We have over 15 years of experience and always provide free written estimate before every job.During this time we have built a good reputable company and have been named The Top Plumber of the Year. We are hardworking and believe our work is our name. We strive everyday to do the best job possible to keep our customers for life so that they tell their friends family and neighbors about the great work we do.With ABP All Bay Plumbing you&apos;re assured confidence and peace of mind that the job will be done right the first time and at the right price. We are licensed and bonded. We service from single family residences duplexes apartments condo complexes to restaurants and commercial businesses. Established in 2011. In the late 1990s Richard started Plumbing for a few well named Plumbing Companies in the Bay Area. Soon after his brother opened his own along with a few other brothers they made that Plumbing Company a success. After over 10 years of experience Richard decided to open his own in the Valley with time A.B.P was born. Even though Richard is the owner He is still out on jobs and taking service call to provide the best work possible. We are a family owned business and we feel our work is our name. Our goal is to make every customer happy and hope we keep them for life.',
		operatingHours: {},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [157],
		categoryNames: 'Plumbing',
		corporateURL: 'http://www.allbayareaplumbing.com',
		storefrontURL: 'http://www.allbayareaplumbing.com',
		logoURL: 'http://static.sites.yp.com/var/m_1/19/19e/8321053/1506951-new_logo.w400.h150.png',
		poEmail: 'allbayplumbing@yahoo.com',
		website: 'allbayareaplumbing.com',
		primaryContactEmail: 'allbayplumbing@yahoo.com',
		primaryPhone: '(209) 818-0256',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.670448303222656,
		longitude: -120.93025970458984,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4',
			yelpNumReviews: '4',
			hasCommercialText: true,
		},
		supplierCompanyId: 914,
	},
	{
		id: 920,
		name: 'Advanced Quality Plumbing & Rooter',
		displayName: 'Advanced Quality Plumbing & Rooter',
		status: 'active',
		about:
			'Advanced Quality Plumbing specializes in all aspects of plumbing from residential service and repair to residential/commercial new construction underground and top out.Our main goal at Advanced Quality Plumbing is to provide our clients with the best possible quality service at a competitive investment cost. We are CA Licensed & Insured Locally Owned & Operated! Established in 2005. Advanced Quality Plumbing is a family owned and operated full scope residential service and commercial contruction plumbing company. We have been proudly serving the Bay Area since 2005. I started my plumbing career 20+ years ago while still in high school. In 2005 I decided that I would obtain my contractors license and start my own company.In doing so my main focus is on providing my community with full scope plumbing services with help and support from God my family and church and my awesome team that makes it all happen.',
		operatingHours: {},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [157],
		categoryNames: 'Plumbing',
		corporateURL: 'http://www.advancedqualityplumbing.com',
		storefrontURL: 'http://www.advancedqualityplumbing.com',
		logoURL: 'http://www.advancedqualityplumbing.com/images/logo.png',
		poEmail: 'office@advancedqualityplumbing.com',
		website: 'advancedqualityplumbing.com',
		primaryContactEmail: 'office@advancedqualityplumbing.com',
		primaryPhone: '(408) 418-6017',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.225711822509766,
		longitude: -121.76229095458984,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '22',
			hasCommercialText: true,
		},
		supplierCompanyId: 920,
	},
	{
		id: 1074,
		name: 'Just Tankless',
		displayName: 'Just Tankless',
		status: 'active',
		about:
			'We specialize in tankless water heater installation repair and service that is All We Do! We also specialize in Eichler Homes Hydronic Heating With our advanced solution we can reduce your energy bill and water usage significantly. We are experts and carry all major brands like Quietside Noritz Takagi Rinnai Bosch Eternal Hybrid Navien Samsung. We offer unit and installation kits or full service installation through us. Our Technicians are factory trained and certified by all major tankless manufactures. At Just Tankless you are assured to receive Best Value and Best Service. We offer extended warranties and satisfaction guarantees for your peace of mind. We stand behind every product and installation. Visit our website for more information. Established in 2005. We have always been involved in renewable energy and energy saving construction and developments. Having seen the energy prices rise year after year we came across of one of the biggest energy wasters in a household Tank Water Heaters. keeping 40 50 or more gallons of water continuously heated in tank seems very primitive and out of time. We knew about tankless water heaters and point of use heaters from europe and asia and thought it would be a good idea to offer it here. Now with a large federal tax credit of 30 % of the units cost and installation of up to $ 1500.00 it makes more sense than ever to go tankless. John has been active in energy conservation and renewable energy industry for decades. Saving energy and producing energy from renewable sources has been a top priority in our lives and business. We can consult you on your energy usage and conservation in residential as well as commercial applications. With our vast experience we can surely find the best solution that is cost effective and environmentally safe and friendly. We hold General. Electrical and Plumbing Licenses from the California State Licensing Board. We specialize also in Hydronic and Radiant Heating especially for Eichler Homes.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '7:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '7:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '7:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '7:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '7:00 pm',
			},
			Saturday: {
				from: '8:00 am',
				to: '7:00 pm',
			},
			Sunday: {
				from: '1:00 am',
				to: '6:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [157],
		categoryNames: 'Plumbing',
		corporateURL: 'http://www.justtankless.com',
		storefrontURL: 'http://www.justtankless.com',
		logoURL: 'http://www.justtankless.com/images/blogotankless.gif',
		poEmail: 'info@justtankless.com',
		website: 'justtankless.com',
		primaryContactEmail: 'info@justtankless.com',
		primaryPhone: '(877) 934-6765',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.22605895996094,
		longitude: -121.93023681640625,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4',
			yelpNumReviews: '33',
			hasCommercialText: true,
		},
		supplierCompanyId: 1074,
	},
	{
		id: 1082,
		name: 'KS Plumbing Inc',
		displayName: 'KS Plumbing Inc',
		status: 'active',
		about: 'Commercial Plumbing Contractor',
		operatingHours: {
			Monday: {
				from: '6:00 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '6:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '6:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '6:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '6:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [157],
		categoryNames: 'Plumbing',
		corporateURL: 'http://www.ksplumbinginc.com',
		storefrontURL: 'http://www.ksplumbinginc.com',
		logoURL:
			'http://folsomshopegolf.org/ksplumbingnew/wp-content/uploads/2018/03/ksp_logo_112.png alt=KS Plumbing, Inc. srcset=http://folsomshopegolf.org/ksplumbingnew/wp-content/uploads/2018/03/ksp_logo_112.png, http://folsomshopegolf.org/ksplumbingnew/wp-content/uploads/2018/03/ksp_logo_224.png',
		poEmail: 'info@ksplumbinginc.com',
		website: 'ksplumbinginc.com',
		primaryContactEmail: 'info@ksplumbinginc.com',
		primaryPhone: '(916) 496-0630',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 38.66913986206055,
		longitude: -120.93599700927734,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '5',
			yelpNumReviews: '1',
			hasCommercialText: true,
		},
		supplierCompanyId: 1082,
	},
	{
		id: 1093,
		name: 'Lovotti',
		displayName: 'Lovotti',
		status: 'active',
		about:
			'Specializing in:- Refrigeration Equipment-Commercial & Industrial- Air Conditioning Contractors & Systems- Air Conditioning Service & Repair- Heating Contractors & Specialties- Heating Equipment & Systems- Electricians- Plumbers- Plumbing-Drain & Sewer Cleaning- Refrigerators & Freezers-Repair & Service- Major Appliance Refinishing & Repair- Air Conditioning Equipment & Systems-Wholesale & Manufacturers Established in 2006. After being in the Heating and Air Conditioning business for 14 years Scott Lovotti went out on his own and started Lovotti Air in 2006. Scott began his company with him and a helper and since 2006 has built his business to where he employs 12 full time employees and 30 summer seasonal employees. Scott attributes his growth to word of mouth referrals by providing excellent service to customers at a great price. All of Lovotti Airs technicians are fully trained and educated in all aspects of the HVAC field. We provide our services to a wide range of residential and commercial customers throughout the greater Modesto Stockton and Sacramento areas.',
		operatingHours: {
			Monday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Tuesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Wednesday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Thursday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
			Friday: {
				from: '8:00 am',
				to: '5:00 pm',
			},
		},
		verifications: [],
		licenses: [],
		certifications: [],
		insurances: [],
		faqs: [],
		isWomenOwned: false,
		isMinorityOwned: false,
		isVeteranOwned: false,
		isDisabledOwned: false,
		isLgbtOwned: false,
		isSmallBusinessEnterprise: false,
		categoryIds: [157],
		categoryNames: 'Plumbing',
		corporateURL: 'http://www.lovottiair.com',
		storefrontURL: 'http://www.lovottiair.com',
		logoURL: 'http://www.lovottiair.com/files/logo_img_p4635460_n3.png',
		poEmail: 'eric@redtruck.us',
		website: 'lovottiair.com',
		primaryContactEmail: 'eric@redtruck.us',
		primaryPhone: '(209) 931-2100',
		primaryAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		remitToAddress: {
			streetAddress1: '',
			city: 'San Francisco Bay Area',
			postcode: '',
			region: 'CA',
			country: 'United States',
		},
		businessCodes: {},
		latitude: 37.97956085205078,
		longitude: -121.2694091796875,
		socialMedia: {},
		additionalDetails: {
			yelpRatings: '4',
			yelpNumReviews: '22',
			hasCommercialText: true,
		},
		supplierCompanyId: 1093,
	},
];

export const suppliers = [
	{
		id: 1,
		name: 'Versiti',
		display_name: 'Versiti',
		status: 'active',
		duns: null,
		tax_id: null,
		corporate_url: 'https://www.versiti.org/',
		storefront_url: null,
		po_method: null,
		po_change_method: null,
		po_email: null,
		website: 'https://www.versiti.org/',
		logo_url: 'https://s3.amazonaws.com/mock-data-assets/suppliers/images/versiti.png',
		parent: null,
		primary_contact_email: 'christopher.plautz@versiti.org',
		primary_address: '638 N 18th St, Milwaukee, WI 53233',
		remit_to_address: '638 N 18th St, Milwaukee, WI 53233',
	},
	{
		id: 2,
		name: 'Lenco Diagnostic Laboratory',
		display_name: 'Lenco Diagnostic Laboratory',
		status: 'active',
		duns: null,
		tax_id: null,
		corporate_url: 'http://www.lencolab.com/',
		storefront_url: null,
		po_method: null,
		po_change_method: null,
		po_email: null,
		website: 'http://www.lencolab.com/',
		logo_url: 'https://s3.amazonaws.com/mock-data-assets/suppliers/images/lenco.gif',
		parent: null,
		primary_contact_email: 'info@lencolab.com',
		primary_address: '1857 86th St, Brooklyn NY 11214',
		remit_to_address: '1857 86th St, Brooklyn NY 11214',
	},
	{
		id: 3,
		name: 'Sysmex',
		display_name: 'Sysmex',
		status: 'active',
		duns: null,
		tax_id: null,
		corporate_url: 'https://www.sysmex.com/us/en/Pages/default.aspx',
		storefront_url: null,
		po_method: null,
		po_change_method: null,
		po_email: null,
		website: 'https://www.sysmex.com/us/en/Pages/default.aspx',
		logo_url: 'https://s3.amazonaws.com/mock-data-assets/suppliers/images/sysmex.jpg',
		parent: null,
		primary_contact_email: 'communications@sysmex.com',
		primary_address: '577 Aptakisic Rd, Lincolnshire, IL 60069',
		remit_to_address: '577 Aptakisic Rd, Lincolnshire, IL 60069',
	},
	{
		id: 4,
		name: 'Miraca Life Sciences',
		display_name: 'Miraca Life Sciences',
		status: 'active',
		duns: null,
		tax_id: null,
		corporate_url: 'http://www.miracalifesciences.com',
		storefront_url: null,
		po_method: null,
		po_change_method: null,
		po_email: null,
		website: 'http://www.miracalifesciences.com',
		logo_url: 'https://s3.amazonaws.com/mock-data-assets/suppliers/images/miraca.gif',
		parent: null,
		primary_contact_email: 'jjennings@miracals.com',
		primary_address: '6655 N MacArthur Blvd, Irving, TX 75039',
		remit_to_address: '6655 N MacArthur Blvd, Irving, TX 75039',
	},
	{
		id: 5,
		name: 'Cleveland Clinic',
		display_name: 'Cleveland Clinic',
		status: 'active',
		duns: null,
		tax_id: null,
		corporate_url: 'https://www.clevelandclinic.org/',
		storefront_url: null,
		po_method: null,
		po_change_method: null,
		po_email: null,
		website: 'https://www.clevelandclinic.org/',
		logo_url: 'https://s3.amazonaws.com/mock-data-assets/suppliers/images/Cleveland-Clinic.jpeg',
		parent: null,
		primary_contact_email: 'info@clevelandclinic.org',
		primary_address: '638 N 18th St, Milwaukee, WI 53233',
		remit_to_address: '638 N 18th St, Milwaukee, WI 53233',
	},
];

export const currencies = [
	{
		id: 'USD',
		abbreviation: 'USD',
		displayNamePlural: 'dollars',
		displayNameSingular: 'dollar',
		symbol: '$',
	},
	{
		id: 'CAD',
		abbreviation: 'CAD',
		displayNameSingular: 'Canada dollar',
		displayNamePlural: 'Canada dollars',
		symbol: 'C$',
	},
	{
		id: 'EUR',
		abbreviation: 'EUR',
		displayNamePlural: 'euros',
		displayNameSingular: 'euro',
		symbol: '€',
	},
	{
		id: 'GBP',
		abbreviation: 'GBP',
		displayNamePlural: 'pounds',
		displayNameSingular: 'pound',
		symbol: '£',
	},
	{
		id: 'JPY',
		abbreviation: 'JPY',
		displayNamePlural: 'yen',
		displayNameSingular: 'yen',
		symbol: '¥',
	},
	{
		id: 'CNY',
		abbreviation: 'CNY',
		displayNamePlural: 'yuan',
		displayNameSingular: 'yuan',
		symbol: '¥',
	},
];

export const event_buyer_team_member1 = {
	id: 1,
	sourcing_event_id: 1,
	contact_email: 'matt@emptor.ai', // contact_email is foreign key for account if account exists
	event_role: 'owner',
	buyer_id: 1,
};

export const event_buyer_team_member2 = {
	id: 2,
	sourcing_event_id: 1,
	contact_email: 'vignesh@emptor.ai',
	event_role: 'collaborator',
	buyer_id: 1,
};

export const event_buyer_team_member3 = {
	id: 3,
	sourcing_event_id: 1,
	contact_email: 'staff@emptor.ai',
	event_role: 'watcher',
};

export const avatars = [
	'https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png',
	'https://gw.alipayobjects.com/zos/rmsportal/cnrhVkzwxjPwAaCfPbdc.png',
	'https://gw.alipayobjects.com/zos/rmsportal/gaOngJwsRYRaVAuXXcmB.png',
	'https://gw.alipayobjects.com/zos/rmsportal/ubnKSIfAJTxIgXOKlciN.png',
	'https://gw.alipayobjects.com/zos/rmsportal/WhxKECPNujWoWEFNdnJE.png',
	'https://gw.alipayobjects.com/zos/rmsportal/jZUIxmJycoymBprLOUbT.png',
	'https://gw.alipayobjects.com/zos/rmsportal/psOgztMplJMGpVEqfcgF.png',
	'https://gw.alipayobjects.com/zos/rmsportal/ZpBqSxLxVEXfcUNoPKrz.png',
	'https://gw.alipayobjects.com/zos/rmsportal/laiEnJdGHVOhJrUShBaJ.png',
	'https://gw.alipayobjects.com/zos/rmsportal/UrQsqscbKEpNuJcvBZBu.png',
];

export const currentUser = {
	email: 'matt@emptor.ai',
	role: SUPER_ADMIN,
	phone_work: faker.phone.phoneNumber(),
	phone_mobile: faker.phone.phoneNumber(),
	job_title: faker.name.jobTitle(),
	company_id: 1,
	fax: faker.phone.phoneNumber(),
	name_prefix: faker.name.prefix,
	name_suffix: Math.random() > 0.75 ? faker.name.suffix : '',
	name_given: faker.name.firstName(),
	name_family: faker.name.lastName(),
	name_additional: '',
	photo_link: 'https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png',
	notes: '',
	created_at: faker.date.past(),
	updated_at: faker.date.past(),
};

export const contacts = avatars.map((avatarUrl, idx) => ({
	id: idx,
	email: faker.internet.email(),
	phone_work: faker.phone.phoneNumber(),
	phone_mobile: faker.phone.phoneNumber(),
	job_title: faker.name.jobTitle(),
	company_id: 1,
	fax: faker.phone.phoneNumber(),
	name_prefix: faker.name.prefix(),
	name_suffix: Math.random() > 0.75 ? faker.name.suffix : '',
	name_given: faker.name.firstName(),
	name_family: faker.name.lastName(),
	name_additional: '',
	photo_link: avatarUrl,
	notes: '',
	created_at: faker.date.past(),
	updated_at: faker.date.past(),
}));

export const bidder1 = {
	sourcing_event_id: 1,
	supplier_id: 1,
	score_card_id: 1,
	questionnaire_id: 1,
};

export const bidder2 = {
	sourcing_event_id: 1,
	supplier_id: 2,
	score_card_id: 2,
	questionnaire_id: 2,
};

export const event_supplier_team = {
	sourcing_event_id: 1,
	contact_email: faker.internet.email(),
	event_role: 'owner',
	supplier_id: 1,
	is_nda_signed: true,
};

export const statement_of_work = {
	id: 1,
	sourcing_event_id: 1,
	sow_details: {},
	budget: 100000.0,
};

export const pricing_schedule = {
	id: 1,
	statement_of_work_id: 1,
	schedule_details: {},
	expense: null,
	expense_cap: null,
	target_cost: null,
};

export const line_items = [
	{
		id: 1,
		pricing_schedule_id: 1,
		description: 'Platelet antigen and antibody testing',
		line_item_details: {},
		lowest_uom_id: 1,
		lowest_uom_quantity: 300,
		order_uom_id: 1,
		conversion_factor: 1,
	},
	{
		id: 2,
		pricing_schedule_id: 1,
		description: 'Fibrinolytic disorders testing',
		line_item_details: {},
		lowest_uom_id: 1,
		lowest_uom_quantity: 100,
		order_uom_id: 1,
		conversion_factor: 1,
	},
];

export const questionnaire = {
	id: 1,
	title: 'Service Qualification Survey',
	description: null,
};

export const mockQuestions = [
	{
		id: 1,
		title: 'Response Time',
		description:
			'Ability to support clinical diagnostics for full territory with maximum 48 hour turnaround on routine tests?',
		type: 'multipleChoice',
		choices: ['Yes', 'No'],
	},
	{
		id: 2,
		title: 'Quality Control',
		description:
			'Availability of test kit controls, such as internal test device controls and test kit controls for QC?',
		type: 'multipleChoice',
		choices: ['Yes', 'No'],
	},
	{
		id: 3,
		title: 'Compatibility',
		description: 'Compatibility with EQAS/proficiency testing programmes?',
		type: 'multipleChoice',
		choices: ['Yes', 'No'],
	},
	{
		id: 4,
		title: 'Customer Support',
		description: 'Dedicated customer service and account representative?',
		type: 'multipleChoice',
		choices: ['Yes', 'No'],
	},
	{
		id: 5,
		title: 'Solution Completeness',
		description: 'Coagulation and urinalysis testing?',
		type: 'multipleChoice',
		choices: ['Yes', 'No'],
	},
];

export const answers = [];

export const milestones = [
	{
		id: 1,
		pricing_schedule_id: 1,
		name: 'Milestone 1',
		description: 'milestone 1 description is well described',
		due_date: faker.date.future(),
		assigned_to_email: 'matt@emptor.ai',
		assigned_by_email: 'vignesh@emptor.ai',
		assigned_at: faker.date.past(),
		acceptance_criteria: {},
		acceptance_required: false,
		acceptance_type: 'performanceBased',
		created_at: faker.date.past(),
		updated_at: faker.date.past(),
	},
	{
		id: 2,
		pricing_schedule_id: 1,
		name: 'Milestone 2',
		description: 'milestone 2 description is well described',
		due_date: faker.date.future(),
		assigned_to_email: 'matt@emptor.ai',
		assigned_by_email: 'vignesh@emptor.ai',
		assigned_at: faker.date.past(),
		acceptance_criteria: {},
		acceptance_required: false,
		acceptance_type: 'performanceBased',
		created_at: faker.date.past(),
		updated_at: faker.date.past(),
	},
	{
		id: 3,
		pricing_schedule_id: 1,
		name: 'Milestone 3',
		description: 'milestone 3 description is well described',
		due_date: faker.date.future(),
		assigned_to_email: 'matt@emptor.ai',
		assigned_by_email: 'vignesh@emptor.ai',
		assigned_at: faker.date.past(),
		acceptance_criteria: {},
		acceptance_required: false,
		acceptance_type: 'performanceBased',
		created_at: faker.date.past(),
		updated_at: faker.date.past(),
	},
];

export const howEmptorWorks = [
	{ displayName: 'Create a new project', icon: 'add' },
	{ displayName: 'Add your internal team', icon: 'account' },
	{ displayName: 'Fill out project details', icon: 'edit' },
	{ displayName: 'Invite qualified suppliers', icon: 'email' },
	{ displayName: 'Compare and score bids', icon: 'compare' },
	{ displayName: 'Make an award', icon: 'trust' },
];
export const howEmptorWorks2 = [
	{ displayName: 'Describe your project', icon: 'edit' },
	{ displayName: 'Choose a pricing model', icon: 'dollar' },
	{ displayName: 'Get matched with qualified service providers', icon: 'email' },
	{ displayName: 'Compare bids and pick a provider', icon: 'trust' },
];
export const howEmptorWorks3 = [
	{
		displayName: 'We analyze spend data to uncover opportunities',
		imageLink:
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-landing-page/emptor-steps-01.svg',
		icon: 'data',
	},
	{
		displayName: 'Stakeholders collaborate on the scope of work',
		imageLink:
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-landing-page/emptor-steps-02.svg',
		icon: 'edit',
	},
	{
		displayName: 'You define questions, scoring criteria & pricing model',
		imageLink:
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-landing-page/emptor-steps-03.svg',
		icon: 'dollar',
	},
	{
		displayName: 'We match you with the best suppliers from our network',
		imageLink:
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-landing-page/emptor-steps-04.svg',
		icon: 'email',
	},
	{
		displayName: 'Your team compares and scores bids then picks a provider',
		imageLink:
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-landing-page/emptor-steps-05.svg',
		icon: 'trust',
	},
];

export const howEmptorWorks4 = [
	{
		title: 'Benchmark your spend',
		displayName: 'We analyze spend data to uncover opportunities',
		imageLink:
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-landing-page/emptor-steps-01.svg',
		icon: 'data',
	},
	{
		title: 'Engage your stakeholders',
		displayName: 'Stakeholders collaborate on the scope of work',
		imageLink:
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-landing-page/emptor-steps-02.svg',
		icon: 'edit',
	},
	{
		title: 'Discover new suppliers',
		displayName: 'We match you with the best suppliers from our network',
		imageLink:
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-landing-page/emptor-steps-04.svg',
		icon: 'email',
	},
	{
		title: 'Gather market intel',
		displayName: 'You define questions, scoring criteria & pricing model',
		imageLink:
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-landing-page/emptor-steps-03.svg',
		icon: 'dollar',
	},
	{
		title: 'Reduce your overhead',
		displayName: 'Your team compares bids then picks a provider',
		imageLink:
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-landing-page/emptor-steps-05.svg',
		icon: 'trust',
	},
];

export const howEmptorWorks5 = [
	{
		title: 'Answer a few questions',
		displayName:
			"Tell us what you need, where you need it and when you'd prefer to receive service.",
		imageLink:
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-landing-page/emptor-steps-05.svg',
		icon: 'data',
	},
	{
		title: 'Get competitive quotes',
		displayName:
			"We'll get you quotes from great service providers in the area ready to do the job.",
		imageLink:
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-landing-page/emptor-steps-03.svg',
		icon: 'edit',
	},
	{
		title: 'Hire a great service provider',
		displayName: 'You can hire a pro and get them on site without ever picking up a phone.',
		imageLink:
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-landing-page/emptor-steps-02.svg',
		icon: 'email',
	},
];

export const openWrenchModules = [
	{
		id: 'wom',
		title: 'Work Order Management',
		description: 'Automatically dispatch new work orders and manage past ones.',
		icon: 'set',
		color: '#4e2991',
		productRoute: 'work-order-management',
		benefitsTitle: 'Why Adopt Work Order Management',
		featuresTitle: 'Work Order Management Features',
		headlineTitle: 'A faster path from request to resolution',
		headlineDescription:
			"OpenWrench's work order management platform enables FMs to automatically dispatch and schedule new work orders and maintain accurate maintenance records on past service.",
		productMockUrl:
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-landing-page/work-order-management-mock.svg',
		features: [
			{
				icon: 'icons8-iphone-x',
				name: 'Mobile Service Requests',
				description: 'Empower your team to make service requests on the go from their phone',
			},
			{
				icon: 'icons8-track-order',
				name: 'Site Check In / Check Out',
				description: 'Validate contractor arrival, departure and wrench time in real time with GPS',
			},
			{
				icon: 'icons8-push-notifications',
				name: 'Real Time Updates',
				description: 'Receive real-time work status updates via the app, email or text',
			},
			{
				icon: 'icons8-estimate',
				name: 'Configurable NTE Controls',
				description: 'Achieve budget goals by configuring ruled-based not-to-exceed cost controls',
			},
		],
		benefits: [
			{
				icon: 'icons8-money-box',
				name: 'Cut Costs',
				description:
					'Reduce total maintenance expenses by eliminating redundant work, securing competitive rates and enforcing not-to-exceed controls',
			},
			{
				icon: 'icons8-time-machine',
				name: 'Save Time',
				description:
					'Spend less time pushing paperwork, calling contractors and crunching spreadsheets',
			},
			{
				icon: 'icons8-good-quality',
				name: 'Improve Service',
				description:
					'Drive improved service levels and contractor performance by creating transparency',
			},
		],
	},
	{
		id: 'am',
		title: 'Asset Management',
		description: 'Seamlessly tie work back to specific equipment and warranties.',
		icon: 'machinery',
		color: 'rgb(52, 85, 159)',
		productRoute: 'asset-management',
		headlineTitle: "Your equipment's life story at your fingertips",
		benefitsTitle: 'How Asset Management Can Help',
		featuresTitle: 'How Asset Management Works',
		headlineDescription:
			"OpenWrench's asset management module allows work to be seamlessly tied to specific equipment, which speeds up troubleshooting and facilitates repair/replace decisions.",
		productMockUrl:
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-landing-page/asset-management-mock.svg',
		benefits: [
			{
				icon: 'icons8-money-box',
				name: 'Save Money',
				description: 'Avoid paying for work that should be covered by warranty',
			},
			{
				icon: 'icons8-time-machine',
				name: 'Shorten Time to Repair',
				description: 'Leverage asset work history to speed up time to diagnosis and repair',
			},
			{
				icon: 'icons8-accuracy',
				name: 'Prevent Errors',
				description: 'Leverage asset tags to ensure the correct piece of equipment is worked on',
			},
			{
				icon: 'icons8-fund-accounting',
				name: 'Reduce TCO',
				description:
					'Understand asset-level maintenance spend and depreciation to make smarter replacement decisions',
			},
		],
		features: [
			{
				icon: 'icons8-track-order',
				name: 'Track Equipment',
				description:
					'Import, create and maintain accurate records of your assets by make, model, serial number and more',
			},
			{
				icon: 'icons8-qr-code',
				name: 'Tag Assets',
				description:
					'Tag assets with QR codes to keep accurate inventories as they move across locations',
			},
			{
				icon: 'icons8-bulldozer',
				name: 'Analyze Equipment Lifecycle',
				description:
					'View asset work history, depreciation and replacement costs to make smarter repair/replace decisions',
			},
			{
				icon: 'icons8-map-pin',
				name: 'Locate Assets',
				description:
					'Associate assets with physical locations to make them easier to find and shorten time-to-repair',
			},
			{
				icon: 'icons8-decrease',
				name: 'Understand Depreciation',
				description:
					"View asset's original purchase price, repair history, life expectancy and replacement cost",
			},
			{
				icon: 'icons8-engineer-symbol',
				name: 'Manage Warranties',
				description: 'Track warranties for your assets to avoid paying for covered work',
			},
			{
				icon: 'icons8-fund-accounting',
				name: 'Budget Against Assets',
				description: 'Configure alerts when repair expenses for assets exceed a preset threshold',
			},
		],
	},
	{
		id: 'pm',
		title: 'Planned Maintenance',
		description: 'Schedule and manage recurring preventative maintenance tasks.',
		icon: 'task-management',
		color: 'rgb(0, 140, 184)',
		productRoute: 'planned-maintenance',
		benefitsTitle: 'Benefits of Implementing Planned Maintenance',
		featuresTitle: 'What Planned Maintenance Does',
		headlineTitle: 'Put your recurring maintenance on autopilot',
		headlineDescription:
			"OpenWrench's planned maintenance module helps FMs deliver consistently great customer experiences by allowing them to schedule and manage recurring preventative maintenance tasks.",
		productMockUrl:
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-landing-page/planned-maintenance-mock.svg',
		benefits: [
			{
				icon: 'icons8-time-machine',
				name: 'Save Time Spent Scheduling',
				description: 'Create maintenance plans to automatically schedule recurring work',
			},
			{
				icon: 'icons8-get-cash',
				name: 'Cut Costs',
				description: 'Avoid costly repairs by staying on top of preventative maintenance',
			},
			{
				icon: 'icons8-lol',
				name: 'Improve Customer Experiences',
				description:
					'Deliver consistently positive customer experiences by keeping facilities clean, safe and comfortable',
			},
			{
				icon: 'icons8-test-passed',
				name: 'Drive Compliance',
				description:
					'Ensure trusted contractors receive and perform recurring maintenance on approved work orders',
			},
			{
				icon: 'icons8-view',
				name: 'Gain Visibility into Spend',
				description: 'Clearly understand upcoming expenses through location-based reports',
			},
		],
		features: [
			{
				icon: 'icons8-schedule',
				name: 'Automatic Scheduling',
				description:
					'Automatically create work orders for recurring work at one or more locations based on custom schedules',
			},
			{
				icon: 'icons8-track-order',
				name: 'Monitor Completion',
				description: 'Track real time completion of work for each location by schedule',
			},
			{
				icon: 'icons8-rescheduling-a-task',
				name: 'Flexible Scheduling',
				description:
					'Easily modify schedules or skip single service events without changing the schedule',
			},
			{
				icon: 'icons8-green-check-mark',
				name: 'Validate Work',
				description:
					'Ensure reported contractor hours and work completion are accurate with GPS check ins and automatic stakeholder feedback',
			},
			{
				icon: 'icons8-online-payment-with-a-credit-card',
				name: 'Automatic Payment',
				description:
					'Automatically generate invoices for the contractor based on agreed rates once the work is done',
			},
		],
	},
	{
		id: 'cm',
		title: 'Contractor Management',
		description: 'Find, hire, and manage qualified, experienced service providers.',
		icon: 'supplierfeatures',
		color: '#4e2991',
		benefitsTitle: 'Why Use Contract Management',
		featuresTitle: 'What Can Contract Management Do For Me',
		productRoute: 'contractor-management',
		headlineTitle: 'Build your maintenance all-star team',
		headlineDescription:
			"OpenWrench's contractor management platform allows FMs to easily find, hire, and manage service providers, ensuring they have the right experience, licenses, certifications and insurance for the job.",
		productMockUrl:
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-landing-page/contractor-management-mock.svg',
		benefits: [
			{
				icon: 'icons8-omnichannel',
				name: 'Expand Your Contractor Network',
				description:
					'Discover reliable contractors with the right skills, licenses and certifications for all your trades and regions',
			},
			{
				icon: 'icons8-time-machine',
				name: 'Save Time',
				description:
					'Spend less time searching for contractors and calling to qualify them -- we make identifying qualified contractors simple',
			},
			{
				icon: 'icons8-diversity',
				name: 'Improve Supplier Diversity',
				description: 'Access thousands of diverse, qualified suppliers on our network',
			},
		],
		features: [
			{
				icon: 'icons8-search-property',
				name: 'Search 50,000 Contractors',
				description:
					'Explore our network of more than 50,000 service providers, filtering by trade, diversity status, location and more',
			},
			{
				icon: 'icons8-worker-2',
				name: 'Source contractors',
				description:
					'Source, qualify and onboard local service providers without picking up the phone',
			},
			{
				icon: 'icons8-test-passed',
				name: 'Manage compliance',
				description:
					'Request, collect and maintain licenses, insurance coverage, W9 and other contractor data',
			},
			{
				icon: 'icons8-popular-topic',
				name: 'Access Peer Feedback',
				description: 'Read reviews from other facility managers before hiring a new contractor',
			},
		],
	},
	{
		id: 'a',
		title: 'Analytics',
		description: 'Use data to identify ways to improve quality of service and cut costs.',
		icon: 'data',
		color: 'rgb(52, 85, 159)',
		productRoute: 'analytics',
		benefitsTitle: 'How Can Analytics Impact My Organization',
		featuresTitle: "What Can OpenWrench's Analytics Do",
		headlineTitle: 'Make your data a competitive advantage',
		headlineDescription:
			"OpenWrench's analytics platform allows FMs to analyze data on maintenance and repair expenses and activity, so they can identify effective ways to improve quality of service and cut costs.",
		productMockUrl:
			'https://s3.amazonaws.com/emptor-data-assets/images/emptor-landing-page/analytics-mock.svg',
		benefits: [
			{
				icon: 'icons8-money-box',
				name: 'Cut Costs',
				description:
					'Turn data on work activity and expenses into actionable insights to reduce costs',
			},
			{
				icon: 'icons8-good-quality',
				name: 'Achieve Best Practices',
				description:
					'Benchmark pricing by trade, by contractor and by location to achieve best practices across locations',
			},
			{
				icon: 'icons8-opera-glasses',
				name: 'Gain Full Visibility',
				description:
					'Access full visibility into key KPIs on contractor performance, service levels and maintenance expenses',
			},
		],
		features: [
			{
				icon: 'icons8-line-chart',
				name: 'Trend Analysis',
				description: 'Visualize your data to identify trends and pinpoint areas for improvement',
			},
			{
				icon: 'icons8-scorecard',
				name: 'Contractor Scorecards',
				description: 'Level set with contractors on service levels using industry standard KPIs',
			},
			{
				icon: 'icons8-view',
				name: 'End-to-end Visibility',
				description: 'Track spend and work activity across all locations, trades, and contractors',
			},
		],
	},
];
export const howEmptorAnalyzeWorks = [
	{
		title: 'Leave your email',
		description: 'Enter your email address to receive a link with onboarding instructions.',
	},
	{
		title: 'Upload your data',
		description:
			'Upload your purchase data file. The process is easy and your data stays safe and secure.',
	},
	{
		title: 'Access your analytics',
		description: 'Within 3 days, access benchmarks, market share and other reports on your spend.',
	},
];

export const emptorAnalyzeFrequentlyAskedQuestions = [
	{
		question: 'What’s the catch?',
		answer: 'There is no catch. Our services spend analytics and reporting app is free.',
	},
	{
		question: 'Why are you doing this?',
		answer:
			"Hospital operating margins recently hit a 10 year low. We think pricing transparency is the only way hospitals can fully take control of their services spend. It’s so important that we believe hospitals shouldn't ever have to pay for these benchmarks.",
	},
	{
		question: 'Is my data safe? You aren’t going to resell it, are you?',
		answer:
			'We take data security extremely seriously. All purchasing data is fully anonymized and encrypted both in transit and at rest using military-grade AES-256 encryption protocols. We will not resell your data. We only share anonymized, aggregated benchmarks.',
	},
	{
		question: 'How much does all this cost?',
		answer:
			'Our open analytics suite is completely free. We think hospitals shouldn’t have to pay to categorize and benchmark their services spend. Switch to Emptor and never pay again.',
	},
	{
		question: 'So what do I have to do to sign up?',
		answer:
			'Share your email address and we will send you an invitation with instructions on how to share your purchasing data and get access for free. It takes us only a few days to categorize and benchmark your spend.',
	},
];

export const genericQuestions = [
	{
		id: 1,
		title: "In a few words, describe what you're looking for.",
		description: '',
		questionType: 'freeText',
	},
	{
		id: 2,
		title: 'Would you like to add a photo?',
		description: '',
		questionType: 'pictureYesNo',
	},
	{
		id: 3,
		title: 'When would you like the service provider?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: [
			'In the next few days',
			'Within a week',
			'As recommended by the pro',
			'Choose date(s)',
		],
	},
	{
		id: 4,
		title: 'Please confirm where you need the services.',
		description: '',
		questionType: 'address',
		width: 240,
		placeholder: 'Zip code',
	},
	{
		id: 5,
		title: 'Where should we send your matches?',
		description: '',
		questionType: 'textbox',
		width: 240,
		placeholder: 'Email address',
	},
];

const questions = [
	{
		id: 1,
		title: 'What service are your interested in?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: [
			'Plumbing Drain Repair',
			'Plumbing Pipe Repair',
			'Plumbing Pipe Installation or Replacement',
			'Emergency Plumbing',
			'Plumbing Inspection',
			'Handyman',
			'Bathroom Remodel',
			'Sink or Faucet Installation or Replacement',
			'General Contracting',
			'Shower and Bathtub Installation or Replacement',
		],
	},
	{
		id: 2,
		title: 'How long has this problem existed?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: [
			'Less than a few hours',
			'A few hours to a day',
			'Two to seven days',
			'More than a week',
		],
	},
	{
		id: 3,
		title: 'What is your emergency plumbing issue?',
		description: 'Select all that apply',
		questionType: 'multipleChoiceMultiSelect',
		multipleChoices: [
			'Leaking or burst pipes or appliances',
			'Failure in heating system',
			'Sewer backup',
			'Flooding',
			'Water heater repair',
			'Faucet malfunctioning',
			'Clogged toilet or drain',
			'Gas line issues',
		],
	},
	{
		id: 4,
		title: 'Where is the issue located?',
		description: '',
		questionType: 'multipleChoiceMultiSelect',
		multipleChoices: [
			'Bathroom',
			'Kitchen',
			'Laundry room',
			'Basement',
			'Garage',
			'Crawl space',
			'Outdoors',
			'Entire building',
			'Other location',
		],
	},
	{
		id: 5,
		title: 'Which appliances or fixtures are affected by the issue?',
		description: 'Optional',
		questionType: 'multipleChoiceMultiSelect',
		multipleChoices: [
			'Toilet',
			'Sink or faucet',
			'Shower or bathtub',
			'Garbage disposal',
			'Dishwasher',
			'Washing machine',
			'Water heater',
			'Other appliance or fixture',
			"Need professional's assessment",
		],
	},
	{
		id: 6,
		title: 'Would you like to add a photo of your plumbing issue?',
		description: '',
		questionType: 'pictureYesNo',
	},
	{
		id: 7,
		title: 'When would you like the plumber?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: [
			'In the next few days',
			'Within a week',
			'As recommended by the pro',
			'Choose date(s)',
		],
	},
	{
		id: 8,
		title: 'Anything else the plumber should know?',
		description: 'Optional',
		questionType: 'freeText',
	},
	{
		id: 9,
		title: 'Please confirm where you need the plumber.',
		description: '',
		questionType: 'address',
		width: 240,
		placeholder: 'Address',
	},
	{
		id: 10,
		title: 'Where should we send your matches?',
		description: '',
		questionType: 'textbox',
		width: 240,
		placeholder: 'Email address',
	},
];

const questions5 = [
	{
		id: 1,
		title: 'What kind of electrical services do you need?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: [
			'Lighting installation',
			'Switch and outlet installation',
			'Fan installation',
			'Switch and outlet repair',
			'Electrical and wiring repair',
		],
	},
	{
		id: 2,
		title: 'What type of electrical and wiring service do you need?',
		description: '',
		questionType: 'multipleChoiceMultiSelect',
		multipleChoices: ['Repair and/or troubleshooting', 'Replacement', 'New installation'],
		hasOther: true,
	},
	{
		id: 3,
		title: 'What electrical or wiring problem do you have?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: [
			'Upgrade wiring, fixture, or equipment',
			'Fixture or outlet not working',
			'Electrical not functioning normally',
			'Loss of power',
			'Inconsistent power',
		],
		hasOther: true,
	},
	{
		id: 4,
		title: 'What kind(s) of fixtures need work?',
		description: '',
		questionType: 'multipleChoiceMultiSelect',
		multipleChoices: [
			'Outlets',
			'Lights',
			'Circuit breaker panel or fuse box',
			'Wiring',
			'Switches',
			'Ceiling fan',
		],
		hasOther: true,
	},
	{
		id: 5,
		title: 'Are the fixtures indoors or outdoors?',
		description: '',
		questionType: 'multipleChoiceMultiSelect',
		multipleChoices: ['Indoors', 'Outdoors'],
	},
	{
		id: 6,
		title: 'Approximately how high is your ceiling?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: [
			'Under 8 feet (low ceiling)',
			'8 - 10 feet (standard ceiling)',
			'10 - 14 feet (high ceiling)',
			'Over 14 feet (lofty ceiling)',
		],
	},
	{
		id: 7,
		title: 'Would you like to add a photo of your electrical and wiring issues?',
		description: '',
		questionType: 'pictureYesNo',
	},
	{
		id: 8,
		title: 'When would you like the electrician to come?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: [
			'In the next few days',
			'Within a week',
			'As recommended by the pro',
			'Choose date(s)',
		],
	},
	{
		id: 9,
		title: 'Anything else the electrician should know?',
		description: 'Optional',
		questionType: 'freeText',
	},
	{
		id: 10,
		title: 'Please confirm where you need the electrician.',
		description: '',
		questionType: 'address',
		width: 240,
		placeholder: 'Address',
	},
	{
		id: 11,
		title: 'Where should we send your matches?',
		description: '',
		questionType: 'textbox',
		width: 240,
		placeholder: 'Email address',
	},
];

const questions4 = [
	{
		id: 1,
		title: 'What air conditioning services do you need?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: ['Repair', 'Routine maintenance'],
	},
	{
		id: 2,
		title: 'What problems are you having with your A/C unit?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: [
			'Only warm air is blowing from the vents',
			"Unit won't turn on or off",
			"The power is on, but the fan won't run",
			'No problem, just need maintenance',
			'My AC unit is frozen',
		],
	},
	{
		id: 3,
		title: 'When did this problem start?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: ['Less than a week ago', 'A few weeks ago', 'Over a month ago'],
	},
	{
		id: 4,
		title: 'Is your system electric or gas powered?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: ['Electric (most common)', 'Gas', "I'm not sure"],
	},
	{
		id: 5,
		title: 'What is the make and model of your air conditioning system?',
		description: 'Optional',
		questionType: 'textbox',
		width: 360,
		placeholder: 'Please enter A/C make and model',
	},
	{
		id: 6,
		title: 'Where is the air handler located?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: ['Basement', 'Attic', 'Closet', 'Outside', 'Garage'],
		hasOther: true,
	},
	{
		id: 7,
		title: 'Where is the condenser and fan located?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: ['Ground floor', 'Roof', 'Outside'],
		hasOther: true,
	},
	{
		id: 8,
		title: 'Would you like to add a photo of your A/C unit?',
		description: '',
		questionType: 'pictureYesNo',
	},
	{
		id: 9,
		title: 'When would you like the HVAC technician to come?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: [
			'In the next few days',
			'Within a week',
			'As recommended by the pro',
			'Choose date(s)',
		],
	},
	{
		id: 10,
		title: 'When would you like the HVAC technician to come?',
		description: 'Select all the times that work for you.',
		questionType: 'multipleChoiceMultiSelect',
		multipleChoices: [
			'Early Morning (before 9 a.m.)',
			'Morning (9 a.m. - 12 p.m.)',
			'Afternoon (12 p.m. - 3 p.m.)',
			'Late Afternoon (3 p.m. - 6 p.m.)',
			'Evening (after 6pm)',
		],
	},
	{
		id: 11,
		title: 'Anything else the HVAC technician should know?',
		description: 'Optional',
		questionType: 'freeText',
	},
	{
		id: 12,
		title: 'Please confirm where you need the HVAC technician.',
		description: '',
		questionType: 'address',
		width: 240,
		placeholder: 'Address',
	},
	{
		id: 13,
		title: 'Where should we send your matches?',
		description: '',
		questionType: 'textbox',
		width: 240,
		placeholder: 'Email address',
	},
];
const questions3 = [
	{
		id: 1,
		title: 'What type of property would you like cleaned?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: [
			'Office',
			'Retail',
			'Medical facility',
			'Restaurant',
			'School or place of worship',
			'Apartment building',
			'Lab',
			'Factory',
			'Warehouse',
		],
	},
	{
		id: 2,
		title: 'How often would you like cleaning services?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: ['One time only', 'Once a week', 'Every other week', 'Once a month'],
	},
	{
		id: 3,
		title: 'What is the approximate square footage of the area to be cleaned?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: [
			'Less than 1,000 sq ft',
			'1,000-2,000 sq ft',
			'2,000-3,000 sq ft',
			'3,000-4,000 sq ft',
			'4,000-5,000 sq ft',
			'6,000-10,000 sq ft',
			'More than 10,000 sq ft',
		],
	},
	{
		id: 4,
		title: 'How many windows would you like cleaned?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: [
			'No windows',
			'1-5 windows',
			'6-10 windows',
			'11-15 windows',
			'16-20 windows',
			'21-25 windows',
			'More than 25 windows',
		],
	},
	{
		id: 5,
		title: 'Would you like to add a photo of the major areas you need cleaned?',
		description: '',
		questionType: 'pictureYesNo',
	},
	{
		id: 6,
		title: 'When do you need this service?',
		description: 'Select all the times that work for you.',
		questionType: 'multipleChoiceMultiSelect',
		multipleChoices: [
			'Weekday mornings',
			'Weekday afternoons',
			'Weekday evenings',
			'Saturday/Sunday',
		],
	},
	{
		id: 7,
		title: 'Anything else the cleaners should know?',
		description: 'Optional',
		questionType: 'freeText',
	},
	{
		id: 8,
		title: 'Please confirm where you need the cleaners.',
		description: '',
		questionType: 'address',
		width: 240,
		placeholder: 'Address',
	},
	{
		id: 9,
		title: 'Where should we send your matches?',
		description: '',
		questionType: 'textbox',
		width: 240,
		placeholder: 'Email address',
	},
];

const questions2 = [
	{
		id: 1,
		title: 'What service are you interested in?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: ['Lawn Mowing and Trimming', 'Multi Service Lawn Care'],
	},
	{
		id: 2,
		title: 'How often would you like lawn care services?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: ['One time only', 'Once a week', 'Every other week', 'Once a month'],
	},
	{
		id: 3,
		title: 'How big is the lawn?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: [
			'Small (less than 1,000 sq ft)',
			'Medium (1,000-5,000 sq ft)',
			'Large (5,000-10,000 sq ft)',
			'Huge (more than 10,000 sq ft)',
		],
	},
	{
		id: 4,
		title: 'What services do you need?',
		description: 'Select all that apply',
		questionType: 'multipleChoiceMultiSelect',
		multipleChoices: [
			'Mowing, trimming and edging',
			'Leaf clean-up',
			'Weeding and prevention',
			'Fertilizer application',
			'Seeding or overseeding',
			'Insect control',
			'Aeration',
		],
	},
	{
		id: 5,
		title: 'How long is the grass?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: ['Standard grass (under 6 inches)', 'Tall grass (6 to 12 inches)'],
	},
	{
		id: 6,
		title: 'When did you last have yard work done?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: ['Less than a week ago', '2-3 weeks ago', 'Over a month ago'],
	},
	{
		id: 7,
		title: 'Do you need to be on site while the lawn professional is working?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: ["No, I don't need to be there", 'Yes, I must be present'],
	},
	{
		id: 8,
		title: 'Would you like to add a photo of your lawn?',
		description: '',
		questionType: 'pictureYesNo',
	},
	{
		id: 9,
		title: 'When would you like the lawn professional?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: [
			'In the next few days',
			'Within a week',
			'As recommended by the pro',
			'Choose date(s)',
		],
	},
	{
		id: 10,
		title: 'When would you like the lawn professional?',
		description: '',
		questionType: 'multipleChoice',
		multipleChoices: [
			'Early Morning (before 9 a.m.)',
			'Morning (9 a.m. - 12 p.m.)',
			'Afternoon (12 p.m. - 3 p.m.)',
			'Late Afternoon (3 p.m. - 6 p.m.)',
			'Evening (after 6pm)',
		],
	},
	{
		id: 11,
		title: 'Anything else the lawn professional should know?',
		description: 'Optional',
		questionType: 'freeText',
	},

	{
		id: 12,
		title: 'Please confirm where you need the lawn professional.',
		description: '',
		questionType: 'address',
		width: 240,
		placeholder: 'Address',
	},
	{
		id: 13,
		title: 'Where should we send your matches?',
		description: '',
		questionType: 'textbox',
		width: 240,
		placeholder: 'Email address',
	},
];

export const questionsMap = {
	20: questions3,
	17: questions4,
	157: questions,
	159: questions5,
	29: questions2,
};

export const rate_cards = [
	{
		id: 1,
		name: 'Eastern U.S. Lab Temps',
		description: 'Hourly rates for technical temps for East Coast laboratories',
	},
];

export const resource_roles = [
	{
		id: 1,
		name: 'Medical Laboratory Assistant',
		description: 'Job description or other details go here',
		rate_card_id: 1,
	},
	{
		id: 2,
		name: 'Medical Laboratory Technician',
		description: 'Job description or other details go here',
		rate_card_id: 1,
	},
	{
		id: 3,
		name: 'Phlebotomist',
		description: 'Job description or other details go here',
		rate_card_id: 1,
	},
	{
		id: 4,
		name: 'Renal Technician',
		description: 'Job description or other details go here',
		rate_card_id: 1,
	},
	{
		id: 5,
		name: 'Cytology Technician',
		description: 'Job description or other details go here',
		rate_card_id: 1,
	},
	{
		id: 6,
		name: 'Blood Bank Technician',
		description: 'Job description or other details go here',
		rate_card_id: 1,
	},
];

export const rates = [
	{
		id: 1,
		unit_price: 55.5,
		luom_id: 1,
		role_id: 1,
	},
	{
		id: 2,
		unit_price: 35.5,
		luom_id: 1,
		role_id: 2,
	},
	{
		id: 3,
		unit_price: 45.5,
		luom_id: 1,
		role_id: 3,
	},
	{
		id: 4,
		unit_price: 65.5,
		luom_id: 1,
		role_id: 4,
	},
	{
		id: 5,
		unit_price: 75.5,
		luom_id: 1,
		role_id: 5,
	},
	{
		id: 6,
		unit_price: 35.5,
		luom_id: 1,
		role_id: 6,
	},
];

export const uoms = [
	{
		id: 1,
		name: 'hour',
		displayNameSingular: 'hour',
		displayNamePlural: 'hours',
		uomConversionFactor: [
			{
				uomId: 3,
				factor: 60.0,
			},
		],
		description:
			'a period of time equal to a twenty-fourth part of a day and night and divided into 60 minutes',
	},
	{
		id: 2,
		name: 'minute',
		displayNameSingular: 'minute',
		displayNamePlural: 'minutes',
		uomConversionFactor: [
			{
				uomId: 3,
				factor: 60.0,
			},
		],
		description: 'a period of time equal to sixty seconds or a sixtieth of an hour',
	},
	{
		id: 3,
		name: 'second',
		displayNameSingular: 'second',
		displayNamePlural: 'seconds',
		uomConversionFactor: [],
		description:
			'a sixtieth of a minute of time, which as the SI unit of time is defined in terms of the natural periodicity of the radiation of a cesium-133 atom',
	},
	{
		id: 4,
		name: 'day',
		displayNameSingular: 'day',
		displayNamePlural: 'days',
		uomConversionFactor: [
			{
				uomId: 1,
				factor: 24.0,
			},
		],
		description:
			'a period of twenty-four hours as a unit of time, reckoned from one midnight to the next, corresponding to a rotation of the earth on its axis',
	},
	{
		id: 5,
		name: 'each',
		displayNameSingular: 'each',
		displayNamePlural: 'eaches',
		uomConversionFactor: [],
		description: 'the smallest unit by which something is consumed',
	},
	{
		id: 6,
		name: 'box',
		displayNameSingular: 'box',
		displayNamePlural: 'boxes',
		uomConversionFactor: [],
		description: 'a packaged unit',
	},
];

export const oldUoms = [
	{
		id: 1,
		name: 'each',
		description: 'each',
	},
	{
		id: 2,
		name: 'hour',
		description: 'hour',
	},
	{
		id: 3,
		name: 'day',
		description: 'day',
	},
	{
		id: 4,
		name: 'box',
		description: 'box',
	},
];

export const rate_card = {};

export const rate = {};

export const resource = {};

export const sourcingEventFormData = {
	biddingStatus: 'draft',
	title: 'ICD 10 Training',
	description:
		'Understand ICD-10 coding from code books for ICD-10-CM or PCS to simplify medical billing and coding process.',
	eventType: 'rfp',
	ndaRequired: true,
	currencyId: 'USD',
	biddingDates: ['2018-01-11T22:21:11.711Z', '2018-01-27T22:21:11.711Z'],
	targetAwardDate: '2018-01-24T22:21:19.868Z',
	quietPeriodDates: ['2018-01-18T22:21:11.719Z', '2018-01-27T22:21:11.719Z'],
	internalTeam: [
		{
			sourcing_event_id: '',
			contact_email: 'Dallin61@yahoo.com',
			contact: {
				id: 0,
				email: 'Dallin61@yahoo.com',
				phone_work: '(476) 456-2257',
				phone_mobile: '1-981-002-7337 x693',
				job_title: 'National Division Engineer',
				company_id: 1,
				fax: '1-741-940-0589',
				name_suffix: '',
				name_given: 'Austen',
				name_family: 'Lind',
				name_additional: '',
				photo_link: 'https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png',
				notes: '',
				created_at: '2017-06-02T04:45:36.376Z',
				updated_at: '2017-12-04T05:32:53.021Z',
				key: 0,
				name: 'Lind Austen',
			},
			event_role: 'watcher',
			supplier_id: '',
			is_nda_signed: false,
		},
		{
			sourcing_event_id: '',
			contact_email: 'Clarabelle.Padberg@yahoo.com',
			contact: {
				id: 2,
				email: 'Clarabelle.Padberg@yahoo.com',
				phone_work: '620.558.7558',
				phone_mobile: '1-970-560-3445 x66845',
				job_title: 'Future Program Specialist',
				company_id: 1,
				fax: '1-044-865-0868 x4660',
				name_given: 'Reina',
				name_family: 'Schumm',
				name_additional: '',
				photo_link: 'https://gw.alipayobjects.com/zos/rmsportal/gaOngJwsRYRaVAuXXcmB.png',
				notes: '',
				created_at: '2017-11-06T06:57:03.575Z',
				updated_at: '2017-09-06T00:38:22.435Z',
				key: 2,
				name: 'Schumm Reina',
			},
			event_role: 'owner',
			supplier_id: '',
			is_nda_signed: false,
		},
	],
	bidders: [
		{
			sourcing_event_id: '',
			supplier_id: 1,
			status: 'noResponse',
			score_card_id: null,
			questionnaire_id: null,
			supplier: {
				id: 1,
				name: 'Versiti',
				display_name: 'Versiti',
				status: 'active',
				duns: null,
				tax_id: null,
				corporate_url: 'https://www.versiti.org/',
				storefront_url: null,
				po_method: null,
				po_change_method: null,
				po_email: null,
				website: 'https://www.versiti.org/',
				logo_url: 'https://s3.amazonaws.com/mock-data-assets/suppliers/images/versiti.png',
				parent: null,
				primary_contact_email: 'christopher.plautz@versiti.org',
				primary_address: '638 N 18th St, Milwaukee, WI 53233',
				remit_to_address: '638 N 18th St, Milwaukee, WI 53233',
				key: 1,
			},
		},
		{
			sourcing_event_id: '',
			supplier_id: 2,
			status: 'noResponse',
			score_card_id: null,
			questionnaire_id: null,
			supplier: {
				id: 2,
				name: 'Lenco Diagnostic Laboratory',
				display_name: 'Lenco Diagnostic Laboratory',
				status: 'active',
				duns: null,
				tax_id: null,
				corporate_url: 'http://www.lencolab.com/',
				storefront_url: null,
				po_method: null,
				po_change_method: null,
				po_email: null,
				website: 'http://www.lencolab.com/',
				logo_url: 'https://s3.amazonaws.com/mock-data-assets/suppliers/images/lenco.gif',
				parent: null,
				primary_contact_email: 'info@lencolab.com',
				primary_address: '1857 86th St, Brooklyn NY 11214',
				remit_to_address: '1857 86th St, Brooklyn NY 11214',
				key: 2,
			},
		},
		{
			sourcing_event_id: '',
			supplier_id: 3,
			status: 'noResponse',
			score_card_id: null,
			questionnaire_id: null,
			supplier: {
				id: 3,
				name: 'Sysmex',
				display_name: 'Sysmex',
				status: 'active',
				duns: null,
				tax_id: null,
				corporate_url: 'https://www.sysmex.com/us/en/Pages/default.aspx',
				storefront_url: null,
				po_method: null,
				po_change_method: null,
				po_email: null,
				website: 'https://www.sysmex.com/us/en/Pages/default.aspx',
				logo_url: 'https://s3.amazonaws.com/mock-data-assets/suppliers/images/sysmex.jpg',
				parent: null,
				primary_contact_email: 'communications@sysmex.com',
				primary_address: '577 Aptakisic Rd, Lincolnshire, IL 60069',
				remit_to_address: '577 Aptakisic Rd, Lincolnshire, IL 60069',
				key: 3,
			},
		},
		{
			sourcing_event_id: '',
			supplier_id: 4,
			status: 'noResponse',
			score_card_id: null,
			questionnaire_id: null,
			supplier: {
				id: 4,
				name: 'Miraca Life Sciences',
				display_name: 'Miraca Life Sciences',
				status: 'active',
				duns: null,
				tax_id: null,
				corporate_url: 'http://www.miracalifesciences.com',
				storefront_url: null,
				po_method: null,
				po_change_method: null,
				po_email: null,
				website: 'http://www.miracalifesciences.com',
				logo_url: 'https://s3.amazonaws.com/mock-data-assets/suppliers/images/miraca.gif',
				parent: null,
				primary_contact_email: 'jjennings@miracals.com',
				primary_address: '6655 N MacArthur Blvd, Irving, TX 75039',
				remit_to_address: '6655 N MacArthur Blvd, Irving, TX 75039',
				key: 4,
			},
		},
		{
			sourcing_event_id: '',
			supplier_id: 5,
			status: 'noResponse',
			score_card_id: null,
			questionnaire_id: null,
			supplier: {
				id: 5,
				name: 'Cleveland Clinic',
				display_name: 'Cleveland Clinic',
				status: 'active',
				duns: null,
				tax_id: null,
				corporate_url: 'https://www.clevelandclinic.org/',
				storefront_url: null,
				po_method: null,
				po_change_method: null,
				po_email: null,
				website: 'https://www.clevelandclinic.org/',
				logo_url:
					'https://s3.amazonaws.com/mock-data-assets/suppliers/images/Cleveland-Clinic.jpeg',
				parent: null,
				primary_contact_email: 'info@clevelandclinic.org',
				primary_address: '638 N 18th St, Milwaukee, WI 53233',
				remit_to_address: '638 N 18th St, Milwaukee, WI 53233',
				key: 5,
			},
		},
	],
	questionKeys: [0],
	questions0: {},
	'questions-0-choiceKeys': [],
	questions1: {},
	'questions-1-choiceKeys': [],
	'questions-0-title': 'asdf',
	'questions-0-description': 'sdf',
	'questions-0-type': 'yesNo',
	lineItemKeys: [0, 1],
	performanceMilestoneKeys: [0, 1],
	scheduleMilestoneKeys: [0, 1],
	rateCardKeys: [0],
	'rateCards-0-resourceKeys': [0, 1],
	pricingModel: 'lumpSum',
	scoringCriterionKeys: [0],
	scoringCriteria: [
		{
			weight: '2',
			name: 'sdf',
			description: 'hdfg',
		},
	],
};

const staticContacts = [
	{
		id: 0,
		email: 'Marianna.Schulist14@gmail.com',
		phone_work: '241-331-8334',
		phone_mobile: '(680) 771-0815 x3301',
		job_title: 'Investor Factors Associate',
		company_id: 1,
		fax: '1-688-811-1959 x6975',
		name_prefix: 'Dr.',
		name_suffix: '',
		name_given: 'Lucius',
		name_family: 'Barton',
		name_additional: '',
		photo_link: 'https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png',
		notes: '',
		created_at: '2017-09-08T11:20:22.837Z',
		updated_at: '2018-01-10T15:53:37.757Z',
	},
	{
		id: 1,
		email: 'Ahmad.Reilly84@hotmail.com',
		phone_work: '301.620.0868',
		phone_mobile: '629-999-6568',
		job_title: 'Chief Configuration Manager',
		company_id: 1,
		fax: '528.596.2976',
		name_prefix: 'Ms.',
		name_suffix: '',
		name_given: 'Fay',
		name_family: 'Schultz',
		name_additional: '',
		photo_link: 'https://gw.alipayobjects.com/zos/rmsportal/cnrhVkzwxjPwAaCfPbdc.png',
		notes: '',
		created_at: '2017-02-13T13:06:41.260Z',
		updated_at: '2017-02-28T18:34:40.307Z',
	},
	{
		id: 2,
		email: 'Reggie_Bartell@gmail.com',
		phone_work: '534-926-7023 x91770',
		phone_mobile: '958-012-5666',
		job_title: 'Internal Mobility Agent',
		company_id: 1,
		fax: '709-483-7567 x010',
		name_prefix: 'Miss',
		name_suffix: '',
		name_given: 'Lori',
		name_family: 'Jacobi',
		name_additional: '',
		photo_link: 'https://gw.alipayobjects.com/zos/rmsportal/gaOngJwsRYRaVAuXXcmB.png',
		notes: '',
		created_at: '2017-09-18T18:12:29.961Z',
		updated_at: '2017-08-08T16:27:37.387Z',
	},
	{
		id: 3,
		email: 'Anjali_Schowalter@gmail.com',
		phone_work: '1-637-246-7897',
		phone_mobile: '710.814.2196 x0950',
		job_title: 'District Tactics Engineer',
		company_id: 1,
		fax: '1-377-849-2813 x267',
		name_prefix: 'Miss',
		name_suffix: '',
		name_given: 'Murray',
		name_family: 'Medhurst',
		name_additional: '',
		photo_link: 'https://gw.alipayobjects.com/zos/rmsportal/ubnKSIfAJTxIgXOKlciN.png',
		notes: '',
		created_at: '2017-10-24T19:19:30.739Z',
		updated_at: '2017-09-15T22:17:53.546Z',
	},
	{
		id: 4,
		email: 'Robbie_Graham27@hotmail.com',
		phone_work: '868.180.8477 x4195',
		phone_mobile: '(172) 725-4493 x847',
		job_title: 'Forward Security Facilitator',
		company_id: 1,
		fax: '(239) 253-5039 x615',
		name_prefix: 'Miss',
		name_suffix: '',
		name_given: 'Dawson',
		name_family: 'Ullrich',
		name_additional: '',
		photo_link: 'https://gw.alipayobjects.com/zos/rmsportal/WhxKECPNujWoWEFNdnJE.png',
		notes: '',
		created_at: '2017-09-26T02:44:16.776Z',
		updated_at: '2017-01-25T17:48:43.416Z',
	},
	{
		id: 5,
		email: 'Vesta_Tromp@yahoo.com',
		phone_work: '(066) 116-2837 x3729',
		phone_mobile: '1-616-432-9098 x94951',
		job_title: 'Global Marketing Liaison',
		company_id: 1,
		fax: '161.281.8098',
		name_prefix: 'Mrs.',
		name_suffix: '',
		name_given: 'Gregory',
		name_family: 'Effertz',
		name_additional: '',
		photo_link: 'https://gw.alipayobjects.com/zos/rmsportal/jZUIxmJycoymBprLOUbT.png',
		notes: '',
		created_at: '2017-01-23T22:06:42.366Z',
		updated_at: '2017-10-11T02:56:35.673Z',
	},
	{
		id: 6,
		email: 'Kacie53@hotmail.com',
		phone_work: '061-946-7405 x722',
		phone_mobile: '1-632-391-2756 x036',
		job_title: 'Product Operations Facilitator',
		company_id: 1,
		fax: '1-402-699-4755 x8351',
		name_prefix: 'Dr.',
		name_suffix: '',
		name_given: 'Humberto',
		name_family: 'Rippin',
		name_additional: '',
		photo_link: 'https://gw.alipayobjects.com/zos/rmsportal/psOgztMplJMGpVEqfcgF.png',
		notes: '',
		created_at: '2017-05-02T20:42:10.392Z',
		updated_at: '2017-11-09T12:55:15.598Z',
	},
	{
		id: 7,
		email: 'Nettie.Strosin72@hotmail.com',
		phone_work: '(157) 225-2760',
		phone_mobile: '225.543.0204',
		job_title: 'Global Data Representative',
		company_id: 1,
		fax: '(159) 907-7122 x36991',
		name_prefix: 'Mrs.',
		name_suffix: '',
		name_given: 'Lela',
		name_family: 'Brown',
		name_additional: '',
		photo_link: 'https://gw.alipayobjects.com/zos/rmsportal/ZpBqSxLxVEXfcUNoPKrz.png',
		notes: '',
		created_at: '2017-10-30T09:49:52.745Z',
		updated_at: '2017-07-07T21:16:56.769Z',
	},
	{
		id: 8,
		email: 'Fabiola.Gottlieb@yahoo.com',
		phone_work: '1-993-465-4466',
		phone_mobile: '781.423.6563 x7710',
		job_title: 'International Infrastructure Representative',
		company_id: 1,
		fax: '(387) 696-1809 x5414',
		name_prefix: 'Mrs.',
		name_suffix: '',
		name_given: 'Dan',
		name_family: 'Ruecker',
		name_additional: '',
		photo_link: 'https://gw.alipayobjects.com/zos/rmsportal/laiEnJdGHVOhJrUShBaJ.png',
		notes: '',
		created_at: '2017-09-01T21:39:05.312Z',
		updated_at: '2018-01-09T11:29:03.570Z',
	},
	{
		id: 9,
		email: 'Jayne36@gmail.com',
		phone_work: '(231) 290-4871',
		phone_mobile: '1-177-458-3720',
		job_title: 'Internal Factors Coordinator',
		company_id: 1,
		fax: '710-264-6950 x855',
		name_prefix: 'Mrs.',
		name_suffix: '',
		name_given: 'Ottis',
		name_family: 'Schoen',
		name_additional: '',
		photo_link: 'https://gw.alipayobjects.com/zos/rmsportal/UrQsqscbKEpNuJcvBZBu.png',
		notes: '',
		created_at: '2017-10-07T17:43:43.480Z',
		updated_at: '2017-01-16T04:55:56.678Z',
	},
];
